webpackJsonp([1],[
/* 0 */,
/* 1 */,
/* 2 */,
/* 3 */,
/* 4 */,
/* 5 */,
/* 6 */,
/* 7 */,
/* 8 */,
/* 9 */,
/* 10 */,
/* 11 */,
/* 12 */,
/* 13 */,
/* 14 */,
/* 15 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Grid_vue__ = __webpack_require__(667);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_dd834028_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_Grid_vue__ = __webpack_require__(819);
var normalizeComponent = __webpack_require__(4)
/* script */

/* template */

/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Grid_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_dd834028_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_Grid_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 16 */,
/* 17 */,
/* 18 */,
/* 19 */,
/* 20 */,
/* 21 */,
/* 22 */,
/* 23 */,
/* 24 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_BaseFilter_vue__ = __webpack_require__(868);
var normalizeComponent = __webpack_require__(4)
/* script */

/* template */
var __vue_template__ = null
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_BaseFilter_vue__["a" /* default */],
  __vue_template__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 25 */,
/* 26 */,
/* 27 */,
/* 28 */,
/* 29 */,
/* 30 */,
/* 31 */,
/* 32 */,
/* 33 */,
/* 34 */,
/* 35 */,
/* 36 */,
/* 37 */,
/* 38 */,
/* 39 */,
/* 40 */,
/* 41 */,
/* 42 */,
/* 43 */,
/* 44 */,
/* 45 */,
/* 46 */,
/* 47 */,
/* 48 */,
/* 49 */,
/* 50 */,
/* 51 */,
/* 52 */,
/* 53 */,
/* 54 */,
/* 55 */,
/* 56 */,
/* 57 */,
/* 58 */,
/* 59 */,
/* 60 */,
/* 61 */,
/* 62 */,
/* 63 */,
/* 64 */,
/* 65 */,
/* 66 */,
/* 67 */,
/* 68 */,
/* 69 */,
/* 70 */,
/* 71 */,
/* 72 */,
/* 73 */,
/* 74 */,
/* 75 */,
/* 76 */,
/* 77 */,
/* 78 */,
/* 79 */,
/* 80 */,
/* 81 */,
/* 82 */,
/* 83 */,
/* 84 */,
/* 85 */,
/* 86 */,
/* 87 */,
/* 88 */,
/* 89 */,
/* 90 */,
/* 91 */,
/* 92 */,
/* 93 */,
/* 94 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__(588);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__containers_Full__ = __webpack_require__(589);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__views_Dashboard__ = __webpack_require__(821);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__views_pages_Page404__ = __webpack_require__(830);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__views_pages_Page500__ = __webpack_require__(833);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__views_pages_Login__ = __webpack_require__(836);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__views_pages_Forgot__ = __webpack_require__(839);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__views_pages_ResetPassword__ = __webpack_require__(842);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__views_users_UsersGrid__ = __webpack_require__(845);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__views_users_UsersEdit__ = __webpack_require__(848);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__views_users_Profile__ = __webpack_require__(854);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__views_roles_grid__ = __webpack_require__(857);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__views_roles_edit__ = __webpack_require__(860);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__views_statistics_Statistics__ = __webpack_require__(863);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__views_sellin_Statistics__ = __webpack_require__(912);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__views_stars_oportunity__ = __webpack_require__(930);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__views_stars_oportunity_self__ = __webpack_require__(933);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__views_nifsexcluidos_nifsexcluidos__ = __webpack_require__(936);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__views_operators_operatorsGrid__ = __webpack_require__(939);




























__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

var usersRoutes = {
  path: '/users',
  redirect: '/users/index',
  name: 'users',
  meta: {
    auth: {
      redirect: {
        name: 'users.index'
      },
      forbiddenRedirect: '/dashboard'
    },
    label: 'Utilizadores'
  },
  component: {
    render: function render(c) {
      return c('router-view');
    }
  },
  children: [{
    path: 'index',
    name: 'users.index',
    component: __WEBPACK_IMPORTED_MODULE_9__views_users_UsersGrid__["a" /* default */],
    meta: {
      auth: true,
      label: 'Lista'
    }
  }, {
    path: 'create',
    name: 'users.create',
    component: __WEBPACK_IMPORTED_MODULE_10__views_users_UsersEdit__["a" /* default */],
    meta: {
      auth: true,
      label: 'Criar'
    }
  }, {
    path: 'edit/:id',
    name: 'users.edit',
    component: __WEBPACK_IMPORTED_MODULE_10__views_users_UsersEdit__["a" /* default */],
    meta: {
      auth: true,
      label: 'Editar'
    }
  }]
};

var rolesRoutes = {
  path: '/roles',
  redirect: '/roles/index',
  name: 'roles',
  meta: {
    auth: {
      redirect: {
        name: 'roles.index'
      },
      forbiddenRedirect: '/dashboard'
    },
    label: 'Utilizadores'
  },
  component: {
    render: function render(c) {
      return c('router-view');
    }
  },
  children: [{
    path: 'index',
    name: 'roles.index',
    component: __WEBPACK_IMPORTED_MODULE_12__views_roles_grid__["a" /* default */],
    meta: {
      auth: true,
      label: 'Lista'
    }
  }, {
    path: 'create',
    name: 'roles.create',
    component: __WEBPACK_IMPORTED_MODULE_13__views_roles_edit__["a" /* default */],
    meta: {
      auth: true,
      label: 'Criar'
    }
  }, {
    path: 'edit/:id',
    name: 'roles.edit',
    component: __WEBPACK_IMPORTED_MODULE_13__views_roles_edit__["a" /* default */],
    meta: {
      auth: true,
      label: 'Editar'
    }
  }]
};

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
  mode: 'hash',
  linkActiveClass: 'active',
  scrollBehavior: function scrollBehavior() {
    return {
      y: 0
    };
  },
  routes: [{
    path: '/',
    redirect: '/dashboard',
    name: 'Home',
    component: __WEBPACK_IMPORTED_MODULE_2__containers_Full__["a" /* default */],
    children: [{
      path: 'dashboard',
      name: 'dashboard',
      component: __WEBPACK_IMPORTED_MODULE_3__views_Dashboard__["a" /* default */],
      meta: {
        auth: true
      }
    }, {
      path: 'oportunity',
      name: 'oportunity',
      component: __WEBPACK_IMPORTED_MODULE_16__views_stars_oportunity__["a" /* default */],
      meta: {
        auth: true
      }
    }, {
      path: 'oportunity-self',
      name: 'oportunity-self',
      component: __WEBPACK_IMPORTED_MODULE_17__views_stars_oportunity_self__["a" /* default */],
      meta: {
        auth: true
      }
    }, {
      path: 'nifs-excluidos',
      name: 'nifs-excluidos',
      component: __WEBPACK_IMPORTED_MODULE_18__views_nifsexcluidos_nifsexcluidos__["a" /* default */],
      meta: {
        auth: true
      }
    }, {
      path: 'operators',
      name: 'operators',
      component: __WEBPACK_IMPORTED_MODULE_19__views_operators_operatorsGrid__["a" /* default */],
      meta: {
        auth: true
      }
    }, {
      path: 'profile',
      name: 'profile',
      component: __WEBPACK_IMPORTED_MODULE_11__views_users_Profile__["a" /* default */],
      meta: {
        auth: true
      }
    }, {
      path: '/statistics',
      redirect: '/statistics/index',
      name: 'statistics',
      meta: {
        auth: true,
        label: 'DIM'
      },
      component: {
        render: function render(c) {
          return c('router-view');
        }
      },
      children: [{
        path: ':id',
        name: 'statistics.index',
        component: __WEBPACK_IMPORTED_MODULE_14__views_statistics_Statistics__["a" /* default */],
        meta: {
          auth: true,
          label: 'Lista'
        }
      }]
    }, {
      path: '/sellin',
      redirect: '/sellin/index',
      name: 'sellin',
      meta: {
        auth: true,
        label: 'DIM'
      },
      component: {
        render: function render(c) {
          return c('router-view');
        }
      },
      children: [{
        path: ':id',
        name: 'sellin.index',
        component: __WEBPACK_IMPORTED_MODULE_15__views_sellin_Statistics__["a" /* default */],
        meta: {
          auth: true,
          label: 'Lista'
        }
      }]
    }, usersRoutes, rolesRoutes]
  }, {
    path: '/login',
    name: 'login',
    component: __WEBPACK_IMPORTED_MODULE_6__views_pages_Login__["a" /* default */]
  }, {
    path: '/forgot-password',
    name: 'forgot-password',
    component: __WEBPACK_IMPORTED_MODULE_7__views_pages_Forgot__["a" /* default */]
  }, {
    path: '/reset-password/:token',
    name: 'reset-password',
    component: __WEBPACK_IMPORTED_MODULE_8__views_pages_ResetPassword__["a" /* default */]
  }, {
    path: '/404',
    name: '404 Not Found',
    component: __WEBPACK_IMPORTED_MODULE_4__views_pages_Page404__["a" /* default */]
  }, {
    path: '/500',
    name: '500 Internal error',
    component: __WEBPACK_IMPORTED_MODULE_5__views_pages_Page500__["a" /* default */]
  }]
}));

/***/ }),
/* 95 */,
/* 96 */,
/* 97 */,
/* 98 */,
/* 99 */,
/* 100 */,
/* 101 */,
/* 102 */,
/* 103 */,
/* 104 */,
/* 105 */,
/* 106 */,
/* 107 */,
/* 108 */,
/* 109 */,
/* 110 */,
/* 111 */,
/* 112 */,
/* 113 */,
/* 114 */,
/* 115 */,
/* 116 */,
/* 117 */,
/* 118 */,
/* 119 */,
/* 120 */,
/* 121 */,
/* 122 */,
/* 123 */,
/* 124 */,
/* 125 */,
/* 126 */,
/* 127 */,
/* 128 */,
/* 129 */,
/* 130 */,
/* 131 */,
/* 132 */,
/* 133 */,
/* 134 */,
/* 135 */,
/* 136 */,
/* 137 */,
/* 138 */,
/* 139 */,
/* 140 */,
/* 141 */,
/* 142 */,
/* 143 */,
/* 144 */,
/* 145 */,
/* 146 */,
/* 147 */,
/* 148 */,
/* 149 */,
/* 150 */,
/* 151 */,
/* 152 */,
/* 153 */,
/* 154 */,
/* 155 */,
/* 156 */,
/* 157 */,
/* 158 */,
/* 159 */,
/* 160 */,
/* 161 */,
/* 162 */,
/* 163 */,
/* 164 */,
/* 165 */,
/* 166 */,
/* 167 */,
/* 168 */,
/* 169 */,
/* 170 */,
/* 171 */,
/* 172 */,
/* 173 */,
/* 174 */,
/* 175 */,
/* 176 */,
/* 177 */,
/* 178 */,
/* 179 */,
/* 180 */,
/* 181 */,
/* 182 */,
/* 183 */,
/* 184 */,
/* 185 */,
/* 186 */,
/* 187 */,
/* 188 */,
/* 189 */,
/* 190 */,
/* 191 */,
/* 192 */,
/* 193 */,
/* 194 */,
/* 195 */,
/* 196 */,
/* 197 */,
/* 198 */,
/* 199 */,
/* 200 */,
/* 201 */,
/* 202 */,
/* 203 */,
/* 204 */,
/* 205 */,
/* 206 */,
/* 207 */,
/* 208 */,
/* 209 */,
/* 210 */,
/* 211 */,
/* 212 */,
/* 213 */,
/* 214 */,
/* 215 */,
/* 216 */,
/* 217 */,
/* 218 */,
/* 219 */,
/* 220 */,
/* 221 */,
/* 222 */,
/* 223 */,
/* 224 */,
/* 225 */,
/* 226 */,
/* 227 */,
/* 228 */,
/* 229 */,
/* 230 */,
/* 231 */,
/* 232 */,
/* 233 */,
/* 234 */,
/* 235 */,
/* 236 */,
/* 237 */,
/* 238 */,
/* 239 */,
/* 240 */,
/* 241 */,
/* 242 */,
/* 243 */,
/* 244 */,
/* 245 */,
/* 246 */,
/* 247 */,
/* 248 */,
/* 249 */,
/* 250 */,
/* 251 */,
/* 252 */,
/* 253 */,
/* 254 */,
/* 255 */,
/* 256 */,
/* 257 */,
/* 258 */,
/* 259 */,
/* 260 */,
/* 261 */,
/* 262 */,
/* 263 */,
/* 264 */,
/* 265 */,
/* 266 */,
/* 267 */,
/* 268 */,
/* 269 */,
/* 270 */,
/* 271 */,
/* 272 */,
/* 273 */,
/* 274 */,
/* 275 */,
/* 276 */,
/* 277 */,
/* 278 */,
/* 279 */,
/* 280 */,
/* 281 */,
/* 282 */,
/* 283 */,
/* 284 */,
/* 285 */,
/* 286 */,
/* 287 */,
/* 288 */,
/* 289 */,
/* 290 */,
/* 291 */,
/* 292 */,
/* 293 */,
/* 294 */,
/* 295 */,
/* 296 */,
/* 297 */,
/* 298 */,
/* 299 */,
/* 300 */,
/* 301 */,
/* 302 */,
/* 303 */,
/* 304 */,
/* 305 */,
/* 306 */,
/* 307 */,
/* 308 */,
/* 309 */,
/* 310 */,
/* 311 */,
/* 312 */,
/* 313 */,
/* 314 */,
/* 315 */,
/* 316 */,
/* 317 */,
/* 318 */,
/* 319 */,
/* 320 */,
/* 321 */,
/* 322 */,
/* 323 */,
/* 324 */,
/* 325 */,
/* 326 */,
/* 327 */,
/* 328 */,
/* 329 */,
/* 330 */,
/* 331 */,
/* 332 */,
/* 333 */,
/* 334 */,
/* 335 */,
/* 336 */,
/* 337 */,
/* 338 */,
/* 339 */,
/* 340 */,
/* 341 */,
/* 342 */,
/* 343 */,
/* 344 */,
/* 345 */,
/* 346 */,
/* 347 */,
/* 348 */,
/* 349 */,
/* 350 */,
/* 351 */,
/* 352 */,
/* 353 */,
/* 354 */,
/* 355 */,
/* 356 */,
/* 357 */,
/* 358 */,
/* 359 */,
/* 360 */,
/* 361 */,
/* 362 */,
/* 363 */,
/* 364 */,
/* 365 */,
/* 366 */,
/* 367 */,
/* 368 */,
/* 369 */,
/* 370 */,
/* 371 */,
/* 372 */,
/* 373 */,
/* 374 */,
/* 375 */,
/* 376 */,
/* 377 */,
/* 378 */,
/* 379 */,
/* 380 */,
/* 381 */,
/* 382 */,
/* 383 */,
/* 384 */,
/* 385 */,
/* 386 */,
/* 387 */,
/* 388 */,
/* 389 */,
/* 390 */,
/* 391 */,
/* 392 */,
/* 393 */,
/* 394 */,
/* 395 */,
/* 396 */,
/* 397 */,
/* 398 */,
/* 399 */,
/* 400 */,
/* 401 */,
/* 402 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Filter_vue__ = __webpack_require__(867);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e80625a0_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_Filter_vue__ = __webpack_require__(869);
var normalizeComponent = __webpack_require__(4)
/* script */

/* template */

/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Filter_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e80625a0_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_Filter_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 403 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DealersFilter_vue__ = __webpack_require__(870);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_012b440a_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_DealersFilter_vue__ = __webpack_require__(871);
var normalizeComponent = __webpack_require__(4)
/* script */

/* template */

/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DealersFilter_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_012b440a_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_DealersFilter_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 404 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ProdAgregFilter_vue__ = __webpack_require__(872);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4a03f832_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_ProdAgregFilter_vue__ = __webpack_require__(875);
var normalizeComponent = __webpack_require__(4)
/* script */

/* template */

/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ProdAgregFilter_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4a03f832_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_ProdAgregFilter_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 405 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_GridLocal_vue__ = __webpack_require__(873);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_047e8b8f_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_GridLocal_vue__ = __webpack_require__(874);
var normalizeComponent = __webpack_require__(4)
/* script */

/* template */

/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_GridLocal_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_047e8b8f_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_GridLocal_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 406 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ProductFilter_vue__ = __webpack_require__(876);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2247dd3f_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_ProductFilter_vue__ = __webpack_require__(877);
var normalizeComponent = __webpack_require__(4)
/* script */

/* template */

/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ProductFilter_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2247dd3f_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_ProductFilter_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 407 */,
/* 408 */,
/* 409 */,
/* 410 */,
/* 411 */,
/* 412 */,
/* 413 */,
/* 414 */,
/* 415 */,
/* 416 */,
/* 417 */,
/* 418 */,
/* 419 */,
/* 420 */,
/* 421 */,
/* 422 */,
/* 423 */,
/* 424 */,
/* 425 */,
/* 426 */,
/* 427 */,
/* 428 */,
/* 429 */,
/* 430 */,
/* 431 */,
/* 432 */,
/* 433 */,
/* 434 */,
/* 435 */,
/* 436 */,
/* 437 */,
/* 438 */,
/* 439 */,
/* 440 */,
/* 441 */,
/* 442 */,
/* 443 */,
/* 444 */,
/* 445 */,
/* 446 */,
/* 447 */,
/* 448 */,
/* 449 */,
/* 450 */,
/* 451 */,
/* 452 */,
/* 453 */,
/* 454 */,
/* 455 */,
/* 456 */,
/* 457 */,
/* 458 */,
/* 459 */,
/* 460 */,
/* 461 */,
/* 462 */,
/* 463 */,
/* 464 */,
/* 465 */,
/* 466 */,
/* 467 */,
/* 468 */,
/* 469 */,
/* 470 */,
/* 471 */,
/* 472 */,
/* 473 */,
/* 474 */,
/* 475 */,
/* 476 */,
/* 477 */,
/* 478 */,
/* 479 */,
/* 480 */,
/* 481 */,
/* 482 */,
/* 483 */,
/* 484 */,
/* 485 */,
/* 486 */,
/* 487 */,
/* 488 */,
/* 489 */,
/* 490 */,
/* 491 */,
/* 492 */,
/* 493 */,
/* 494 */,
/* 495 */,
/* 496 */,
/* 497 */,
/* 498 */,
/* 499 */,
/* 500 */,
/* 501 */,
/* 502 */,
/* 503 */,
/* 504 */,
/* 505 */,
/* 506 */,
/* 507 */,
/* 508 */,
/* 509 */,
/* 510 */,
/* 511 */,
/* 512 */,
/* 513 */,
/* 514 */,
/* 515 */,
/* 516 */,
/* 517 */,
/* 518 */,
/* 519 */,
/* 520 */,
/* 521 */,
/* 522 */,
/* 523 */,
/* 524 */,
/* 525 */,
/* 526 */,
/* 527 */,
/* 528 */,
/* 529 */,
/* 530 */,
/* 531 */,
/* 532 */,
/* 533 */,
/* 534 */,
/* 535 */,
/* 536 */,
/* 537 */,
/* 538 */,
/* 539 */,
/* 540 */,
/* 541 */,
/* 542 */,
/* 543 */,
/* 544 */,
/* 545 */,
/* 546 */,
/* 547 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_bootstrap_vue__ = __webpack_require__(550);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__App__ = __webpack_require__(582);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__router__ = __webpack_require__(94);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_axios__ = __webpack_require__(942);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_axios__ = __webpack_require__(961);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_vue_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__websanova_vue_auth__ = __webpack_require__(962);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__websanova_vue_auth___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__websanova_vue_auth__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__websanova_vue_auth_src_lib_utils_js__ = __webpack_require__(417);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__websanova_vue_auth_src_lib_utils_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__websanova_vue_auth_src_lib_utils_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_lodash__ = __webpack_require__(965);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_vue_lodash__ = __webpack_require__(966);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_vue_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_vue_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__deveodk_vue_toastr__ = __webpack_require__(967);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__deveodk_vue_toastr___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__deveodk_vue_toastr__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_vue_bootstrap_datetimepicker__ = __webpack_require__(968);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_vue_bootstrap_datetimepicker___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_vue_bootstrap_datetimepicker__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_vee_validate__ = __webpack_require__(971);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_vee_validate_dist_locale_pt_PT_js__ = __webpack_require__(972);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_vee_validate_dist_locale_pt_PT_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_vee_validate_dist_locale_pt_PT_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__progress_kendo_ui_js_kendo_all_js__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__progress_kendo_ui_js_kendo_all_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14__progress_kendo_ui_js_kendo_all_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__progress_kendo_ui_js_cultures_kendo_culture_pt_PT_js__ = __webpack_require__(973);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__progress_kendo_ui_js_cultures_kendo_culture_pt_PT_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15__progress_kendo_ui_js_cultures_kendo_culture_pt_PT_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__progress_kendo_ui_js_messages_kendo_messages_pt_PT_js__ = __webpack_require__(974);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__progress_kendo_ui_js_messages_kendo_messages_pt_PT_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16__progress_kendo_ui_js_messages_kendo_messages_pt_PT_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__components_StatisticsGrid_vue__ = __webpack_require__(975);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__components_SellinGrid_vue__ = __webpack_require__(982);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__components_GenericGrid_vue__ = __webpack_require__(988);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_20_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_vue_scrollto__ = __webpack_require__(994);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_vue_scrollto___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_21_vue_scrollto__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_vue_currency_filter__ = __webpack_require__(995);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__deveodk_vue_toastr_dist_deveodk_vue_toastr_css__ = __webpack_require__(996);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__deveodk_vue_toastr_dist_deveodk_vue_toastr_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_23__deveodk_vue_toastr_dist_deveodk_vue_toastr_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24_eonasdan_bootstrap_datetimepicker_build_css_bootstrap_datetimepicker_css__ = __webpack_require__(997);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24_eonasdan_bootstrap_datetimepicker_build_css_bootstrap_datetimepicker_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_24_eonasdan_bootstrap_datetimepicker_build_css_bootstrap_datetimepicker_css__);






























console.log(Window.appConfig);
__WEBPACK_IMPORTED_MODULE_14__progress_kendo_ui_js_kendo_all_js___default.a.culture('pt-PT');
Window.prototype.$ = __WEBPACK_IMPORTED_MODULE_14__progress_kendo_ui_js_kendo_all_js___default.a.jQuery;

function percent(a, b) {
  if (b === 0) {
    return 0;
  }
  return Math.round(a / b * 10000) / 100;
}
Window.prototype.percent = percent;

function growth(a, b) {
  if (b === 0) {
    return 0;
  }
  return Math.round((a - b) / b * 10000) / 100;
}
Window.prototype.growth = growth;

function growthFormat(p) {
  var icon = '<i class="fa fa-minus"></i>';
  if (p > 0) {
    icon = '<i class="fa fa-arrow-up text-success"></i>';
  } else if (p < 0) {
    icon = '<i class="fa fa-arrow-down text-danger"></i>';
  } else {
    icon = '<i class="fa fa-equals text-secondary"></i>';
  }
  return __WEBPACK_IMPORTED_MODULE_14__progress_kendo_ui_js_kendo_all_js___default.a.toString(p, 'n1') + '% ' + icon;
}
Window.prototype.growthFormat = growthFormat;

__WEBPACK_IMPORTED_MODULE_20_moment___default.a.locale('pt');
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].prototype.$moment = __WEBPACK_IMPORTED_MODULE_20_moment___default.a;

__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_bootstrap_vue__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_10__deveodk_vue_toastr___default.a, {
  defaultPosition: 'toast-top-center',
  defaultType: 'info',
  defaultTimeout: 1000
});
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_22_vue_currency_filter__["a" /* default */], {
  symbol: '€',
  thousandsSeparator: '.',
  fractionCount: 2,
  fractionSeparator: ',',
  symbolPosition: 'back',
  symbolSpacing: true
});
var apiRoot = "https://api.stats.app.inpar.com.pt/";
if (typeof Window.appConfig !== 'undefined' && Window.appConfig.baseUrl !== 'undefined') {
  apiRoot = Window.appConfig.baseUrl;
}
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].prototype.APIURL = apiRoot;
__WEBPACK_IMPORTED_MODULE_4_axios___default.a.defaults.baseURL = apiRoot;
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_5_vue_axios___default.a, __WEBPACK_IMPORTED_MODULE_4_axios___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__webpack_require__(998), {
  http: function http(data) {
    this.Vue.axios.post(data.url, data.body, {
      progress: data.progress
    }).then(data.success, data.error);
  }
});
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].router = __WEBPACK_IMPORTED_MODULE_3__router__["a" /* default */];

Object.defineProperty(__WEBPACK_IMPORTED_MODULE_0_vue__["default"].prototype, '$lodash', {
  value: __WEBPACK_IMPORTED_MODULE_8_lodash___default.a
});
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_21_vue_scrollto___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_9_vue_lodash___default.a, __WEBPACK_IMPORTED_MODULE_8_lodash___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_11_vue_bootstrap_datetimepicker___default.a);

var isUniqueUsername = function isUniqueUsername(value, args) {
  return __WEBPACK_IMPORTED_MODULE_0_vue__["default"].axios.post('users/username', {
    username: value,
    user_id: args[0]
  }).then(function (response) {
    return {
      valid: response.data.valid,
      data: {
        message: response.data.message
      }
    };
  });
};
var isUniqueEmail = function isUniqueEmail(value, args) {
  return __WEBPACK_IMPORTED_MODULE_0_vue__["default"].axios.post('users/email', {
    email: value,
    user_id: args[0]
  }).then(function (response) {
    return {
      valid: response.data.valid,
      data: {
        message: response.data.message
      }
    };
  });
};

__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_12_vee_validate__["b" /* default */], {
  locale: 'pt_PT',
  inject: true,
  fieldsBagName: 'veeFields'
});
__WEBPACK_IMPORTED_MODULE_13_vee_validate_dist_locale_pt_PT_js___default.a.attributes = {
  email: 'Email',
  name: 'Nome',
  username: 'Nome de utilizador',
  password: 'Palavra-passe',
  password_confirm: 'Confirme a palavra-passe'
};
__WEBPACK_IMPORTED_MODULE_12_vee_validate__["a" /* Validator */].localize('pt_PT', __WEBPACK_IMPORTED_MODULE_13_vee_validate_dist_locale_pt_PT_js___default.a);

__WEBPACK_IMPORTED_MODULE_12_vee_validate__["a" /* Validator */].extend('username', {
  validate: isUniqueUsername,
  getMessage: function getMessage(field, params, data) {
    console.log(data);
    return data.message;
  }
});
__WEBPACK_IMPORTED_MODULE_12_vee_validate__["a" /* Validator */].extend('uniqueemail', {
  validate: isUniqueEmail,
  getMessage: function getMessage(field, params, data) {
    console.log(data);
    return data.message;
  }
});


__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_6__websanova_vue_auth___default.a, {
  auth: __webpack_require__(1000),
  http: __webpack_require__(1001),
  router: __webpack_require__(1002),
  authRedirect: {
    path: '/login'
  },
  fetchData: {
    url: 'users/me'
  },
  refreshData: {
    url: 'auth/refresh',
    interval: 60
  },

  check: function check(role) {
    if (this.watch.authenticated === true) {
      if (role) {
        if (__WEBPACK_IMPORTED_MODULE_7__websanova_vue_auth_src_lib_utils_js___default.a.compare('superuser', this.watch.data['permissions'])) {
          return true;
        }
        return __WEBPACK_IMPORTED_MODULE_7__websanova_vue_auth_src_lib_utils_js___default.a.compare(role, this.watch.data['roles']) || __WEBPACK_IMPORTED_MODULE_7__websanova_vue_auth_src_lib_utils_js___default.a.compare(role, this.watch.data['permissions']);
      }
      return true;
    }
    return false;
  }
});
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].auth.perms = function (perm) {
  return this.options.check.call(this, perm, 'permissions');
};

__WEBPACK_IMPORTED_MODULE_0_vue__["default"].component('statistics-grid', __WEBPACK_IMPORTED_MODULE_0_vue__["default"].extend(__WEBPACK_IMPORTED_MODULE_17__components_StatisticsGrid_vue__["a" /* default */]));
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].component('sellin-grid', __WEBPACK_IMPORTED_MODULE_0_vue__["default"].extend(__WEBPACK_IMPORTED_MODULE_18__components_SellinGrid_vue__["a" /* default */]));

__WEBPACK_IMPORTED_MODULE_0_vue__["default"].component('generic-grid', __WEBPACK_IMPORTED_MODULE_0_vue__["default"].extend(__WEBPACK_IMPORTED_MODULE_19__components_GenericGrid_vue__["a" /* default */]));

new __WEBPACK_IMPORTED_MODULE_0_vue__["default"]({
  el: '#app',
  router: __WEBPACK_IMPORTED_MODULE_3__router__["a" /* default */],
  template: '<App/>',
  components: {
    App: __WEBPACK_IMPORTED_MODULE_2__App__["a" /* default */]
  }
});

/***/ }),
/* 548 */,
/* 549 */,
/* 550 */,
/* 551 */,
/* 552 */,
/* 553 */,
/* 554 */,
/* 555 */,
/* 556 */,
/* 557 */,
/* 558 */,
/* 559 */,
/* 560 */,
/* 561 */,
/* 562 */,
/* 563 */,
/* 564 */,
/* 565 */,
/* 566 */,
/* 567 */,
/* 568 */,
/* 569 */,
/* 570 */,
/* 571 */,
/* 572 */,
/* 573 */,
/* 574 */,
/* 575 */,
/* 576 */,
/* 577 */,
/* 578 */,
/* 579 */,
/* 580 */,
/* 581 */,
/* 582 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__ = __webpack_require__(586);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_921744a4_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__ = __webpack_require__(587);
function injectStyle (ssrContext) {
  __webpack_require__(583)
  __webpack_require__(585)
}
var normalizeComponent = __webpack_require__(4)
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_921744a4_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 583 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 584 */,
/* 585 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 586 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'app'
});

/***/ }),
/* 587 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.$auth.ready())?_c('div',[_c('router-view')],1):_vm._e(),_vm._v(" "),(!_vm.$auth.ready())?_c('div',{staticClass:"splash"},[_vm._m(0)]):_vm._e()])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container  d-flex h-100"},[_c('div',{staticClass:"row justify-content-center text-primary w-100 align-self-center text-white"},[_c('i',{staticClass:"fa fa-spin fa-spinner"})])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 588 */,
/* 589 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Full_vue__ = __webpack_require__(590);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_44cec539_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_Full_vue__ = __webpack_require__(820);
var normalizeComponent = __webpack_require__(4)
/* script */

/* template */

/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Full_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_44cec539_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_Full_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 590 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__nav__ = __webpack_require__(591);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components___ = __webpack_require__(592);





/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'full',
  components: {
    AppHeader: __WEBPACK_IMPORTED_MODULE_1__components___["c" /* Header */],
    Sidebar: __WEBPACK_IMPORTED_MODULE_1__components___["d" /* Sidebar */],
    AppAside: __WEBPACK_IMPORTED_MODULE_1__components___["a" /* Aside */],
    Breadcrumb: __WEBPACK_IMPORTED_MODULE_1__components___["b" /* Breadcrumb */]
  },
  data: function data() {
    return {
      nav: __WEBPACK_IMPORTED_MODULE_0__nav__["a" /* default */].items
    };
  },

  computed: {
    name: function name() {
      return this.$route.name;
    },
    list: function list() {
      return this.$route.matched;
    }
  }
});

/***/ }),
/* 591 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  items: [{
    name: 'Dashboard',
    url: '/dashboard',
    icon: 'fa fa-table'
  }, {
    name: 'Sellout',
    url: '/statistics/index',
    icon: 'fa fa-table'
  }, {
    name: 'Sellin',
    url: '/sellin/index',
    icon: 'fa fa-table'
  }, {
    name: 'Oportunidades',
    url: '/oportunity',
    icon: 'fa fa-table',
    auth: ['oportunity.all']
  }, {
    name: 'Oportunidades',
    url: '/oportunity-self',
    icon: 'fa fa-table',
    auth: ['oportunity.results']
  }, {
    name: 'NIF\'s Excluídos',
    url: '/nifs-excluidos',
    icon: 'fa fa-table' }, {
    name: 'Operators',
    url: '/operators',
    icon: 'fa fa-table' }, {
    divider: true
  }, {
    name: 'Utilizadores',
    url: '/users',
    icon: 'fa fa-users',
    auth: ['users.list']
  }, {
    name: 'Grupos',
    url: '/roles',
    icon: 'fa fa-users',
    auth: ['roles.list']
  }, {
    divider: true
  }]
});

/***/ }),
/* 592 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Aside_vue__ = __webpack_require__(593);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Breadcrumb_vue__ = __webpack_require__(596);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Callout_vue__ = __webpack_require__(599);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Footer_vue__ = __webpack_require__(602);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Header_vue__ = __webpack_require__(605);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Sidebar_vue__ = __webpack_require__(608);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Switch_vue__ = __webpack_require__(664);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Grid_vue__ = __webpack_require__(15);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__Aside_vue__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_1__Breadcrumb_vue__["a"]; });
/* unused harmony reexport Callout */
/* unused harmony reexport Footer */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_4__Header_vue__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_5__Sidebar_vue__["a"]; });
/* unused harmony reexport Switch */
/* unused harmony reexport Grid */











/***/ }),
/* 593 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Aside_vue__ = __webpack_require__(594);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f08aeefc_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_Aside_vue__ = __webpack_require__(595);
var normalizeComponent = __webpack_require__(4)
/* script */

/* template */

/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Aside_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f08aeefc_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_Aside_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 594 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'theaside'
});

/***/ }),
/* 595 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('aside',{staticClass:"aside-menu"})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 596 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Breadcrumb_vue__ = __webpack_require__(597);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_74d5dba9_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_Breadcrumb_vue__ = __webpack_require__(598);
var normalizeComponent = __webpack_require__(4)
/* script */

/* template */

/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Breadcrumb_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_74d5dba9_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_Breadcrumb_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 597 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    list: {
      type: Array,
      required: true,
      default: function _default() {
        return [];
      }
    }
  },
  methods: {
    isLast: function isLast(index) {
      return index === this.list.length - 1;
    },
    showName: function showName(item) {
      if (item.meta && item.meta.label) {
        item = item.meta && item.meta.label;
      }
      if (item.name) {
        item = item.name;
      }
      return item;
    }
  }
});

/***/ }),
/* 598 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ol',{staticClass:"breadcrumb"},_vm._l((_vm.list),function(item,index){return _c('li',{staticClass:"breadcrumb-item"},[(_vm.isLast(index))?_c('span',{staticClass:"active"},[_vm._v(_vm._s(_vm.showName(item)))]):_c('router-link',{attrs:{"to":item.path}},[_vm._v(_vm._s(_vm.showName(item)))])],1)}),0)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 599 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Callout_vue__ = __webpack_require__(600);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_059ad2fa_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_Callout_vue__ = __webpack_require__(601);
var normalizeComponent = __webpack_require__(4)
/* script */

/* template */

/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Callout_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_059ad2fa_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_Callout_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* unused harmony default export */ var _unused_webpack_default_export = (Component.exports);


/***/ }),
/* 600 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    variant: {
      type: String
    }
  },
  computed: {
    classList: function classList() {
      return ['callout', this.calloutVariant];
    },
    calloutVariant: function calloutVariant() {
      return this.variant ? 'callout-' + this.variant : '';
    }
  }
});

/***/ }),
/* 601 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.classList},[_vm._t("default")],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 602 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Footer_vue__ = __webpack_require__(603);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b587677e_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_Footer_vue__ = __webpack_require__(604);
var normalizeComponent = __webpack_require__(4)
/* script */

/* template */

/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Footer_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b587677e_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_Footer_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* unused harmony default export */ var _unused_webpack_default_export = (Component.exports);


/***/ }),
/* 603 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'thefooter'
});

/***/ }),
/* 604 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('footer',{staticClass:"app-footer"},[_c('span',[_c('a',{attrs:{"href":"http://coreui.io"}},[_vm._v("CoreUI")]),_vm._v(" © 2017 creativeLabs.")]),_vm._v(" "),_c('span',{staticClass:"ml-auto"},[_vm._v("Powered by "),_c('a',{attrs:{"href":"http://coreui.io"}},[_vm._v("CoreUI")])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 605 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Header_vue__ = __webpack_require__(606);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_73229f9a_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_Header_vue__ = __webpack_require__(607);
var normalizeComponent = __webpack_require__(4)
/* script */

/* template */

/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Header_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_73229f9a_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_Header_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 606 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'theheader',
  data: function data() {
    return {
      user: this.$auth.user()
    };
  },

  methods: {
    logout: function logout() {
      this.$auth.logout();
      this.$router.push({
        name: 'login'
      });
    },
    sidebarToggle: function sidebarToggle(e) {
      e.preventDefault();
      document.body.classList.toggle('sidebar-hidden');
    },
    sidebarMinimize: function sidebarMinimize(e) {
      e.preventDefault();
      document.body.classList.toggle('sidebar-minimized');
    },
    mobileSidebarToggle: function mobileSidebarToggle(e) {
      e.preventDefault();
      document.body.classList.toggle('sidebar-mobile-show');
    },
    asideToggle: function asideToggle(e) {
      e.preventDefault();
      document.body.classList.toggle('aside-menu-hidden');
    }
  }
});

/***/ }),
/* 607 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('header',{staticClass:"app-header navbar"},[_c('button',{staticClass:"navbar-toggler mobile-sidebar-toggler d-lg-none",attrs:{"type":"button"},on:{"click":_vm.mobileSidebarToggle}},[_vm._v("☰")]),_vm._v(" "),_c('b-link',{staticClass:"navbar-brand",attrs:{"to":"#"}}),_vm._v(" "),_c('button',{staticClass:"navbar-toggler sidebar-toggler d-md-down-none mr-auto",attrs:{"type":"button"},on:{"click":_vm.sidebarToggle}},[_vm._v("☰")]),_vm._v(" "),_c('b-nav',{staticClass:"ml-auto mr-3",attrs:{"is-nav-bar":""}},[_c('b-nav-item-dropdown',{attrs:{"right":""}},[_c('template',{slot:"button-content"},[_c('img',{staticClass:"img-avatar",attrs:{"src":"//www.gravatar.com/avatar/?d=mysteryman&s=200","alt":"admin@bootstrapmaster.com"}}),_vm._v(" "),_c('span',{staticClass:"d-md-down-none"},[_vm._v(_vm._s(_vm.user.name))])]),_vm._v(" "),_c('b-dropdown-item',{attrs:{"to":{ name: 'profile' }}},[_c('i',{staticClass:"fa fa-user"}),_vm._v(" Perfil")]),_vm._v(" "),_c('b-dropdown-item',{on:{"click":function($event){return _vm.logout()}}},[_c('i',{staticClass:"fa fa-lock"}),_vm._v(" Logout")])],2)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 608 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Sidebar_vue__ = __webpack_require__(610);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_aa108fb4_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_Sidebar_vue__ = __webpack_require__(663);
function injectStyle (ssrContext) {
  __webpack_require__(609)
}
var normalizeComponent = __webpack_require__(4)
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Sidebar_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_aa108fb4_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_Sidebar_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 609 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 610 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__SidebarFooter__ = __webpack_require__(611);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__SidebarForm__ = __webpack_require__(614);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__SidebarHeader__ = __webpack_require__(617);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__SidebarMinimizer__ = __webpack_require__(620);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__SidebarNavDropdown__ = __webpack_require__(623);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__SidebarNavLink__ = __webpack_require__(626);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__SidebarNavTitle__ = __webpack_require__(630);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__SidebarNavItem__ = __webpack_require__(660);










/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'sidebar',
  props: {
    navItems: {
      type: Array,
      required: true,
      default: function _default() {
        return [];
      }
    }
  },
  components: {
    SidebarFooter: __WEBPACK_IMPORTED_MODULE_0__SidebarFooter__["a" /* default */],
    SidebarForm: __WEBPACK_IMPORTED_MODULE_1__SidebarForm__["a" /* default */],
    SidebarHeader: __WEBPACK_IMPORTED_MODULE_2__SidebarHeader__["a" /* default */],
    SidebarMinimizer: __WEBPACK_IMPORTED_MODULE_3__SidebarMinimizer__["a" /* default */],
    SidebarNavDropdown: __WEBPACK_IMPORTED_MODULE_4__SidebarNavDropdown__["a" /* default */],
    SidebarNavLink: __WEBPACK_IMPORTED_MODULE_5__SidebarNavLink__["a" /* default */],
    SidebarNavTitle: __WEBPACK_IMPORTED_MODULE_6__SidebarNavTitle__["a" /* default */],
    SidebarNavItem: __WEBPACK_IMPORTED_MODULE_7__SidebarNavItem__["a" /* default */]
  },
  methods: {
    handleClick: function handleClick(e) {
      e.preventDefault();
      e.target.parentElement.classList.toggle('open');
    }
  }
});

/***/ }),
/* 611 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SidebarFooter_vue__ = __webpack_require__(612);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3f29bc3e_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_SidebarFooter_vue__ = __webpack_require__(613);
var normalizeComponent = __webpack_require__(4)
/* script */

/* template */

/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SidebarFooter_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3f29bc3e_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_SidebarFooter_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 612 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'sidebar-footer'
});

/***/ }),
/* 613 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c("div")}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 614 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SidebarForm_vue__ = __webpack_require__(615);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7ea69fec_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_SidebarForm_vue__ = __webpack_require__(616);
var normalizeComponent = __webpack_require__(4)
/* script */

/* template */

/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SidebarForm_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7ea69fec_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_SidebarForm_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 615 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'sidebar-form'
});

/***/ }),
/* 616 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c("div")}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 617 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SidebarHeader_vue__ = __webpack_require__(618);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_019d85d3_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_SidebarHeader_vue__ = __webpack_require__(619);
var normalizeComponent = __webpack_require__(4)
/* script */

/* template */

/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SidebarHeader_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_019d85d3_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_SidebarHeader_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 618 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'sidebar-header'
});

/***/ }),
/* 619 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c("div")}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 620 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SidebarMinimizer_vue__ = __webpack_require__(621);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ae6e3f84_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_SidebarMinimizer_vue__ = __webpack_require__(622);
var normalizeComponent = __webpack_require__(4)
/* script */

/* template */

/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SidebarMinimizer_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ae6e3f84_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_SidebarMinimizer_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 621 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'sidebar-minimizer',
  methods: {
    sidebarMinimize: function sidebarMinimize() {
      document.body.classList.toggle('sidebar-minimized');
    },
    brandMinimize: function brandMinimize() {
      document.body.classList.toggle('brand-minimized');
    }
  }
});

/***/ }),
/* 622 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"sidebar-minimizer",attrs:{"type":"button"},on:{"click":function($event){_vm.sidebarMinimize();_vm.brandMinimize()}}})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 623 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SidebarNavDropdown_vue__ = __webpack_require__(624);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ed499704_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_SidebarNavDropdown_vue__ = __webpack_require__(625);
var normalizeComponent = __webpack_require__(4)
/* script */

/* template */

/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SidebarNavDropdown_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ed499704_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_SidebarNavDropdown_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 624 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    name: {
      type: String,
      default: ''
    },
    url: {
      type: String,
      default: ''
    },
    icon: {
      type: String,
      default: ''
    }
  },
  methods: {
    handleClick: function handleClick(e) {
      e.preventDefault();
      e.target.parentElement.classList.toggle('open');
    }
  }
});

/***/ }),
/* 625 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('router-link',{staticClass:"nav-item nav-dropdown",attrs:{"tag":"li","to":_vm.url,"disabled":""}},[_c('div',{staticClass:"nav-link nav-dropdown-toggle",on:{"click":_vm.handleClick}},[_c('i',{class:_vm.icon}),_vm._v(" "+_vm._s(_vm.name))]),_vm._v(" "),_c('ul',{staticClass:"nav-dropdown-items"},[_vm._t("default")],2)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 626 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SidebarNavLink_vue__ = __webpack_require__(627);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1acaf667_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_SidebarNavLink_vue__ = __webpack_require__(629);
var normalizeComponent = __webpack_require__(4)
/* script */

/* template */

/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SidebarNavLink_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1acaf667_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_SidebarNavLink_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 627 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_is_url_external__ = __webpack_require__(628);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_is_url_external___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_is_url_external__);




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'sidebar-nav-link',
  props: {
    name: {
      type: String,
      default: ''
    },
    url: {
      type: String,
      default: ''
    },
    icon: {
      type: String,
      default: ''
    },
    badge: {
      type: Object,
      default: function _default() {}
    },
    variant: {
      type: String,
      default: ''
    }
  },
  computed: {
    classList: function classList() {
      return ['nav-link', this.linkVariant];
    },
    linkVariant: function linkVariant() {
      return this.variant ? 'nav-link-' + this.variant : '';
    },
    linkExternal: function linkExternal() {
      return __WEBPACK_IMPORTED_MODULE_0_is_url_external___default()(this.url);
    }
  }
});

/***/ }),
/* 628 */,
/* 629 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.linkExternal)?_c('div',[_c('a',{class:_vm.classList,attrs:{"href":_vm.url}},[_c('i',{class:_vm.icon}),_vm._v(" "+_vm._s(_vm.name)+"\n      "),(_vm.badge && _vm.badge.text)?_c('b-badge',{attrs:{"variant":_vm.badge.variant}},[_vm._v(_vm._s(_vm.badge.text))]):_vm._e()],1)]):_c('div',[_c('router-link',{class:_vm.classList,attrs:{"to":_vm.url}},[_c('i',{class:_vm.icon}),_vm._v(" "+_vm._s(_vm.name)+"\n    "),(_vm.badge && _vm.badge.text)?_c('b-badge',{attrs:{"variant":_vm.badge.variant}},[_vm._v(_vm._s(_vm.badge.text))]):_vm._e()],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 630 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SidebarNavTitle_vue__ = __webpack_require__(631);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_22b7e2bb_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_SidebarNavTitle_vue__ = __webpack_require__(659);
var normalizeComponent = __webpack_require__(4)
/* script */

/* template */

/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SidebarNavTitle_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_22b7e2bb_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_SidebarNavTitle_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 631 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(323);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__);



/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    name: {
      type: String,
      default: ''
    },
    classes: {
      type: String,
      default: ''
    },
    wrapper: {
      type: Object,
      default: function _default() {}
    }
  },
  computed: {
    classList: function classList() {
      return ['nav-title'].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(this.itemClasses));
    },
    itemClasses: function itemClasses() {
      return this.classes ? this.classes.split(' ') : '';
    }
  }
});

/***/ }),
/* 632 */,
/* 633 */,
/* 634 */,
/* 635 */,
/* 636 */,
/* 637 */,
/* 638 */,
/* 639 */,
/* 640 */,
/* 641 */,
/* 642 */,
/* 643 */,
/* 644 */,
/* 645 */,
/* 646 */,
/* 647 */,
/* 648 */,
/* 649 */,
/* 650 */,
/* 651 */,
/* 652 */,
/* 653 */,
/* 654 */,
/* 655 */,
/* 656 */,
/* 657 */,
/* 658 */,
/* 659 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('li',{class:_vm.classList},[(_vm.wrapper && _vm.wrapper.element)?[_c(_vm.wrapper.element,_vm._b({tag:"component"},'component',_vm.wrapper.attributes,false),[_vm._v("\n        "+_vm._s(_vm.name)+"\n      ")])]:[_vm._v("\n      "+_vm._s(_vm.name)+"\n    ")]],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 660 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SidebarNavItem_vue__ = __webpack_require__(661);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_19cc8d00_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_SidebarNavItem_vue__ = __webpack_require__(662);
var normalizeComponent = __webpack_require__(4)
/* script */

/* template */

/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SidebarNavItem_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_19cc8d00_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_SidebarNavItem_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 661 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(323);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__);



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'sidebar-nav-item',
  props: {
    classes: {
      type: String,
      default: ''
    }
  },
  computed: {
    classList: function classList() {
      return ['nav-item'].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(this.itemClasses));
    },
    itemClasses: function itemClasses() {
      return this.classes ? this.classes.split(' ') : '';
    }
  }
});

/***/ }),
/* 662 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('li',{class:_vm.classList},[_vm._t("default")],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 663 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"sidebar"},[_c('SidebarHeader'),_vm._v(" "),_c('SidebarForm'),_vm._v(" "),_c('nav',{staticClass:"sidebar-nav"},[_c('div',{attrs:{"slot":"header"},slot:"header"}),_vm._v(" "),_c('ul',{staticClass:"nav"},[_vm._l((_vm.navItems),function(item,index){return (!item.auth || _vm.$auth.check(item.auth))?[(item.title)?[_c('SidebarNavTitle',{attrs:{"name":item.name,"classes":item.class,"wrapper":item.wrapper}})]:(item.divider)?[_c('li',{staticClass:"divider"})]:[(item.children)?[_c('SidebarNavDropdown',{attrs:{"name":item.name,"url":item.url,"icon":item.icon}},[_vm._l((item.children),function(childL1,index){return [(childL1.children)?[_c('SidebarNavDropdown',{attrs:{"name":childL1.name,"url":childL1.url,"icon":childL1.icon}},_vm._l((childL1.children),function(childL2,index){return _c('li',{staticClass:"nav-item"},[_c('SidebarNavLink',{attrs:{"name":childL2.name,"url":childL2.url,"icon":childL2.icon,"badge":childL2.badge,"variant":item.variant}})],1)}),0)]:[_c('SidebarNavItem',{attrs:{"classes":item.class}},[_c('SidebarNavLink',{attrs:{"name":childL1.name,"url":childL1.url,"icon":childL1.icon,"badge":childL1.badge,"variant":item.variant}})],1)]]})],2)]:[_c('SidebarNavItem',{attrs:{"classes":item.class}},[_c('SidebarNavLink',{attrs:{"name":item.name,"url":item.url,"icon":item.icon,"badge":item.badge,"variant":item.variant}})],1)]]]:_vm._e()})],2),_vm._v(" "),_vm._t("default")],2),_vm._v(" "),_c('SidebarFooter'),_vm._v(" "),_c('SidebarMinimizer')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 664 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Switch_vue__ = __webpack_require__(665);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3bdcd95a_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_Switch_vue__ = __webpack_require__(666);
var normalizeComponent = __webpack_require__(4)
/* script */

/* template */

/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Switch_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3bdcd95a_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_Switch_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* unused harmony default export */ var _unused_webpack_default_export = (Component.exports);


/***/ }),
/* 665 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
  model: {
    prop: 'checked',
    event: 'change'
  },
  props: {
    value: {
      default: true
    },
    uncheckedValue: {
      default: false
    },
    checked: {
      default: false
    },
    type: {
      type: String,
      default: 'default'
    },
    variant: {
      type: String,
      default: ''
    },
    pill: {
      type: Boolean,
      default: false
    },
    on: {
      type: String,
      default: null
    },
    off: {
      type: String,
      default: null
    },
    size: {
      type: String,
      default: null
    }
  },
  computed: {
    classList: function classList() {
      return ['switch', this.switchType, this.switchVariant, this.switchPill, this.switchSize];
    },
    switchType: function switchType() {
      return this.type ? 'switch-' + this.type : 'switch-default';
    },
    switchVariant: function switchVariant() {
      return this.variant ? 'switch-' + this.variant : 'switch-secondary';
    },
    switchPill: function switchPill() {
      return !this.pill ? null : 'switch-pill';
    },
    switchSize: function switchSize() {
      return this.size ? 'switch-' + this.size : '';
    },
    isChecked: function isChecked() {
      return this.checked === this.value;
    },
    isOn: function isOn() {
      return !this.on ? null : true;
    }
  },
  methods: {
    handleChange: function handleChange(_ref) {
      var checked = _ref.target.checked;

      this.$emit('change', checked ? this.value : this.uncheckedValue);
    }
  }
});

/***/ }),
/* 666 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{class:_vm.classList},[_c('input',{staticClass:"switch-input",attrs:{"type":"checkbox"},domProps:{"value":_vm.value,"checked":_vm.isChecked},on:{"change":_vm.handleChange}}),_vm._v(" "),(_vm.isOn)?[_c('span',{staticClass:"switch-label",attrs:{"data-on":_vm.on,"data-off":_vm.off}})]:[_c('span',{staticClass:"switch-label"})],_vm._v(" "),_c('span',{staticClass:"switch-handle"})],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 667 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__progress_kendo_ui_js_kendo_all_js__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__progress_kendo_ui_js_kendo_all_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__progress_kendo_ui_js_kendo_all_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__progress_kendo_grid_vue_wrapper__ = __webpack_require__(74);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__progress_kendo_grid_vue_wrapper___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__progress_kendo_grid_vue_wrapper__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__progress_kendo_datasource_vue_wrapper__ = __webpack_require__(75);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__progress_kendo_datasource_vue_wrapper___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__progress_kendo_datasource_vue_wrapper__);








__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_3__progress_kendo_datasource_vue_wrapper__["KendoDataSourceInstaller"]);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_2__progress_kendo_grid_vue_wrapper__["KendoGridInstaller"]);

/* harmony default export */ __webpack_exports__["a"] = ({
  props: ['name', 'schemaModelFields', 'url', 'columns', 'preload', 'sortable', 'pageable', 'filterable', 'height', 'databound', 'pagesize'],
  components: {
    KendoGrid: __WEBPACK_IMPORTED_MODULE_2__progress_kendo_grid_vue_wrapper__["KendoGrid"],
    KendoDataSource: __WEBPACK_IMPORTED_MODULE_3__progress_kendo_datasource_vue_wrapper__["KendoDataSource"]
  },
  data: function data() {
    return {
      preloadDone: false,
      gridTransport: this.getTransport(),
      schemaTotal: this.getTotal,
      finalDataBound: null,
      options: {
        dataSource: {
          page: 1,
          sort: null,
          filter: null
        }
      }
    };
  },

  methods: {
    getTransport: function getTransport() {
      var v = this;
      return {
        read: {
          url: v.axios.defaults.baseURL + this.url,
          beforeSend: function beforeSend(req) {
            req.setRequestHeader('Authorization', 'Bearer ' + v.$auth.token());
          }
        }
      };
    },
    getGrid: function getGrid() {
      return this.$refs.mygrid.kendoWidget();
    },
    getTotal: function getTotal(response) {
      if (response.meta) {
        return response.meta.pagination.total;
      } else {
        return response.data.length;
      }
    },
    setColumnsData: function setColumnsData(data, field) {
      for (var i = 0; i < this.columns.length; i++) {
        if (this.columns[i].field === field) {
          this.columns[i].values = data;
        }
      }
    }
  },
  created: function created() {
    var _this = this;

    if (typeof this.databound === 'function') {
      this.finalDataBound = this.databound;
    } else {
      this.finalDataBound = function () {};
    }
    var that = this;
    if (localStorage[this.name + 'options']) {
      this.options = JSON.parse(localStorage[this.name + 'options']);
    }
    var apiPreloads = [];
    if (typeof this.preload !== 'undefined' && this.preload != null && this.preload.length > 0) {
      for (var i = 0; i < this.preload.length; i++) {
        apiPreloads.push(this.preload[i].api);
      }
      this.axios.all(apiPreloads.map(function (l) {
        return _this.axios.get(l);
      })).then(that.axios.spread(function () {
        for (var i = 0; i < that.preload.length; i++) {
          that.setColumnsData(arguments[i].data.data, that.preload[i].field);
        }
        that.preloadDone = true;
      })).catch(function (response) {
        console.error('error loading foreigns', response);
      });
    } else {
      that.preloadDone = true;
    }
  },
  beforeDestroy: function beforeDestroy() {
    try {
      var grid = this.$refs.mygrid.kendoWidget();
      localStorage[this.name + 'options'] = __WEBPACK_IMPORTED_MODULE_1__progress_kendo_ui_js_kendo_all_js___default.a.stringify(grid.getOptions());
    } catch (error) {}
  }
});

/***/ }),
/* 668 */,
/* 669 */,
/* 670 */,
/* 671 */,
/* 672 */,
/* 673 */,
/* 674 */,
/* 675 */,
/* 676 */,
/* 677 */,
/* 678 */,
/* 679 */,
/* 680 */,
/* 681 */,
/* 682 */,
/* 683 */,
/* 684 */,
/* 685 */,
/* 686 */,
/* 687 */,
/* 688 */,
/* 689 */,
/* 690 */,
/* 691 */,
/* 692 */,
/* 693 */,
/* 694 */,
/* 695 */,
/* 696 */,
/* 697 */,
/* 698 */,
/* 699 */,
/* 700 */,
/* 701 */,
/* 702 */,
/* 703 */,
/* 704 */,
/* 705 */,
/* 706 */,
/* 707 */,
/* 708 */,
/* 709 */,
/* 710 */,
/* 711 */,
/* 712 */,
/* 713 */,
/* 714 */,
/* 715 */,
/* 716 */,
/* 717 */,
/* 718 */,
/* 719 */,
/* 720 */,
/* 721 */,
/* 722 */,
/* 723 */,
/* 724 */,
/* 725 */,
/* 726 */,
/* 727 */,
/* 728 */,
/* 729 */,
/* 730 */,
/* 731 */,
/* 732 */,
/* 733 */,
/* 734 */,
/* 735 */,
/* 736 */,
/* 737 */,
/* 738 */,
/* 739 */,
/* 740 */,
/* 741 */,
/* 742 */,
/* 743 */,
/* 744 */,
/* 745 */,
/* 746 */,
/* 747 */,
/* 748 */,
/* 749 */,
/* 750 */,
/* 751 */,
/* 752 */,
/* 753 */,
/* 754 */,
/* 755 */,
/* 756 */,
/* 757 */,
/* 758 */,
/* 759 */,
/* 760 */,
/* 761 */,
/* 762 */,
/* 763 */,
/* 764 */,
/* 765 */,
/* 766 */,
/* 767 */,
/* 768 */,
/* 769 */,
/* 770 */,
/* 771 */,
/* 772 */,
/* 773 */,
/* 774 */,
/* 775 */,
/* 776 */,
/* 777 */,
/* 778 */,
/* 779 */,
/* 780 */,
/* 781 */,
/* 782 */,
/* 783 */,
/* 784 */,
/* 785 */,
/* 786 */,
/* 787 */,
/* 788 */,
/* 789 */,
/* 790 */,
/* 791 */,
/* 792 */,
/* 793 */,
/* 794 */,
/* 795 */,
/* 796 */,
/* 797 */,
/* 798 */,
/* 799 */,
/* 800 */,
/* 801 */,
/* 802 */,
/* 803 */,
/* 804 */,
/* 805 */,
/* 806 */,
/* 807 */,
/* 808 */,
/* 809 */,
/* 810 */,
/* 811 */,
/* 812 */,
/* 813 */,
/* 814 */,
/* 815 */,
/* 816 */,
/* 817 */,
/* 818 */,
/* 819 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.preloadDone)?_c('div',[_c('kendo-datasource',{ref:"datasource1",attrs:{"transport":_vm.gridTransport,"schema-model-fields":_vm.schemaModelFields,"schema-total":_vm.schemaTotal,"schema-data":'data',"page-size":_vm.pagesize?_vm.pagesize:10,"server-paging":true,"server-filtering":true,"server-sorting":true,"page":_vm.options.dataSource.page,"filter":_vm.options.dataSource.filter,"sort":_vm.options.dataSource.sort}}),_vm._v(" "),_c('kendo-grid',{ref:"mygrid",attrs:{"height":_vm.height,"data-source-ref":'datasource1',"pageable":_vm.pageable,"filterable":_vm.filterable,"sortable":_vm.sortable,"columns":_vm.columns,"scrollable":true},on:{"databound":_vm.finalDataBound}})],1):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 820 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"app"},[_c('AppHeader'),_vm._v(" "),_c('div',{staticClass:"app-body"},[_c('Sidebar',{attrs:{"navItems":_vm.nav}}),_vm._v(" "),_c('main',{staticClass:"main"},[_c('div',{staticClass:"container-fluid"},[_c('router-view')],1)]),_vm._v(" "),_c('AppAside')],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 821 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Dashboard_vue__ = __webpack_require__(822);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6a26f980_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_Dashboard_vue__ = __webpack_require__(829);
var normalizeComponent = __webpack_require__(4)
/* script */

/* template */

/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Dashboard_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6a26f980_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_Dashboard_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 822 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__dashboard_ObjectivesTable__ = __webpack_require__(823);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__dashboard_EffectivenessTable__ = __webpack_require__(826);




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'dashboard',
  components: {
    ObjectivesTable: __WEBPACK_IMPORTED_MODULE_0__dashboard_ObjectivesTable__["a" /* default */],
    EffectivenessTable: __WEBPACK_IMPORTED_MODULE_1__dashboard_EffectivenessTable__["a" /* default */]
  },
  data: function data() {
    return {
      lastUpdate: [],
      loading: false,
      scorecard: {
        sellout: [],
        selloutTop10: [],
        operators: [],
        sumtop10: [],
        dealers_operators: [],
        dealers: {
          ufs: [],
          spreads: []
        },
        sellin: {
          niv: [],
          turnover: [],
          top10: []
        }
      },
      objectivesPeriods: [{
        value: 1,
        text: 'mês'
      }, {
        value: 2,
        text: 'acumulado até'
      }],
      years: [{
        value: 2026,
        text: '2026'
      }, {
        value: 2025,
        text: '2025'
      }],
      selectedMonth: null,
      zone: null,
      selectedPeriod: 1,
      selectedYear: null,
      selectedMonthEnd: null,
      selectedMonthStart: null,
      selectedMonthLitersLE: null,
      effectiveness: [],
      litersLE: [],
      accounts: {
        open_docs: 0,
        expired_docs: 0,
        avg_expired_docs: 0,
        days_behind: 0,
        open_value: 0,
        expired_value: 0
      },
      monthOptions: [],
      objectivesZones: [],
      effectivenessCurrentPage: 1,
      npsFields: [{ key: 'label', label: 'Categoria', sortable: true }, { key: 'objective', label: 'Objectivo', sortable: true }, { key: 'total', label: 'Real', sortable: true }, { key: 'progress', label: 'Progresso', sortable: true }],
      operatorsFields: [{ key: 'label', label: 'Categoria', sortable: true }, { key: 'objective', label: 'Homólogo', sortable: true }, { key: 'total', label: 'Real', sortable: true }, { key: 'progress', label: 'Progresso', sortable: true }],
      dealerOperatorsFields: [{ key: 'label', label: 'Categoria', sortable: true }, { key: 'objective', label: 'Homólogo', sortable: true }, { key: 'total', label: 'Real', sortable: true }, { key: 'progress', label: 'Progresso', sortable: true }],
      dealerFields: [{ key: 'label', label: 'Distribuidor', sortable: true }, { key: 'objective', label: 'Objectivo', sortable: true }, { key: 'total', label: 'Real', sortable: true }, { key: 'progress', label: 'Progresso', sortable: true }],
      objective_items: ['sellout', 'sumtop10', 'operators', 'dealers/0', 'dealers/1', 'sellin', 'dealers_operators']
    };
  },
  watch: {
    selectedYear: {
      handler: function handler(newValue) {
        this.loadObjectives(this.selectedMonthStart, this.selectedMonthEnd);
      }
    },
    selectedMonthStart: {
      handler: function handler(newValue) {
        var p = this.selectedMonthEnd;
        if (newValue.month > p.month) {
          this.selectedMonthEnd = newValue;
          p = this.selectedMonthEnd;
        }
        console.log('selectedMonthStart', newValue);
        console.log('selectedMonthEnd', p);
        this.loadObjectives(newValue, p);
      }
    },
    selectedMonthEnd: {
      handler: function handler(newValue) {
        var p = this.selectedMonthStart;
        if (newValue.month < p.month) {
          this.selectedMonthStart = newValue;
          p = this.selectedMonthStart;
        }
        console.log('selectedMonthEnd', newValue);
        console.log('selectedMonthStart', p);
        this.loadObjectives(p, newValue);
      }
    }
  },
  methods: {
    loadObjectives: function loadObjectives(start, end) {
      var _this = this;

      if (!this.loading) {
        this.loading = true;
        var data = {
          analysisType: this.selectedPeriod,
          year: this.selectedYear,
          start: start,
          end: end
        };
        var requests = [];
        for (var i = 0; i < this.objective_items.length; i++) {
          requests.push(this.axios.post('dashboard/' + this.objective_items[i], data));
        }

        this.axios.all(requests).then(this.axios.spread(function () {
          for (var _len = arguments.length, responses = Array(_len), _key = 0; _key < _len; _key++) {
            responses[_key] = arguments[_key];
          }

          for (var _i = 0; _i < _this.objective_items.length; _i++) {
            if (_this.objective_items[_i] === 'dealers/0') {
              _this.scorecard.dealers.ufs = responses[_i].data.data;
            } else if (_this.objective_items[_i] === 'dealers/1') {
              _this.scorecard.dealers.spreads = responses[_i].data.data;
            } else {
              _this.scorecard[_this.objective_items[_i]] = responses[_i].data.data;
            }
            _this.loading = false;
          }
        })).catch(function (errors) {
          _this.loading = false;
        });
      }
    }
  },
  created: function created() {
    var _this2 = this;

    var d = new Date();
    var m = d.getMonth();
    this.axios.get('dashboard/objectives').then(function (response) {
      _this2.monthOptions = response.data.data.months;
      _this2.selectedMonthStart = _this2.monthOptions[m].value;
      _this2.selectedMonthEnd = _this2.monthOptions[m].value;
      _this2.selectedYear = _this2.years[0].value;
    });
  }
});

/***/ }),
/* 823 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ObjectivesTable_vue__ = __webpack_require__(824);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_35bdc245_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_ObjectivesTable_vue__ = __webpack_require__(825);
var normalizeComponent = __webpack_require__(4)
/* script */

/* template */

/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ObjectivesTable_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_35bdc245_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_ObjectivesTable_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 824 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_perfect_scrollbar__ = __webpack_require__(401);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_perfect_scrollbar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue_perfect_scrollbar__);



/* harmony default export */ __webpack_exports__["a"] = ({
  props: ['items', 'loading', 'fields', 'table-caption', 'symbol', 'per-page', 'show-remaining'],
  components: {
    VuePerfectScrollbar: __WEBPACK_IMPORTED_MODULE_0_vue_perfect_scrollbar___default.a
  },
  data: function data() {
    return {
      totalPage: 1,
      currentPage: null
    };
  },

  methods: {},
  created: function created() {
    console.log('Remaining:', this.showRemaining);
  }
});

/***/ }),
/* 825 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mb-3"},[(_vm.loading)?_c('div',[_c('i',{staticClass:"fa fa-spinner fa-spin"})]):_vm._e(),_vm._v(" "),(!_vm.loading)?_c('div',[_c('div',{staticClass:"table-caption"},[_vm._v(_vm._s(_vm.tableCaption))]),_vm._v(" "),_c('VuePerfectScrollbar',{staticClass:"objetives-table-holder"},[_c('b-table',{attrs:{"sort-by":"label","responsive":"","stacked":"sm","fields":_vm.fields,"items":_vm.items,"per-page":_vm.perPage,"current-page":_vm.currentPage},scopedSlots:_vm._u([{key:"cell(label)",fn:function(data){return [(data.item.variant == 'success')?_c('i',{class:'fa fa-thumbs-up text-'+data.item.variant}):_vm._e(),_vm._v(" "),(data.item.variant != 'success')?_c('i',{class:'fa fa-thumbs-down text-'+data.item.variant}):_vm._e(),_vm._v(" "+_vm._s(data.item.label)+"\n      ")]}},{key:"cell(objective)",fn:function(data){return [_vm._v("\n        "+_vm._s(_vm._f("currency")(Math.round(data.item.objective),{fractionCount:0, symbol:_vm.symbol}))+"\n      ")]}},{key:"cell(total)",fn:function(data){return [_vm._v("\n        "+_vm._s(_vm._f("currency")(Math.round(data.item.total),{fractionCount:0, symbol:_vm.symbol}))+"\n      ")]}},{key:"cell(progress)",fn:function(data){return [_vm._v("\n        "+_vm._s(_vm._f("currency")(data.item.progress,{fractionCount:1, symbol:'%'}))+"\n      ")]}},{key:"cell(remaining)",fn:function(data){return [_vm._v("\n        "+_vm._s(_vm._f("currency")(data.item.remaining,{fractionCount:0, symbol:''}))+"\n      ")]}},{key:"cell(balance)",fn:function(data){return [_vm._v("\n        "+_vm._s(_vm._f("currency")(Math.round(data.item.objective - data.item.total),{fractionCount:0, symbol:''}))+"\n      ")]}}])})],1),_vm._v(" "),_c('b-pagination',{directives:[{name:"show",rawName:"v-show",value:(_vm.items.length>_vm.perPage && _vm.perPage>0),expression:"items.length>perPage && perPage>0"}],staticClass:"justify-content-center",attrs:{"total-rows":_vm.items.length,"per-page":_vm.perPage},model:{value:(_vm.totalPage),callback:function ($$v) {_vm.totalPage=$$v},expression:"totalPage"}})],1):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 826 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_EffectivenessTable_vue__ = __webpack_require__(827);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1bd97462_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_EffectivenessTable_vue__ = __webpack_require__(828);
var normalizeComponent = __webpack_require__(4)
/* script */

/* template */

/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_EffectivenessTable_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1bd97462_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_EffectivenessTable_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 827 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_perfect_scrollbar__ = __webpack_require__(401);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_perfect_scrollbar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue_perfect_scrollbar__);



/* harmony default export */ __webpack_exports__["a"] = ({
  props: ['items', 'fields', 'table-caption', 'symbol', 'per-page'],
  components: {
    VuePerfectScrollbar: __WEBPACK_IMPORTED_MODULE_0_vue_perfect_scrollbar___default.a
  },
  data: function data() {
    return {
      currentPage: 1
    };
  },

  methods: {}
});

/***/ }),
/* 828 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mb-3"},[_c('VuePerfectScrollbar',{staticClass:"team-table-holder"},[_c('b-table',{attrs:{"responsive":"","fields":_vm.fields,"items":_vm.items,"per-page":_vm.perPage,"current-page":_vm.currentPage},scopedSlots:_vm._u([{key:"team",fn:function(data){return [_vm._v("\n        "+_vm._s(data.item.team.name)+"\n      ")]}},{key:"visits",fn:function(data){return [_vm._v("\n        "+_vm._s(_vm._f("currency")(data.item.visits,{fractionCount:0, symbol:''}))+"\n      ")]}},{key:"sales",fn:function(data){return [_vm._v("\n        "+_vm._s(_vm._f("currency")(data.item.sales,{fractionCount:0, symbol:''}))+"\n      ")]}},{key:"effectiveness",fn:function(data){return [_vm._v("\n        "+_vm._s(_vm._f("currency")(data.item.effectiveness,{symbol:'%', symbolSpacing:false, symbolPosition:'back'}))+"\n      ")]}}])})],1),_vm._v(" "),_c('b-pagination',{directives:[{name:"show",rawName:"v-show",value:(_vm.items.length>_vm.perPage && _vm.perPage>0),expression:"items.length>perPage && perPage>0"}],staticClass:"justify-content-center",attrs:{"total-rows":_vm.items.length,"per-page":_vm.perPage},model:{value:(_vm.currentPage),callback:function ($$v) {_vm.currentPage=$$v},expression:"currentPage"}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 829 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"animated fadeIn mt-3 dashboard"},[(_vm.$auth.check(['dashboard.objectives']))?_c('b-card',{staticClass:"objective-cards",attrs:{"no-body":""}},[_c('b-card-header',[_vm._v("\n      Objectivos Sellout\n      "),_c('span',{staticClass:"float-right form-inline"},[_c('b-form-select',{staticClass:"mr-2",attrs:{"disabled":_vm.loading,"options":_vm.years,"size":"sm"},model:{value:(_vm.selectedYear),callback:function ($$v) {_vm.selectedYear=$$v},expression:"selectedYear"}}),_vm._v(" "),_c('b-form-select',{attrs:{"disabled":_vm.loading,"options":_vm.monthOptions,"size":"sm"},model:{value:(_vm.selectedMonthStart),callback:function ($$v) {_vm.selectedMonthStart=$$v},expression:"selectedMonthStart"}}),_vm._v(" a "),_c('b-form-select',{attrs:{"disabled":_vm.loading,"options":_vm.monthOptions,"size":"sm"},model:{value:(_vm.selectedMonthEnd),callback:function ($$v) {_vm.selectedMonthEnd=$$v},expression:"selectedMonthEnd"}})],1)]),_vm._v(" "),_c('b-card-body',[_c('b-row',[_c('b-col',{attrs:{"sm":"12","lg":"4","xl":"4"}},[_c('objectives-table',{attrs:{"loading":_vm.loading,"items":_vm.scorecard.sellout,"per-page":0,"fields":_vm.npsFields,"show-remaining":false,"table-caption":"NPS Categoria","symbol":"€"}})],1),_vm._v(" "),_c('b-col',{attrs:{"sm":"12","lg":"4","xl":"4"}},[_c('objectives-table',{attrs:{"loading":_vm.loading,"items":_vm.scorecard.operators,"per-page":0,"fields":_vm.operatorsFields,"show-remaining":false,"table-caption":"Operadores Categoria","symbol":""}})],1),_vm._v(" "),_c('b-col',{attrs:{"sm":"12","lg":"4","xl":"4"}},[_c('objectives-table',{attrs:{"loading":_vm.loading,"items":_vm.scorecard.sumtop10,"per-page":0,"fields":_vm.operatorsFields,"show-remaining":false,"table-caption":"SumTop10 Categoria","symbol":""}})],1)],1)],1)],1):_vm._e(),_vm._v(" "),(_vm.$auth.check(['dashboard.objectives']))?_c('b-card',{staticClass:"objective-cards",attrs:{"no-body":""}},[_c('b-card-header',[_vm._v("\n      Performance\n    ")]),_vm._v(" "),_c('b-card-body',[_c('b-row',[_c('b-col',{attrs:{"sm":"12","lg":"4","xl":"4"}},[_c('objectives-table',{attrs:{"loading":_vm.loading,"items":_vm.scorecard.dealers.ufs,"per-page":0,"fields":_vm.dealerFields,"show-remaining":false,"table-caption":"DESEMPENHO POR DISTRIBUIDOR UFS - NPS ","symbol":"€"}})],1),_vm._v(" "),_c('b-col',{attrs:{"sm":"12","lg":"4","xl":"4"}},[_c('objectives-table',{attrs:{"loading":_vm.loading,"items":_vm.scorecard.dealers.spreads,"per-page":0,"fields":_vm.dealerFields,"show-remaining":false,"table-caption":"DESEMPENHO POR DISTRIBUIDOR UPFIELD - NPS ","symbol":"€"}})],1),_vm._v(" "),_c('b-col',{attrs:{"sm":"12","lg":"4","xl":"4"}},[_c('objectives-table',{attrs:{"loading":_vm.loading,"items":_vm.scorecard.dealers_operators,"per-page":0,"fields":_vm.dealerOperatorsFields,"show-remaining":false,"table-caption":"DESEMPENHO POR DISTRIBUIDOR UFS + UPFIELD - OPERADORES ","symbol":""}})],1)],1)],1)],1):_vm._e(),_vm._v(" "),(_vm.$auth.check(['dashboard.objectives']))?_c('b-card',{staticClass:"objective-cards",attrs:{"no-body":""}},[_c('b-card-header',[_vm._v("\n      Sellin\n    ")]),_vm._v(" "),_c('b-card-body',[_c('b-row',[_c('b-col',{attrs:{"sm":"12","lg":"4","xl":"4"}},[_c('objectives-table',{attrs:{"loading":_vm.loading,"items":_vm.scorecard.sellin.niv,"per-page":0,"fields":_vm.npsFields,"show-remaining":false,"table-caption":"NIV CATEGORIA","symbol":"€"}})],1),_vm._v(" "),_c('b-col',{attrs:{"sm":"12","lg":"4","xl":"4"}},[_c('objectives-table',{attrs:{"loading":_vm.loading,"items":_vm.scorecard.sellin.turnover,"per-page":0,"fields":_vm.npsFields,"show-remaining":false,"table-caption":"TO CATEGORIA","symbol":"€"}})],1),_vm._v(" "),_c('b-col',{attrs:{"sm":"12","lg":"4","xl":"4"}},[_c('objectives-table',{attrs:{"loading":_vm.loading,"items":_vm.scorecard.sellin.top10,"per-page":0,"fields":_vm.npsFields,"show-remaining":false,"table-caption":"TOP10 NIV","symbol":"€"}})],1)],1)],1)],1):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 830 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Page404_vue__ = __webpack_require__(831);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_707ae2aa_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_Page404_vue__ = __webpack_require__(832);
var normalizeComponent = __webpack_require__(4)
/* script */

/* template */

/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Page404_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_707ae2aa_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_Page404_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 831 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'Page404'
});

/***/ }),
/* 832 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"app flex-row align-items-center"},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"row justify-content-center"},[_c('div',{staticClass:"col-md-6"},[_c('div',{staticClass:"clearfix"},[_c('h1',{staticClass:"float-left display-3 mr-4"},[_vm._v("404")]),_vm._v(" "),_c('h4',{staticClass:"pt-3"},[_vm._v("Oops! You're lost.")]),_vm._v(" "),_c('p',{staticClass:"text-muted"},[_vm._v("The page you are looking for was not found.")])]),_vm._v(" "),_c('div',{staticClass:"input-prepend input-group"},[_c('span',{staticClass:"input-group-addon"},[_c('i',{staticClass:"fa fa-search"})]),_vm._v(" "),_c('input',{staticClass:"form-control",attrs:{"id":"prependedInput","size":"16","type":"text","placeholder":"What are you looking for?"}}),_vm._v(" "),_c('span',{staticClass:"input-group-btn"},[_c('button',{staticClass:"btn btn-info",attrs:{"type":"button"}},[_vm._v("Search")])])])])])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 833 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Page500_vue__ = __webpack_require__(834);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b5ae8032_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_Page500_vue__ = __webpack_require__(835);
var normalizeComponent = __webpack_require__(4)
/* script */

/* template */

/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Page500_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b5ae8032_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_Page500_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 834 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'Page500'
});

/***/ }),
/* 835 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"app flex-row align-items-center"},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"row justify-content-center"},[_c('div',{staticClass:"col-md-6"},[_c('div',{staticClass:"clearfix"},[_c('h1',{staticClass:"float-left display-3 mr-4"},[_vm._v("500")]),_vm._v(" "),_c('h4',{staticClass:"pt-3"},[_vm._v("Houston, we have a problem!")]),_vm._v(" "),_c('p',{staticClass:"text-muted"},[_vm._v("The page you are looking for is temporarily unavailable.")])]),_vm._v(" "),_c('div',{staticClass:"input-prepend input-group"},[_c('span',{staticClass:"input-group-addon"},[_c('i',{staticClass:"fa fa-search"})]),_vm._v(" "),_c('input',{staticClass:"form-control",attrs:{"id":"prependedInput","size":"16","type":"text","placeholder":"What are you looking for?"}}),_vm._v(" "),_c('span',{staticClass:"input-group-btn"},[_c('button',{staticClass:"btn btn-info",attrs:{"type":"button"}},[_vm._v("Search")])])])])])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 836 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Login_vue__ = __webpack_require__(837);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_60b8980a_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_Login_vue__ = __webpack_require__(838);
var normalizeComponent = __webpack_require__(4)
/* script */

/* template */

/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Login_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_60b8980a_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_Login_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 837 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'Login',
  data: function data() {
    return {
      appName: 'DIM',
      working: false,
      username: '',
      password: ''
    };
  },

  methods: {
    doLogin: function doLogin(event) {
      this.working = true;
      event.preventDefault();
      var redirect = this.$auth.redirect();
      var redirectTo = { name: 'statistics.index' };
      if (redirect) {
        redirectTo = redirect.from;
      }
      this.$auth.login({
        data: {
          username: this.username,
          password: this.password
        },
        redirect: redirectTo,
        success: function success(response) {
          this.$toastr('success', 'Login efetuado com sucess');
        },
        error: function error(response) {
          this.working = false;
          console.log(response);
          this.$toastr('error', 'Nome de utilizador ou palavra-passe incorrectos');
        }
      });
    }
  },
  created: function created() {
    if (typeof Window.appConfig !== 'undefined' && Window.appConfig.name) {
      this.appName = Window.appConfig.name;
    }
  }
});

/***/ }),
/* 838 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"app flex-row align-items-center"},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"row justify-content-center"},[_c('div',{staticClass:"col-md-4"},[_c('div',{staticClass:"card-group mb-0"},[_c('div',{staticClass:"card p-4"},[_c('div',{staticClass:"card-body"},[_c('form',{attrs:{"action":"#"},on:{"submit":_vm.doLogin}},[_c('h3',[_vm._v(_vm._s(_vm.appName))]),_vm._v(" "),_c('p',{staticClass:"text-muted"},[_vm._v("Bem vindo ao "+_vm._s(_vm.appName)+", para aceder à sua conta utilize o formulário abaixo.")]),_vm._v(" "),_c('b-form-group',[_c('b-input-group',[_c('b-input-group-text',{attrs:{"slot":"prepend"},slot:"prepend"},[_c('i',{staticClass:"fa fa-user"})]),_vm._v(" "),_c('b-form-input',{attrs:{"name":"username","placeholder":"Nome de utilizador"},model:{value:(_vm.username),callback:function ($$v) {_vm.username=$$v},expression:"username"}})],1)],1),_vm._v(" "),_c('b-form-group',[_c('b-input-group',[_c('b-input-group-text',{attrs:{"slot":"prepend"},slot:"prepend"},[_c('i',{staticClass:"fa fa-key"})]),_vm._v(" "),_c('b-form-input',{attrs:{"type":"password","placeholder":"Palavra-passe"},model:{value:(_vm.password),callback:function ($$v) {_vm.password=$$v},expression:"password"}})],1)],1),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-6"},[_c('router-link',{attrs:{"to":{name: 'forgot-password'}}},[_vm._v("Esqueceu-se da palavra-passe?")])],1),_vm._v(" "),_c('div',{staticClass:"col-6 text-right"},[_c('button',{staticClass:"btn  btn-primary px-4",attrs:{"disabled":_vm.working,"type":"submit"}},[_vm._v("Login")])])])],1)])])])])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 839 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Forgot_vue__ = __webpack_require__(840);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0ef0cad2_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_Forgot_vue__ = __webpack_require__(841);
var normalizeComponent = __webpack_require__(4)
/* script */

/* template */

/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Forgot_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0ef0cad2_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_Forgot_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 840 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'Login',
  data: function data() {
    return {
      working: false,
      email: '',
      emailSent: false,
      showForm: true
    };
  },

  methods: {
    validateBeforeSubmit: function validateBeforeSubmit(evt) {
      var _this = this;

      evt.preventDefault();
      this.working = true;
      this.$validator.validateAll().then(function (result) {
        console.log('validation results:', result);
        if (result) {
          console.log('all fields ok. submit');
          _this.submit();
          return;
        }
        _this.working = false;
        _this.$toastr('error', 'Tem campos inválidos', 'Erro');
      });
    },
    submit: function submit() {
      var _this2 = this;

      this.axios.post('auth/sendreset', { email: this.email }).then(function (response) {
        _this2.emailSent = true;
        _this2.showForm = false;
      }).catch(function (response) {
        _this2.$toastr('error', 'Não foi possível enviar email de recuperação', 'Erro');
        _this2.working = false;
      });
    },
    validateState: function validateState(ref) {
      if (this.veeFields[ref] && (this.veeFields[ref].dirty || this.veeFields[ref].validated)) {
        return !this.errors.has(ref);
      }
      return null;
    }
  }
});

/***/ }),
/* 841 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"app flex-row align-items-center"},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"row justify-content-center"},[_c('div',{staticClass:"col-md-6"},[_c('div',{staticClass:"card-group mb-0"},[_c('div',{staticClass:"card p-4"},[_c('div',{staticClass:"card-body"},[(_vm.showForm)?_c('form',{attrs:{"action":"#"},on:{"submit":function($event){return _vm.validateBeforeSubmit($event,false)}}},[_c('h3',[_vm._v("Recuperar a palavra-passe?")]),_vm._v(" "),_c('p',{staticClass:"text-muted"},[_vm._v("Introduza o seu email para lhe enviar-mos um email para repor a palavra-passe")]),_vm._v(" "),_c('div',{staticClass:"input-group mb-3"},[_c('b-form-input',{directives:[{name:"validate",rawName:"v-validate",value:({ required: true, email:true }),expression:"{ required: true, email:true }"}],attrs:{"type":"email","name":"email","placeholder":"Email","state":_vm.validateState('email')},model:{value:(_vm.email),callback:function ($$v) {_vm.email=$$v},expression:"email"}}),_vm._v(" "),_c('b-form-invalid-feedback',[_vm._v("\n                    "+_vm._s(_vm.errors.first('email'))+"\n                  ")])],1),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-6"},[_c('router-link',{attrs:{"to":{name: 'login'}}},[_vm._v("Voltar ao login")])],1),_vm._v(" "),_c('div',{staticClass:"col-6 text-right"},[_c('button',{staticClass:"btn btn-primary px-4",attrs:{"disabled":_vm.working,"type":"submit"}},[_vm._v("Seguinte")])])])]):_vm._e(),_vm._v(" "),(!_vm.showForm)?_c('div',[_c('h2',[_vm._v("Recuperar a palavra-passe?")]),_vm._v(" "),(_vm.emailSent)?_c('p',[_vm._v("Foi-lhe enviado um email para recuperar a palavra-passe"),_c('br'),_vm._v(" "),_c('router-link',{attrs:{"to":{name: 'login'}}},[_vm._v("Voltar ao login")])],1):_vm._e(),_vm._v(" "),(!_vm.emailSent)?_c('p',[_vm._v("Este email não está registado")]):_vm._e()]):_vm._e()])])])])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 842 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ResetPassword_vue__ = __webpack_require__(843);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_19cc57aa_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_ResetPassword_vue__ = __webpack_require__(844);
var normalizeComponent = __webpack_require__(4)
/* script */

/* template */

/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ResetPassword_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_19cc57aa_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_ResetPassword_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 843 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'ResetPassword',
  data: function data() {
    return {
      resetSuccess: false,
      working: false,
      item: {
        password: '',
        password_confirmation: '',
        token: '',
        email: ''
      }
    };
  },

  computed: {
    passwordRequired: function passwordRequired() {
      return this.item.password.length > 0 && !this.errors.has('password');
    }
  },
  methods: {
    validateBeforeSubmit: function validateBeforeSubmit(evt) {
      var _this = this;

      evt.preventDefault();
      console.log('check validation');
      this.$validator.validateAll().then(function (result) {
        console.log('validation results:', result);
        if (result) {
          console.log('all fields ok. submit');
          _this.submit();
          return;
        }
        _this.$toastr('error', 'Tem campos inválidos', 'Erro');
      });
    },
    submit: function submit() {
      var _this2 = this;

      var data = this.item;
      this.axios.post('auth/reset', data).then(function (response) {
        _this2.resetSuccess = true;
      }).catch(function (response) {
        _this2.$toastr('error', response.data.message, 'Erro');
      });
    },
    validateState: function validateState(ref) {
      if (this.veeFields[ref] && (this.veeFields[ref].dirty || this.veeFields[ref].validated)) {
        return !this.errors.has(ref);
      }
      return null;
    }
  },
  created: function created() {
    if (typeof this.$route.params.token === 'undefined' || !this.$route.params.token) {
      this.$router.push({ name: 'login' });
    }
    this.item.token = this.$route.params.token;
  }
});

/***/ }),
/* 844 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"app flex-row align-items-center"},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"row justify-content-center"},[_c('div',{staticClass:"col-md-6"},[_c('div',{staticClass:"card-group mb-0"},[_c('div',{staticClass:"card p-4"},[_c('div',{staticClass:"card-body"},[(!_vm.resetSuccess)?_c('form',{attrs:{"action":"#"},on:{"submit":function($event){return _vm.validateBeforeSubmit($event,false)}}},[_c('h3',[_vm._v("Nova palavra-passe")]),_vm._v(" "),_c('p',{staticClass:"text-muted"},[_vm._v("Para completar o processo, preencha o formulário abaixo")]),_vm._v(" "),_c('b-form-fieldset',{attrs:{"label":"Email"}},[_c('b-form-input',{directives:[{name:"validate",rawName:"v-validate",value:({ required: true, email:true }),expression:"{ required: true, email:true }"}],attrs:{"type":"email","name":"email","placeholder":"Email","state":_vm.validateState('email')},model:{value:(_vm.item.email),callback:function ($$v) {_vm.$set(_vm.item, "email", $$v)},expression:"item.email"}}),_vm._v(" "),_c('b-form-invalid-feedback',[_vm._v("\n                    "+_vm._s(_vm.errors.first('email'))+"\n                  ")])],1),_vm._v(" "),_c('b-form-fieldset',{attrs:{"label":"Palavra-passe"}},[_c('b-form-input',{directives:[{name:"validate",rawName:"v-validate",value:({required:true, min: 8}),expression:"{required:true, min: 8}"}],ref:"password",attrs:{"type":"password","name":"password","placeholder":"Palavra-passe","state":_vm.validateState('password'),"data-vv-validate-on":"change"},model:{value:(_vm.item.password),callback:function ($$v) {_vm.$set(_vm.item, "password", $$v)},expression:"item.password"}}),_vm._v(" "),_c('b-form-invalid-feedback',[_vm._v("\n                    "+_vm._s(_vm.errors.first('password'))+"\n                  ")])],1),_vm._v(" "),_c('b-form-fieldset',{attrs:{"label":"Confirme a palavra-passe"}},[_c('b-form-input',{directives:[{name:"validate",rawName:"v-validate",value:({confirmed: 'password', required:_vm.passwordRequired}),expression:"{confirmed: 'password', required:passwordRequired}"}],attrs:{"type":"password","name":"password_confirmation","placeholder":"Confirme a palavra-passe","state":_vm.validateState('password_confirmation'),"data-vv-validate-on":"change"},model:{value:(_vm.item.password_confirmation),callback:function ($$v) {_vm.$set(_vm.item, "password_confirmation", $$v)},expression:"item.password_confirmation"}}),_vm._v(" "),_c('b-form-invalid-feedback',[_vm._v("\n                    "+_vm._s(_vm.errors.first('password_confirmation'))+"\n                  ")])],1),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12 text-right"},[_c('button',{staticClass:"btn btn-primary px-4",attrs:{"disabled":_vm.working,"type":"submit"}},[_vm._v("Alterar palavra-passe")])])])],1):_vm._e(),_vm._v(" "),(_vm.resetSuccess)?_c('div',[_c('h3',[_vm._v("Nova palavra-passe")]),_vm._v(" "),_c('p',[_vm._v("A sua palavra-passe foi alterada com sucesso.")]),_vm._v(" "),_c('b-button',{attrs:{"variant":"primary","to":{name:'login'}}},[_vm._v("Continuar")])],1):_vm._e()])])])])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 845 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_UsersGrid_vue__ = __webpack_require__(846);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5d5a5253_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_UsersGrid_vue__ = __webpack_require__(847);
var normalizeComponent = __webpack_require__(4)
/* script */

/* template */

/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_UsersGrid_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5d5a5253_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_UsersGrid_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 846 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Grid_vue__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__router__ = __webpack_require__(94);





/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'UsersGrid',
  components: {
    Grid: __WEBPACK_IMPORTED_MODULE_0__components_Grid_vue__["a" /* default */]
  },
  data: function data() {
    return {
      schemaModelFields: {
        'created_at': {
          type: 'date'
        }
      },
      url: 'admin/users',
      columns: [{
        template: this.getBtnTemplate,
        title: '',
        width: '180px'
      }, {
        field: 'id',
        title: 'Id',
        width: '120px'
      }, {
        field: 'name',
        title: 'Nome'
      }, {
        field: 'email',
        title: 'Email'
      }, {
        field: 'created_at',
        title: 'Criado em',
        format: '{0:dd/MM/yyyy HH:mm}',
        type: 'date',
        width: '180px',
        filterable: {
          ui: function ui(element) {
            element.kendoDateTimePicker({
              format: 'dd/MM/yyyy HH:mm'
            });
          }
        }
      }]
    };
  },

  methods: {
    getBtnTemplate: function getBtnTemplate(item) {
      var route = __WEBPACK_IMPORTED_MODULE_1__router__["a" /* default */].resolve({
        name: 'users.edit',
        params: {
          id: item.id
        }
      });
      if (this.$auth.check('roles.edit')) {
        return '<a href="' + route.href + '" class="btn btn-primary" ><i class="fa fa-pencil"></i> editar</a>';
      }
      return '';
    }
  }
});

/***/ }),
/* 847 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('b-card',[_c('div',{staticClass:"text-right mb-3"},[_c('router-link',{staticClass:"btn btn-primary",attrs:{"to":{name:'users.create'}}},[_c('i',{staticClass:"fa fa-plus"}),_vm._v(" Criar")])],1),_vm._v(" "),_c('Grid',{attrs:{"name":"usersGrid","url":_vm.url,"columns":_vm.columns,"pageable":true,"filterable":true,"sortable":true,"schemaModelFields":_vm.schemaModelFields}})],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 848 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_UsersEdit_vue__ = __webpack_require__(849);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ac3b99d2_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_UsersEdit_vue__ = __webpack_require__(853);
var normalizeComponent = __webpack_require__(4)
/* script */

/* template */

/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_UsersEdit_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ac3b99d2_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_UsersEdit_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 849 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__TeamMembers_vue__ = __webpack_require__(850);



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'UsersEdit',
  props: ['id'],
  components: { TeamMembers: __WEBPACK_IMPORTED_MODULE_0__TeamMembers_vue__["a" /* default */] },
  data: function data() {
    return {
      showTeam: false,
      showPassword: false,
      item: {
        name: '',
        password: '',
        password_confirmation: '',
        state: 1,
        sendEmail: null,
        roles: [],
        salesteam: { data: [] }
      },
      roles: [],
      passwordSize: 12,
      characters: 'a-z,A-Z,0-9,#'
    };
  },

  computed: {
    passwordRequired: function passwordRequired() {
      return !this.item.id;
    },
    confirmPasswordRequired: function confirmPasswordRequired() {
      return this.item.password.length > 0;
    }
  },
  methods: {
    selectTeamMembers: function selectTeamMembers(e) {
      this.item.salesteam.data.push({ id: e.item.id, name: e.item.name });
    },
    showTeamModal: function showTeamModal() {
      this.$refs.teamMembersModal.show();
    },
    hideTeamModal: function hideTeamModal() {
      this.$refs.teamMembersModal.hide();
    },
    removeTeamMember: function removeTeamMember(index) {
      this.item.salesteam.data.splice(index, 1);
    },
    toggleViewPassword: function toggleViewPassword() {
      this.showPassword = !this.showPassword;
    },
    validateBeforeSubmit: function validateBeforeSubmit(evt, close) {
      var _this = this;

      evt.preventDefault();
      console.log('check validation');
      this.$validator.validateAll().then(function (result) {
        console.log('validation results:', result);
        if (result) {
          console.log('all fields ok. submit');
          _this.submit(evt, close);
          return;
        }
        _this.$toastr('error', 'Tem campos inválidos', 'Erro');
      });
    },
    validateState: function validateState(ref) {
      if (this.veeFields[ref] && (this.veeFields[ref].dirty || this.veeFields[ref].validated)) {
        return !this.errors.has(ref);
      }
      return null;
    },
    submit: function submit(e, close) {
      var _this2 = this;

      e.preventDefault();
      var data = {
        data: this.item
      };
      if (this.item.id) {
        this.axios.put('admin/users' + '/' + this.item.id, data).then(function (response) {
          _this2.item = response.data.data;
          _this2.$toastr('success', 'item gravado com sucesso', 'Gravado');
          if (close) {
            _this2.$router.push({
              name: 'users.index'
            });
          }
        }).catch(function (response) {
          _this2.$toastr('error', 'Não foi possivel gravar', 'Erro');
        });
      } else {
        this.axios.post('admin/users', data).then(function (response) {
          _this2.item = response.data.data;
          _this2.$toastr('success', 'item gravado com sucesso', 'Gravado');
          _this2.$router.push({
            name: 'users.edit',
            params: {
              id: _this2.item.id
            }
          });
        }).catch(function (response) {
          _this2.$toastr('error', 'Não foi possivel gravar', 'Erro');
        });
      }
    },
    generate: function generate() {
      var charactersArray = this.characters.split(',');
      var CharacterSet = '';
      var password = '';

      if (charactersArray.indexOf('a-z') >= 0) {
        CharacterSet += 'abcdefghijklmnopqrstuvwxyz';
      }
      if (charactersArray.indexOf('A-Z') >= 0) {
        CharacterSet += 'ABCDEFGHIJKLMNOPQRSTUVWXYZ';
      }
      if (charactersArray.indexOf('0-9') >= 0) {
        CharacterSet += '0123456789';
      }
      if (charactersArray.indexOf('#') >= 0) {
        CharacterSet += '![]{}()%&*$#^<>~@|';
      }

      for (var i = 0; i < this.passwordSize; i++) {
        password += CharacterSet.charAt(Math.floor(Math.random() * CharacterSet.length));
      }
      this.item.password = password;
      this.item.password_confirmation = password;
      this.showPassword = true;
    }
  },
  created: function created() {
    var _this3 = this;

    var id = this.$route.params.id;
    if (typeof id !== 'undefined') {
      this.axios.get('admin/users' + '/' + id).then(function (response) {
        _this3.item = response.data.data;
      }).catch(function (response) {
        _this3.$toastr('error', 'Este utilizador não existe', 'Erro');
        _this3.$router.push({
          name: 'users.index'
        });
      });
    } else {
      this.item.sendEmail = 1;
    }
    this.axios.get('admin/roles/lst').then(function (response) {
      _this3.roles = response.data.data;
    });
  }
});

/***/ }),
/* 850 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TeamMembers_vue__ = __webpack_require__(851);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4e5e1ea1_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_TeamMembers_vue__ = __webpack_require__(852);
var normalizeComponent = __webpack_require__(4)
/* script */

/* template */

/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TeamMembers_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4e5e1ea1_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_TeamMembers_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 851 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Grid_vue__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__progress_kendo_ui_js_kendo_all_js__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__progress_kendo_ui_js_kendo_all_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__progress_kendo_ui_js_kendo_all_js__);




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'Client',
  props: ['height'],
  components: {
    Grid: __WEBPACK_IMPORTED_MODULE_0__components_Grid_vue__["a" /* default */]
  },
  data: function data() {
    return {
      preload: [],
      schemaModelFields: {},
      url: 'admin/team',
      columns: [{
        'title': '',
        width: '120px',
        command: {
          'className': 'btn btn-success',
          text: 'Adicionar',
          click: this.addTeamMember
        }
      }, {
        field: 'code',
        title: 'Code'
      }, {
        field: 'name',
        title: 'Name'
      }],
      loaded: false,
      tableInitialized: false,
      variables: [],
      rows: [],
      subrows: [],
      filters: [],
      tables: []
    };
  },

  methods: {
    addTeamMember: function addTeamMember(e) {
      e.preventDefault();
      var grid = this.$refs.userQueriesGrid.$refs.mygrid.kendoWidget();
      var dataItem = grid.dataItem(__WEBPACK_IMPORTED_MODULE_1__progress_kendo_ui_js_kendo_all_js___default.a.jQuery(e.currentTarget).closest('tr'));
      this.$emit('select-member', {
        item: dataItem
      });
    }
  }
});

/***/ }),
/* 852 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('Grid',{ref:"userQueriesGrid",attrs:{"name":"userQueriesGrid","url":_vm.url,"columns":_vm.columns,"pageable":true,"height":_vm.height,"filterable":true,"sortable":true,"schemaModelFields":_vm.schemaModelFields,"preload":_vm.preload}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 853 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"animated fadeIn mt-5"},[_c('form',{attrs:{"enctype":"multipart/form-data"},on:{"submit":function($event){return _vm.validateBeforeSubmit($event,false)}}},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-6"},[_c('b-card',[_c('div',{attrs:{"slot":"header"},slot:"header"},[_c('strong',[_vm._v("Item")])]),_vm._v(" "),_c('b-form-fieldset',{attrs:{"label":"Nome"}},[_c('b-form-input',{directives:[{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],attrs:{"type":"text","name":"name","placeholder":"Nome","state":_vm.validateState('name')},model:{value:(_vm.item.name),callback:function ($$v) {_vm.$set(_vm.item, "name", $$v)},expression:"item.name"}}),_vm._v(" "),_c('b-form-invalid-feedback',[_vm._v("\n              "+_vm._s(_vm.errors.first('name'))+"\n            ")])],1),_vm._v(" "),_c('b-form-fieldset',{attrs:{"label":"Email"}},[_c('b-form-input',{directives:[{name:"validate",rawName:"v-validate",value:({ required: true, email:true, uniqueemail: _vm.item.id }),expression:"{ required: true, email:true, uniqueemail: item.id }"}],attrs:{"type":"email","name":"email","placeholder":"Email","state":_vm.validateState('email'),"data-vv-validate-on":"change"},model:{value:(_vm.item.email),callback:function ($$v) {_vm.$set(_vm.item, "email", $$v)},expression:"item.email"}}),_vm._v(" "),_c('b-form-invalid-feedback',[_vm._v("\n              "+_vm._s(_vm.errors.first('email'))+"\n            ")])],1),_vm._v(" "),_c('b-form-fieldset',{attrs:{"label":"Código UFS"}},[_c('b-form-input',{directives:[{name:"validate",rawName:"v-validate",value:({  }),expression:"{  }"}],attrs:{"id":"ufs_code","type":"text","name":"ufs_code","placeholder":"Código UFS","state":_vm.validateState('ufs_code'),"data-vv-validate-on":"change"},model:{value:(_vm.item.ufs_code),callback:function ($$v) {_vm.$set(_vm.item, "ufs_code", $$v)},expression:"item.ufs_code"}}),_vm._v(" "),_c('b-form-invalid-feedback',[_vm._v("\n              "+_vm._s(_vm.errors.first('ufs_code'))+"\n            ")])],1),_vm._v(" "),_c('b-form-fieldset',{attrs:{"label":"Nome de utilizador"}},[_c('b-form-input',{directives:[{name:"validate",rawName:"v-validate",value:({ username: _vm.item.id, required: true, min:5 }),expression:"{ username: item.id, required: true, min:5 }"}],attrs:{"id":"itemName","type":"text","name":"username","placeholder":"Nome de utilizador","state":_vm.validateState('username'),"data-vv-validate-on":"change"},model:{value:(_vm.item.username),callback:function ($$v) {_vm.$set(_vm.item, "username", $$v)},expression:"item.username"}}),_vm._v(" "),_c('b-form-invalid-feedback',[_vm._v("\n              "+_vm._s(_vm.errors.first('username'))+"\n            ")])],1),_vm._v(" "),_c('b-form-fieldset',{attrs:{"label":"Palavra-passe"}},[_c('b-input-group',[_c('b-form-input',{directives:[{name:"validate",rawName:"v-validate",value:({min: 8, required:_vm.passwordRequired}),expression:"{min: 8, required:passwordRequired}"}],ref:"password",attrs:{"type":!_vm.showPassword?'password':'text',"name":"password","placeholder":"Palavra-passe","state":_vm.validateState('password')},model:{value:(_vm.item.password),callback:function ($$v) {_vm.$set(_vm.item, "password", $$v)},expression:"item.password"}}),_vm._v(" "),_c('b-input-group-append',[_c('b-button',{on:{"click":function($event){return _vm.toggleViewPassword()}}},[_c('i',{staticClass:"fa",class:{'fa-eye':!_vm.showPassword, 'fa-eye-slash':_vm.showPassword}})]),_vm._v(" "),_c('b-button',{attrs:{"variant":"info"},on:{"click":function($event){return _vm.generate()}}},[_vm._v("Gerar palavra-passe "+_vm._s(_vm.passwordRequired))])],1),_vm._v(" "),_c('b-form-invalid-feedback',[_vm._v("\n                "+_vm._s(_vm.errors.first('password'))+"\n              ")])],1)],1),_vm._v(" "),_c('b-form-fieldset',{attrs:{"label":"Confirme a palavra-passe"}},[_c('b-form-input',{directives:[{name:"validate",rawName:"v-validate",value:({confirmed: 'password', required:_vm.confirmPasswordRequired}),expression:"{confirmed: 'password', required:confirmPasswordRequired}"}],attrs:{"type":!_vm.showPassword?'password':'text',"name":"password_confirmation","state":_vm.validateState('password_confirmation'),"placeholder":"Confirme a palavra-passe"},model:{value:(_vm.item.password_confirmation),callback:function ($$v) {_vm.$set(_vm.item, "password_confirmation", $$v)},expression:"item.password_confirmation"}}),_vm._v(" "),_c('b-form-invalid-feedback',[_vm._v("\n              "+_vm._s(_vm.errors.first('password_confirmation'))+"\n            ")])],1),_vm._v(" "),_c('div',{attrs:{"slot":"footer"},slot:"footer"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-3"},[_c('router-link',{attrs:{"to":{name:'users.index'},"size":"sm","variant":"danger"}},[_c('i',{staticClass:"fa fa-ban"}),_vm._v(" Cancelar")])],1),_vm._v(" "),_c('div',{staticClass:"col-sm-9 text-right"},[_c('b-button',{attrs:{"type":"submit","size":"sm","variant":"primary"}},[_c('i',{staticClass:"fa fa-save"}),_vm._v(" Gravar")]),_vm._v(" "),_c('b-button',{attrs:{"type":"button","size":"sm","variant":"primary"},on:{"click":function($event){return _vm.validateBeforeSubmit($event,true)}}},[_c('i',{staticClass:"fa fa-save"}),_vm._v(" Gravar e fechar")])],1)])])],1)],1),_vm._v(" "),_c('div',{staticClass:"col-md-3"},[_c('b-card',[_c('div',{attrs:{"slot":"header"},slot:"header"},[_c('strong',[_vm._v("Estado")])]),_vm._v(" "),_c('b-form-fieldset',{attrs:{"label":"Estado"}},[_c('b-form-select',{staticClass:"mb-3",model:{value:(_vm.item.state),callback:function ($$v) {_vm.$set(_vm.item, "state", $$v)},expression:"item.state"}},[_c('option',{attrs:{"value":"0"}},[_vm._v("Bloqueado")]),_vm._v(" "),_c('option',{attrs:{"value":"1"}},[_vm._v("Activo")])])],1),_vm._v(" "),(!_vm.item.id)?_c('b-form-fieldset',{attrs:{"label":"Enviar email de boas vindas"}},[_c('b-form-select',{staticClass:"mb-3",model:{value:(_vm.item.sendEmail),callback:function ($$v) {_vm.$set(_vm.item, "sendEmail", $$v)},expression:"item.sendEmail"}},[_c('option',{domProps:{"value":null}},[_vm._v("Escolha uma opção")]),_vm._v(" "),_c('option',{attrs:{"value":"0"}},[_vm._v("Não")]),_vm._v(" "),_c('option',{attrs:{"value":"1"}},[_vm._v("Sim")])])],1):_vm._e()],1),_vm._v(" "),_c('b-card',[_c('div',{attrs:{"slot":"header"},slot:"header"},[_c('strong',[_vm._v("Grupos")])]),_vm._v(" "),_c('b-form-checkbox-group',{attrs:{"id":"roles","name":"roles"},model:{value:(_vm.item.roles_list),callback:function ($$v) {_vm.$set(_vm.item, "roles_list", $$v)},expression:"item.roles_list"}},_vm._l((_vm.roles),function(role){return _c('div',{key:role.id},[_c('b-form-checkbox',{attrs:{"value":role.id}},[_vm._v(_vm._s(role.name))])],1)}),0)],1)],1)])]),_vm._v(" "),_c('b-modal',{ref:"teamMembersModal",attrs:{"size":"lg","id":"teamMembersModal"},on:{"shown":function($event){_vm.showTeam=true},"hidden":function($event){_vm.showTeam=false}}},[(_vm.showTeam)?_c('team-members',{attrs:{"height":"400"},on:{"select-member":_vm.selectTeamMembers}}):_vm._e()],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 854 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Profile_vue__ = __webpack_require__(855);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_443eec4e_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_Profile_vue__ = __webpack_require__(856);
var normalizeComponent = __webpack_require__(4)
/* script */

/* template */

/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Profile_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_443eec4e_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_Profile_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 855 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'Profile',
  data: function data() {
    return {
      preloadDone: false,
      item: {
        name: '',
        password_confirm: '',
        password: ''
      },
      roles: []
    };
  },

  computed: {
    passwordRequired: function passwordRequired() {
      return this.item.password.length > 0;
    }
  },
  methods: {
    submit: function submit(e, close) {
      var _this = this;

      var data = {
        data: this.item
      };
      this.axios.put('users/profile', data).then(function (response) {
        _this.item = response.data.data;
        _this.$toastr('success', 'perfil atualizado com sucesso', 'Gravado');
        if (close) {
          _this.$router.push({
            name: 'dashboard'
          });
        }
      }).catch(function (response) {
        _this.$toastr('error', 'Não foi possivel gravar', 'Erro');
      });
    },
    validateBeforeSubmit: function validateBeforeSubmit(evt, close) {
      var _this2 = this;

      evt.preventDefault();
      console.log('check validation');
      this.$validator.validateAll().then(function (result) {
        console.log('validation results:', result);
        if (result) {
          console.log('all fields ok. submit');
          _this2.submit(evt, close);
          return;
        }
        _this2.$toastr('error', 'Tem campos inválidos', 'Erro');
      });
    },
    validateState: function validateState(ref) {
      if (this.veeFields[ref] && (this.veeFields[ref].dirty || this.veeFields[ref].validated)) {
        return !this.errors.has(ref);
      }
      return null;
    }
  },
  created: function created() {
    var _this3 = this;

    this.axios.get('users/profile').then(function (response) {
      _this3.item = response.data.data;
      _this3.preloadDone = true;
    }).catch(function (response) {
      _this3.$toastr('error', 'Este utilizador não existe', 'Erro');
      _this3.$router.push({
        name: 'dashboard'
      });
    });
  }
});

/***/ }),
/* 856 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"animated fadeIn"},[(!_vm.preloadDone)?_c('div',{staticClass:"splash"},[_vm._m(0)]):_vm._e(),_vm._v(" "),(_vm.preloadDone)?_c('form',{attrs:{"enctype":"multipart/form-data","novalidate":""},on:{"submit":function($event){return _vm.validateBeforeSubmit($event,false)}}},[_c('div',{staticClass:"row justify-content-md-center mt-5"},[_c('div',{staticClass:"col-md-4"},[_c('b-card',[_c('div',{attrs:{"slot":"header"},slot:"header"},[_c('strong',[_vm._v("Dados de utilizador")])]),_vm._v(" "),_c('b-form-fieldset',{attrs:{"label":"Nome"}},[_c('b-form-input',{directives:[{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],attrs:{"type":"text","name":"name","placeholder":"Nome","state":_vm.validateState('name')},model:{value:(_vm.item.name),callback:function ($$v) {_vm.$set(_vm.item, "name", $$v)},expression:"item.name"}}),_vm._v(" "),_c('b-form-invalid-feedback',[_vm._v("\n              "+_vm._s(_vm.errors.first('name'))+"\n            ")])],1),_vm._v(" "),_c('b-form-fieldset',{attrs:{"label":"Email"}},[_c('b-form-input',{directives:[{name:"validate",rawName:"v-validate",value:({ required: true, email:true, uniqueemail: _vm.item.id }),expression:"{ required: true, email:true, uniqueemail: item.id }"}],attrs:{"type":"email","name":"email","placeholder":"Email","state":_vm.validateState('email'),"data-vv-validate-on":"change"},model:{value:(_vm.item.email),callback:function ($$v) {_vm.$set(_vm.item, "email", $$v)},expression:"item.email"}}),_vm._v(" "),_c('b-form-invalid-feedback',[_vm._v("\n              "+_vm._s(_vm.errors.first('email'))+"\n            ")])],1),_vm._v(" "),_c('b-form-fieldset',{attrs:{"label":"Nome de utilizador"}},[_c('b-form-input',{directives:[{name:"validate",rawName:"v-validate",value:({ username: _vm.item.id, required: true, min:5 }),expression:"{ username: item.id, required: true, min:5 }"}],attrs:{"id":"itemName","type":"text","name":"username","placeholder":"Nome de utilizador","state":_vm.validateState('username'),"data-vv-validate-on":"change"},model:{value:(_vm.item.username),callback:function ($$v) {_vm.$set(_vm.item, "username", $$v)},expression:"item.username"}}),_vm._v(" "),_c('b-form-invalid-feedback',[_vm._v("\n              "+_vm._s(_vm.errors.first('username'))+"\n            ")])],1),_vm._v(" "),_c('b-form-fieldset',{attrs:{"label":"Palavra-passe"}},[_c('b-form-input',{directives:[{name:"validate",rawName:"v-validate",value:({min: 8}),expression:"{min: 8}"}],ref:"password",attrs:{"type":"password","name":"password","placeholder":"Palavra-passe","state":_vm.validateState('password')},model:{value:(_vm.item.password),callback:function ($$v) {_vm.$set(_vm.item, "password", $$v)},expression:"item.password"}}),_vm._v(" "),_c('b-form-invalid-feedback',[_vm._v("\n              "+_vm._s(_vm.errors.first('password'))+"\n            ")])],1),_vm._v(" "),_c('b-form-fieldset',{attrs:{"label":"Confirme a palavra-passe"}},[_c('b-form-input',{directives:[{name:"validate",rawName:"v-validate",value:({confirmed: 'password', required:_vm.passwordRequired}),expression:"{confirmed: 'password', required:passwordRequired}"}],attrs:{"type":"password","name":"password_confirm","placeholder":"Confirme a palavra-passe","state":_vm.validateState('password_confirm')},model:{value:(_vm.item.password_confirm),callback:function ($$v) {_vm.$set(_vm.item, "password_confirm", $$v)},expression:"item.password_confirm"}}),_vm._v(" "),_c('b-form-invalid-feedback',[_vm._v("\n              "+_vm._s(_vm.errors.first('password_confirm'))+"\n            ")])],1),_vm._v(" "),_c('div',{attrs:{"slot":"footer"},slot:"footer"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-3"},[_c('router-link',{attrs:{"to":{name:'dashboard'},"size":"sm","variant":"danger"}},[_c('i',{staticClass:"fa fa-ban"}),_vm._v(" Cancelar")])],1),_vm._v(" "),_c('div',{staticClass:"col-sm-9 text-right"},[_c('b-button',{attrs:{"type":"submit","size":"sm","variant":"primary"}},[_c('i',{staticClass:"fa fa-save"}),_vm._v(" Gravar")]),_vm._v(" "),_c('b-button',{attrs:{"type":"button","size":"sm","variant":"primary"},on:{"click":function($event){return _vm.validateBeforeSubmit($event,true)}}},[_c('i',{staticClass:"fa fa-save"}),_vm._v(" Gravar e fechar")])],1)])])],1)],1)])]):_vm._e()])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container  d-flex h-100"},[_c('div',{staticClass:"row justify-content-center text-primary w-100 align-self-center text-white"},[_c('i',{staticClass:"fa fa-spin fa-spinner"})])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 857 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_grid_vue__ = __webpack_require__(858);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3ce9af88_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_grid_vue__ = __webpack_require__(859);
var normalizeComponent = __webpack_require__(4)
/* script */

/* template */

/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_grid_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3ce9af88_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_grid_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 858 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Grid_vue__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__router__ = __webpack_require__(94);





/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'RolesGrid',
  components: {
    Grid: __WEBPACK_IMPORTED_MODULE_0__components_Grid_vue__["a" /* default */]
  },
  data: function data() {
    return {
      schemaModelFields: {
        'created_at': {
          type: 'date'
        }
      },
      url: 'admin/roles',
      columns: [{
        template: this.getBtnTemplate,
        title: '',
        width: '180px'
      }, {
        field: 'id',
        title: 'Id',
        width: '120px'
      }, {
        field: 'display_name',
        title: 'Nome'
      }, {
        field: 'created_at',
        title: 'Criado em',
        format: '{0:dd/MM/yyyy HH:mm}',
        type: 'date',
        width: '180px',
        filterable: {
          ui: function ui(element) {
            element.kendoDateTimePicker({
              format: 'dd/MM/yyyy HH:mm'
            });
          }
        }
      }]
    };
  },

  methods: {
    getBtnTemplate: function getBtnTemplate(item) {
      var route = __WEBPACK_IMPORTED_MODULE_1__router__["a" /* default */].resolve({
        name: 'roles.edit',
        params: {
          id: item.id
        }
      });
      return '<a href="' + route.href + '" class="btn btn-primary" ><i class="fa fa-pencil"></i> editar</a>';
    }
  }
});

/***/ }),
/* 859 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('b-card',[_c('div',{staticClass:"text-right mb-3"},[_c('router-link',{staticClass:"btn btn-primary",attrs:{"to":{name:'roles.create'}}},[_c('i',{staticClass:"fa fa-plus"}),_vm._v(" Criar")])],1),_vm._v(" "),_c('Grid',{attrs:{"name":"rolesGrid","url":_vm.url,"columns":_vm.columns,"pageable":true,"filterable":true,"sortable":true,"schemaModelFields":_vm.schemaModelFields}})],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 860 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_edit_vue__ = __webpack_require__(861);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2e130900_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_edit_vue__ = __webpack_require__(862);
var normalizeComponent = __webpack_require__(4)
/* script */

/* template */

/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_edit_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2e130900_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_edit_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 861 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'UsersEdit',
  props: ['id'],
  data: function data() {
    return {
      showTeam: false,
      showPassword: false,
      item: {
        name: '',
        display_name: '',
        product_categories: []
      },
      permissionGroups: [],
      mpg_list: []
    };
  },

  methods: {
    validateBeforeSubmit: function validateBeforeSubmit(evt, close) {
      var _this = this;

      evt.preventDefault();
      console.log('check validation');
      this.$validator.validateAll().then(function (result) {
        console.log('validation results:', result);
        if (result) {
          console.log('all fields ok. submit');
          _this.submit(evt, close);
          return;
        }
        _this.$toastr('error', 'Tem campos inválidos', 'Erro');
      });
    },
    validateState: function validateState(ref) {
      if (this.veeFields[ref] && (this.veeFields[ref].dirty || this.veeFields[ref].validated)) {
        return !this.errors.has(ref);
      }
      return null;
    },
    submit: function submit(e, close) {
      var _this2 = this;

      e.preventDefault();
      var data = {
        data: this.item
      };
      if (this.item.id) {
        this.axios.put('admin/roles' + '/' + this.item.id, data).then(function (response) {
          _this2.item = response.data.data;
          _this2.$toastr('success', 'item gravado com sucesso', 'Gravado');
          if (close) {
            _this2.$router.push({
              name: 'roles.index'
            });
          }
        }).catch(function (response) {
          _this2.$toastr('error', 'Não foi possivel gravar', 'Erro');
        });
      } else {
        this.axios.post('admin/roles', data).then(function (response) {
          _this2.item = response.data.data;
          _this2.$toastr('success', 'item gravado com sucesso', 'Gravado');
          _this2.$router.push({
            name: 'roles.edit',
            params: {
              id: _this2.item.id
            }
          });
        }).catch(function (response) {
          _this2.$toastr('error', 'Não foi possivel gravar', 'Erro');
        });
      }
    }
  },
  created: function created() {
    var _this3 = this;

    var id = this.$route.params.id;
    if (typeof id !== 'undefined') {
      this.axios.get('admin/roles' + '/' + id).then(function (response) {
        _this3.item = response.data.data;
        if (typeof _this3.item.product_categories === 'undefined') {
          _this3.item.product_categories = [];
        }
      }).catch(function (response) {
        _this3.$toastr('error', 'Este utilizador não existe', 'Erro');
        _this3.$router.push({
          name: 'roles.index'
        });
      });
    }
    this.axios.get('admin/permissions/lst').then(function (response) {
      _this3.permissionGroups = response.data.data;
    });
    this.axios.get('product_categories/lst').then(function (response) {
      _this3.mpg_list = response.data.data;
    });
  }
});

/***/ }),
/* 862 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"animated fadeIn mt-5"},[_c('form',{attrs:{"enctype":"multipart/form-data"},on:{"submit":function($event){return _vm.validateBeforeSubmit($event,false)}}},[_c('div',{staticClass:"row justify-content-center"},[_c('div',{staticClass:"col-md-6"},[_c('b-card',[_c('div',{attrs:{"slot":"header"},slot:"header"},[_c('strong',[_vm._v("Item")])]),_vm._v(" "),_c('b-form-fieldset',{attrs:{"label":"Código"}},[_c('b-form-input',{directives:[{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],attrs:{"type":"text","name":"name","placeholder":"Código","state":_vm.validateState('name')},model:{value:(_vm.item.name),callback:function ($$v) {_vm.$set(_vm.item, "name", $$v)},expression:"item.name"}}),_vm._v(" "),_c('b-form-invalid-feedback',[_vm._v("\n              "+_vm._s(_vm.errors.first('name'))+"\n            ")])],1),_vm._v(" "),_c('b-form-fieldset',{attrs:{"label":"Nome"}},[_c('b-form-input',{directives:[{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],attrs:{"type":"text","name":"display_name","placeholder":"Nome","state":_vm.validateState('display_name')},model:{value:(_vm.item.display_name),callback:function ($$v) {_vm.$set(_vm.item, "display_name", $$v)},expression:"item.display_name"}}),_vm._v(" "),_c('b-form-invalid-feedback',[_vm._v("\n              "+_vm._s(_vm.errors.first('name'))+"\n            ")])],1),_vm._v(" "),_c('div',{attrs:{"slot":"footer"},slot:"footer"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-3"},[_c('router-link',{attrs:{"to":{name:'roles.index'},"size":"sm","variant":"danger"}},[_c('i',{staticClass:"fa fa-ban"}),_vm._v(" Cancelar")])],1),_vm._v(" "),_c('div',{staticClass:"col-sm-9 text-right"},[_c('b-button',{attrs:{"type":"submit","size":"sm","variant":"primary"}},[_c('i',{staticClass:"fa fa-save"}),_vm._v(" Gravar")]),_vm._v(" "),_c('b-button',{attrs:{"type":"button","size":"sm","variant":"primary"},on:{"click":function($event){return _vm.validateBeforeSubmit($event,true)}}},[_c('i',{staticClass:"fa fa-save"}),_vm._v(" Gravar e fechar")])],1)])])],1),_vm._v(" "),_c('b-card',{staticClass:"mt-5"},[_c('div',{attrs:{"slot":"header"},slot:"header"},[_c('strong',[_vm._v("Grupos")])]),_vm._v(" "),_c('b-form-checkbox-group',{attrs:{"id":"permissions","name":"permissions"},model:{value:(_vm.item.permissions_list),callback:function ($$v) {_vm.$set(_vm.item, "permissions_list", $$v)},expression:"item.permissions_list"}},[_c('b-row',_vm._l((_vm.permissionGroups),function(pgroup){return _c('b-col',{staticClass:"mb-4",attrs:{"sm":"6","md":"4"}},[_c('h6',[_vm._v(_vm._s(pgroup.name))]),_vm._v(" "),_vm._l((pgroup.permissions.data),function(permission){return _c('div',{key:permission.id},[_c('b-form-checkbox',{attrs:{"value":permission.id}},[_vm._v(_vm._s(permission.display_name))])],1)})],2)}),1)],1)],1),_vm._v(" "),_c('b-card',{staticClass:"mt-5"},[_c('div',{attrs:{"slot":"header"},slot:"header"},[_c('strong',[_vm._v("Categorias")])]),_vm._v(" "),_c('b-form-checkbox-group',{attrs:{"id":"mpg","name":"mpg"},model:{value:(_vm.item.product_categories),callback:function ($$v) {_vm.$set(_vm.item, "product_categories", $$v)},expression:"item.product_categories"}},_vm._l((_vm.mpg_list),function(mpg){return _c('div',{key:mpg.id},[_c('b-form-checkbox',{attrs:{"value":mpg.id}},[_vm._v(_vm._s(mpg.name))])],1)}),0)],1)],1)])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 863 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Statistics_vue__ = __webpack_require__(864);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_03a45efb_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_Statistics_vue__ = __webpack_require__(911);
var normalizeComponent = __webpack_require__(4)
/* script */

/* template */

/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Statistics_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_03a45efb_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_Statistics_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 864 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__views_Statistics_Filters_vue__ = __webpack_require__(865);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__views_Statistics_UserQueries_vue__ = __webpack_require__(900);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_fullscreen__ = __webpack_require__(407);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_fullscreen___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vue_fullscreen__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__progress_kendo_popups_vue_wrapper__ = __webpack_require__(408);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__progress_kendo_popups_vue_wrapper___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__progress_kendo_popups_vue_wrapper__);









__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_4__progress_kendo_popups_vue_wrapper__["PopupsInstaller"]);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_3_vue_fullscreen___default.a);
/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'Statistics',
  components: {
    StatsFilter: __WEBPACK_IMPORTED_MODULE_1__views_Statistics_Filters_vue__["a" /* default */],
    UserQueries: __WEBPACK_IMPORTED_MODULE_2__views_Statistics_UserQueries_vue__["a" /* default */]
  },
  data: function data() {
    return {
      preload: [],
      schemaModelFields: {},
      url: 'statistics',
      loadingResults: false,
      queryErrorShow: false,
      queryErrorMessage: 'Houve um erro com a sua pesquisa',
      readOptions: {
        columns: 'value',
        rows: 'dealers',
        subrows: 'dealer_id',
        groupby: 'none',
        presetdate: 'custom',
        datetype: 'y',
        year: 2026,
        ufsbcs: 0,
        online: 0,
        profiled: -1,
        webshop: -1,
        clientType: 'A',
        docType: 'AGR',
        dates: {
          start: {
            day: 1,
            month: 1
          },
          end: {
            day: 31,
            month: 12
          }
        },
        filters: []
      },
      clientTypes: [{
        value: 'A',
        text: 'Todos'
      }, {
        value: 'F',
        text: 'Fatura'
      }, {
        value: 'G',
        text: 'Guias'
      }],
      onlineOptions: [{
        value: '0',
        text: 'Off line'
      }, {
        value: '1',
        text: 'OMM'
      }],
      ufsbcsOptions: [{
        value: '0',
        text: 'Todos'
      }, {
        value: '1',
        text: 'UFS'
      }, {
        value: '2',
        text: 'UPFIELD'
      }, {
        value: '3',
        text: 'GALLO'
      }],
      profiledOptions: [{
        value: '-1',
        text: 'Todos'
      }, {
        value: '0',
        text: 'Não'
      }, {
        value: '1',
        text: 'Sim'
      }],
      webshopOptions: [{
        value: '-1',
        text: 'Todos'
      }, {
        value: '0',
        text: 'Não'
      }, {
        value: '1',
        text: 'Sim'
      }],
      documentTypes: [{
        value: 'A',
        text: 'Todos'
      }, {
        value: 'AGR',
        text: 'Sem guias'
      }, {
        value: 'SG',
        text: 'Só guias'
      }],
      aggregateDefinition: [],
      details: [],
      columns: [],
      preloadDone: false,
      loaded: false,
      showFilterType: '',
      showFilterGrid: true,
      showResults: false,
      tableInitialized: false,
      fullscreenGrid: false,
      exporting: false,
      showQueries: false,
      fileDownload: '',
      variables: [],
      rows: [],
      subrows: [],
      groups: [],
      queryName: '',
      queryUrl: '',
      years: [{
        value: 2018,
        text: '2018'
      }, {
        value: 2019,
        text: '2019'
      }, {
        value: 2020,
        text: '2020'
      }, {
        value: 2021,
        text: '2021'
      }, {
        value: 2022,
        text: '2022'
      }, {
        value: 2023,
        text: '2023'
      }, {
        value: 2024,
        text: '2024'
      }, {
        value: 2025,
        text: '2025'
      }, {
        value: 2026,
        text: '2026'
      }],
      days: [],
      months: [{
        value: 1,
        text: 'Jan.'
      }, {
        value: 2,
        text: 'Fev.'
      }, {
        value: 3,
        text: 'Mar.'
      }, {
        value: 4,
        text: 'Abr.'
      }, {
        value: 5,
        text: 'Mai.'
      }, {
        value: 6,
        text: 'Jun.'
      }, {
        value: 7,
        text: 'Jul.'
      }, {
        value: 8,
        text: 'Ago.'
      }, {
        value: 9,
        text: 'Set.'
      }, {
        value: 10,
        text: 'Out.'
      }, {
        value: 11,
        text: 'Nov.'
      }, {
        value: 12,
        text: 'Dez.'
      }],
      filterOptions: [],
      datesOptions: [{
        text: 'até ontem',
        value: 'today'
      }, {
        text: 'Q1',
        value: 'q1'
      }, {
        text: 'Q2',
        value: 'q2'
      }, {
        text: 'Q3',
        value: 'q3'
      }, {
        text: 'Q4',
        value: 'q4'
      }, {
        text: 'customizado',
        value: 'custom'
      }],
      periodType: [{
        value: 'y',
        text: 'Ano'
      }, {
        value: 'ym',
        text: 'Ano / Mês'
      }]
    };
  },

  methods: {
    showData: function showData() {
      var _this = this;

      this.loaded = false;
      this.loadingResults = true;
      this.queryErrorShow = false;
      this.showFilterGrid = false;
      this.showResults = false;
      this.axios.post('statistics/columns', this.readOptions).then(function (response) {
        _this.columns = response.data.data.columns;
        _this.aggregateDefinition = response.data.data.aggregates;
        _this.groupDefinition = response.data.data.groups;
        _this.schemaModelFields = response.data.data.fields;

        if (!_this.tableInitialized) {
          _this.loaded = true;
          _this.showResults = true;
        } else {
          _this.$refs.statsGrid.refresh();
          _this.showResults = true;
          _this.loaded = true;
        }
        var that = _this;
        setTimeout(function () {
          that.$scrollTo('#statistics-results', 300, {
            offset: -60
          });
        }, 100);
      });
    },
    showForm: function showForm() {
      this.loaded = false;
      this.showResults = false;
      this.showFilterGrid = true;
      this.loadingResults = false;
    },
    loadingError: function loadingError(e) {
      this.loaded = false;
      this.loadingResults = false;
      this.showFilterGrid = true;
      this.showResults = false;
      this.queryErrorShow = true;
      var error = e.xhr.responseJSON;
      if (error.status_code === 503) {
        this.queryErrorMessage = error.message;
      } else {
        this.queryErrorMessage = 'Houve um erro com a sua pesquisa';
      }
    },
    changedRows: function changedRows() {
      this.subrows = this.rows[this.readOptions.rows].sub;
      this.readOptions.subrows = this.rows[this.readOptions.rows].default;
      this.details = this.subrows[this.readOptions.subrows].details;
      this.setGroups();
    },
    setGroups: function setGroups() {
      this.groups = [];
      var g = this.subrows[this.readOptions.subrows].groupby;
      this.groups.push({
        value: 'none',
        text: 'Consolidado'
      });

      var active = false;
      for (var i = 0; i < g.length; i++) {
        this.groups.push(g[i]);
        if (this.readOptions.groupby === g[i].value) {
          active = true;
        }
      }
      if (!active) {
        this.readOptions.groupby = 'none';
      }
    },
    changedSubRows: function changedSubRows() {
      this.details = this.subrows[this.readOptions.subrows].details;
      this.groups = [];
      this.setGroups();
    },
    exportResults: function exportResults(e) {
      var _this2 = this;

      e.preventDefault();
      this.exporting = true;
      this.axios.post('statistics/export', this.readOptions).then(function (response) {
        _this2.fileDownload = response.data;
        _this2.$refs.downloadModal.show();
        _this2.exporting = false;
      });
    },
    toggleFullscreen: function toggleFullscreen() {
      this.fullscreenGrid = !this.fullscreenGrid;
    },

    hideModal: function hideModal() {
      this.$refs.downloadModal.hide();
    },
    hideSaveModal: function hideSaveModal() {
      this.$refs.saveModal.hide();
    },
    hideShareModal: function hideShareModal() {
      this.$refs.shareModal.hide();
    },
    getTooltipContents: function getTooltipContents(e) {
      return e.target.data('past') + '<br>' + e.target.data('current') + '<br>' + e.target.data('dif');
    },
    getQuery: function getQuery(queryId) {
      var _this3 = this;

      this.axios.get('queries/' + queryId).then(function (response) {
        _this3.loadQuery(response.data.data);
      });
    },
    openSaveQueryPopup: function openSaveQueryPopup() {
      this.$refs.saveModal.show();
    },
    openLoadQueryPopup: function openLoadQueryPopup() {
      this.$refs.loadQueryModal.show();
    },
    shareQuery: function shareQuery() {
      var _this4 = this;

      this.axios.post('queries', this.readOptions).then(function (response) {
        var route = _this4.$router.resolve({
          name: 'statistics.index',
          params: {
            id: response.data.data.uuid
          }
        });
        _this4.queryUrl = window.location.origin + route.href;
        _this4.$refs.shareModal.show();
      });
    },
    saveQuery: function saveQuery() {
      var _this5 = this;

      this.axios.post('userqueries', {
        query: this.readOptions,
        name: this.queryName,
        query_type: 'sellout'
      }).then(function (response) {
        _this5.$router.replace({
          name: 'statistics.index',
          params: {
            id: response.data.data.uuid
          }
        });
        _this5.hideSaveModal();
      });
    },
    loadUserQuery: function loadUserQuery(evt) {
      this.$router.push({
        name: 'statistics.index',
        params: {
          id: evt.item.uquery.data.uuid
        }
      });

      this.$refs.loadQueryModal.hide();
    },
    loadQuery: function loadQuery(data) {
      this.readOptions.columns = data.columns;
      this.readOptions.presetdate = data.presetdate;
      this.readOptions.datetype = data.datetype;
      this.readOptions.dates = data.dates;
      this.readOptions.year = data.year;
      this.readOptions.rows = data.rows;
      this.readOptions.subrows = data.subrows;
      this.readOptions.groupby = data.groupby;
      this.readOptions.filters = data.filters;
    }
  },
  computed: {
    columnsName: function columnsName() {
      return this.variables[this.readOptions.columns].text;
    },
    datesText: function datesText() {
      var txt = 'Ano: <strong>' + this.readOptions.year + '</strong> vs <strong>' + (this.readOptions.year - 1) + '</strong> ';
      txt += 'período: <strong>';
      switch (this.readOptions.presetdate) {
        case 'today':
          txt += ' do início do ano até ontem';
          break;
        case 'q1':
          txt += ' 1º trimestre';
          break;
        case 'q2':
          txt += ' 2º trimestre';
          break;
        case 'q3':
          txt += ' 3º trimestre';
          break;
        case 'q4':
          txt += ' 4º trimestre';
          break;
        case 'custom':
          txt += ' de ' + this.readOptions.dates.start.day + '/' + this.readOptions.dates.start.month;
          txt += ' a ' + this.readOptions.dates.end.day + '/' + this.readOptions.dates.end.month;
      }
      txt += '</strong>';
      return txt;
    },
    groupByName: function groupByName() {
      var sub = this.rows[this.readOptions.rows].sub;
      var groups = sub[this.readOptions.subrows].groupby;
      for (var i = 0; i < groups.length; i++) {
        if (groups[i].value === this.readOptions.groupby) {
          return groups[i].text;
        }
      }
      return '';
    },
    rowsText: function rowsText() {
      var sub = this.rows[this.readOptions.rows].sub;
      return sub[this.readOptions.subrows].text + ' (' + this.rows[this.readOptions.rows].text + ')';
    },
    totalFilters: function totalFilters() {
      var total = 0;
      for (var i = 0; i < this.readOptions.filters.length; i++) {
        total += this.readOptions.filters[i].includes.length;
        total += this.readOptions.filters[i].excludes.length;
      }
      return total;
    }
  },
  watch: {
    'readOptions.rows': function readOptionsRows(val, oldVal) {
      this.changedRows();
    },
    'readOptions.subrows': function readOptionsSubrows(val, oldVal) {
      this.changedSubRows();
    }
  },
  beforeRouteUpdate: function beforeRouteUpdate(to, from, next) {
    var _this6 = this;

    if (to.params.id !== 'index') {
      this.axios.get('queries/' + to.params.id).then(function (response) {
        _this6.loadQuery(response.data.data);
        next();
      });
    } else {
      this.readOptions = {
        columns: 'value',
        rows: 'dealers',
        subrows: 'dealer_id',
        groupby: 'none',
        presetdate: 'custom',
        datetype: 'y',
        clientType: 'A',
        docType: 'AGR',
        ufsbcs: 0,
        online: 0,
        profiled: -1,
        webshop: -1,
        year: 2026,
        dates: {
          start: {
            day: 1,
            month: 1
          },
          end: {
            day: 31,
            month: 12
          }
        },
        filters: []
      };
      next();
    }
  },
  created: function created() {
    var _this7 = this;

    for (var i = 1; i <= 31; i++) {
      this.days.push({
        value: i,
        text: i
      });
    }
    var today = new Date();
    var apiPreloads = [{
      url: 'statistics/variables',
      callback: setVariables
    }, {
      url: 'statistics/rows',
      callback: setRows
    }, {
      url: 'statistics/filters',
      callback: setFilters
    }];
    if (typeof this.$route.params.id !== 'undefined' && this.$route.params.id !== 'index') {
      apiPreloads.push({
        url: 'queries/' + this.$route.params.id,
        callback: this.loadQuery
      });
    }
    var that = this;
    this.axios.all(apiPreloads.map(function (l) {
      return _this7.axios.get(l.url);
    })).then(that.axios.spread(function () {
      for (var i = 0; i < apiPreloads.length; i++) {
        apiPreloads[i].callback(arguments[i].data.data);
      }
      that.preloadDone = true;
    })).catch(function (response) {
      console.error('error loading foreigns', response);
    });

    function setVariables(response) {
      that.variables = response;
    }

    function setRows(response) {
      that.rows = response;
      that.subrows = that.rows[that.readOptions.rows].sub;
      that.readOptions.subrows = that.rows[that.readOptions.rows].default;
      that.details = that.subrows[that.readOptions.subrows].details;
      that.setGroups();
    }

    function setFilters(response) {
      that.filterOptions = response;
    }
    this.readOptions.dates.end.day = today.getDate();
    this.readOptions.dates.end.month = today.getMonth() + 1;
  }
});

/***/ }),
/* 865 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Filters_vue__ = __webpack_require__(866);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5f30ff1a_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_Filters_vue__ = __webpack_require__(899);
var normalizeComponent = __webpack_require__(4)
/* script */

/* template */

/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Filters_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5f30ff1a_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_Filters_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 866 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__views_Filters_Filter_vue__ = __webpack_require__(402);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__views_Filters_DealersFilter_vue__ = __webpack_require__(403);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__views_Filters_ProdAgregFilter_vue__ = __webpack_require__(404);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__views_Filters_ProductFilter_vue__ = __webpack_require__(406);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__views_Filters_OperatorsFilter_vue__ = __webpack_require__(878);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__views_Filters_ZonesFilter_vue__ = __webpack_require__(881);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__views_Filters_DsrFilter_vue__ = __webpack_require__(884);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__views_Filters_SOFilter_vue__ = __webpack_require__(887);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__views_Filters_CHAFilter_vue__ = __webpack_require__(890);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__views_Filters_CADVFilter_vue__ = __webpack_require__(893);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__views_Filters_STFilter_vue__ = __webpack_require__(896);














/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'Filters',
  components: {
    GeneralFilter: __WEBPACK_IMPORTED_MODULE_0__views_Filters_Filter_vue__["a" /* default */],
    Prodaggreg: __WEBPACK_IMPORTED_MODULE_2__views_Filters_ProdAgregFilter_vue__["a" /* default */],
    Product: __WEBPACK_IMPORTED_MODULE_3__views_Filters_ProductFilter_vue__["a" /* default */],
    OperatorsFilter: __WEBPACK_IMPORTED_MODULE_4__views_Filters_OperatorsFilter_vue__["a" /* default */],
    ZonesFilter: __WEBPACK_IMPORTED_MODULE_5__views_Filters_ZonesFilter_vue__["a" /* default */],
    DsrFilter: __WEBPACK_IMPORTED_MODULE_6__views_Filters_DsrFilter_vue__["a" /* default */],
    SOFilter: __WEBPACK_IMPORTED_MODULE_7__views_Filters_SOFilter_vue__["a" /* default */],
    CHAFilter: __WEBPACK_IMPORTED_MODULE_8__views_Filters_CHAFilter_vue__["a" /* default */],
    CADVFilter: __WEBPACK_IMPORTED_MODULE_9__views_Filters_CADVFilter_vue__["a" /* default */],
    STFilter: __WEBPACK_IMPORTED_MODULE_10__views_Filters_STFilter_vue__["a" /* default */],
    DealersFilter: __WEBPACK_IMPORTED_MODULE_1__views_Filters_DealersFilter_vue__["a" /* default */]
  },
  props: ['showFilterGrid', 'filters', 'showResults', 'totalFilters', 'readOptions'],
  data: function data() {
    return {
      type: null,
      name: ''
    };
  },

  methods: {
    changedFilter: function changedFilter(field, name) {
      this.type = field;
      this.name = name;
    },
    removeBeforeAdding: function removeBeforeAdding(evt) {
      for (var i = 0; i < this.readOptions.filters.length; i++) {
        if (this.readOptions.filters[i].field === evt.field) {
          for (var w = 0; w < this.readOptions.filters[i]['includes'].length; w++) {
            if (evt.item.id === this.readOptions.filters[i]['includes'][w].id) {
              this.readOptions.filters[i]['includes'].splice(w, 1);
            }
          }
          for (var _w = 0; _w < this.readOptions.filters[i]['excludes'].length; _w++) {
            if (evt.item.id === this.readOptions.filters[i]['excludes'][_w].id) {
              this.readOptions.filters[i]['excludes'].splice(_w, 1);
            }
          }
          break;
        }
      }
    },
    addFilter: function addFilter(evt) {
      var start = window.performance.now();
      console.log('event received', start);
      var found = false;
      this.removeBeforeAdding(evt);
      for (var i = 0; i < this.readOptions.filters.length; i++) {
        if (this.readOptions.filters[i].field === evt.field) {
          this.readOptions.filters[i][evt.type].push({
            id: evt.item.id,
            name: evt.item.name
          });
          found = true;
        }
      }
      if (!found) {
        if (evt.type === 'includes') {
          this.readOptions.filters.push({
            field: evt.field,
            title: evt.title,
            includes: [{
              id: evt.item.id,
              name: evt.item.name
            }],
            excludes: []
          });
        } else {
          this.readOptions.filters.push({
            field: evt.field,
            title: evt.title,
            excludes: [{
              id: evt.item.id,
              name: evt.item.name
            }],
            includes: []
          });
        }
      }
      console.log('added to list', window.performance.now());
      console.log('added to list elapsed', window.performance.now() - start);
    },
    removeFilter: function removeFilter(field, index, type) {
      for (var i = 0; i < this.readOptions.filters.length; i++) {
        if (this.readOptions.filters[i].field === field) {
          if (type === 'includes') {
            this.readOptions.filters[i].includes.splice(index, 1);
          } else {
            this.readOptions.filters[i].excludes.splice(index, 1);
          }
        }
      }
    },
    removeAllFilters: function removeAllFilters(field) {
      for (var i = 0; i < this.readOptions.filters.length; i++) {
        if (this.readOptions.filters[i].field === field) {
          this.readOptions.filters[i].includes = [];
          this.readOptions.filters[i].excludes = [];
        }
      }
    }
  },
  created: function created() {
    console.log('FIlters', this.filters);
  }
});

/***/ }),
/* 867 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Grid_vue__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__BaseFilter__ = __webpack_require__(24);




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'GeneralFilter',
  extends: __WEBPACK_IMPORTED_MODULE_1__BaseFilter__["a" /* default */],
  props: ['height', 'filters', 'field', 'url', 'name'],
  components: {
    Grid: __WEBPACK_IMPORTED_MODULE_0__components_Grid_vue__["a" /* default */]
  },
  data: function data() {
    return {
      fieldName: '',
      fieldLabel: '',
      gridRef: 'generalFilter',
      preload: [],
      schemaModelFields: {},
      columns: [{
        'title': '',
        width: '120px',
        command: {
          'className': 'btn btn-success',
          text: 'incluir',
          click: this.addIncludeFilter
        }
      }, {
        'title': '',
        width: '120px',
        command: {
          'className': 'btn btn-danger',
          text: 'excluir',
          click: this.addExcludeFilter
        }
      }, {
        width: '160px',
        field: 'code',
        title: 'Código'
      }, {
        field: 'name',
        title: 'Name'
      }, {
        field: 'id',
        title: 'ID'
      }],
      loaded: false,
      tableInitialized: false
    };
  },
  created: function created() {
    this.fieldName = this.field;
    this.fieldLabel = this.name;
  }
});

/***/ }),
/* 868 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__progress_kendo_ui_js_kendo_all_js__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__progress_kendo_ui_js_kendo_all_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__progress_kendo_ui_js_kendo_all_js__);


/* harmony default export */ __webpack_exports__["a"] = ({
  props: ['height', 'filters'],
  data: function data() {
    return {
      fieldName: '',
      fieldLabel: '',
      gridRef: ''
    };
  },
  watch: {
    filters: {
      deep: true,
      handler: function handler(newFilters) {
        try {
          var lines = __WEBPACK_IMPORTED_MODULE_0__progress_kendo_ui_js_kendo_all_js___default.a.jQuery(this.$refs[this.gridRef].$el).find('tbody tr');
          var grid = this.$refs[this.gridRef].getGrid();
          this.highlight(lines, grid, newFilters);
        } catch (err) {}
      }
    }
  },
  methods: {
    dataBound: function dataBound(e) {
      var lines = e.sender.table.find('tbody tr');
      var grid = e.sender.table.parents('.k-grid:first').data('kendoGrid');
      this.highlight(lines, grid, this.filters);
    },
    highlight: function highlight(lines, grid, activeFilters) {
      for (var i = 0; i < lines.length; i++) {
        var selectedRow = grid.dataItem(lines[i]);
        var itemId = selectedRow.id;
        var exists = this.filterActive(itemId, activeFilters);
        if (exists > 0) {
          __WEBPACK_IMPORTED_MODULE_0__progress_kendo_ui_js_kendo_all_js___default.a.jQuery(lines[i]).addClass('table-success');
        } else if (exists < 0) {
          __WEBPACK_IMPORTED_MODULE_0__progress_kendo_ui_js_kendo_all_js___default.a.jQuery(lines[i]).addClass('table-danger');
        } else {
          __WEBPACK_IMPORTED_MODULE_0__progress_kendo_ui_js_kendo_all_js___default.a.jQuery(lines[i]).removeClass('table-danger table-success');
        }
      }
    },
    addIncludeFilter: function addIncludeFilter(e) {
      e.preventDefault();
      var grid = this.$refs[this.gridRef].$refs.mygrid.kendoWidget();
      var row = __WEBPACK_IMPORTED_MODULE_0__progress_kendo_ui_js_kendo_all_js___default.a.jQuery(e.currentTarget).closest('tr');
      var dataItem = grid.dataItem(row);
      row.removeClass('table-danger').addClass('table-success');
      this.$emit('added-filter', {
        field: this.fieldName,
        item: dataItem,
        title: this.fieldLabel,
        'type': 'includes'
      });
    },
    filterActive: function filterActive(itemId, activeFilters) {
      for (var c = 0; c < activeFilters.length; c++) {
        if (activeFilters[c].field === this.fieldName) {
          for (var w = 0; w < activeFilters[c].includes.length; w++) {
            if (activeFilters[c].includes[w].id === itemId) {
              return 1;
            }
          }
          for (var _w = 0; _w < activeFilters[c].excludes.length; _w++) {
            if (activeFilters[c].excludes[_w].id === itemId) {
              return -1;
            }
          }
          return 0;
        }
      }
      return 0;
    },
    addExcludeFilter: function addExcludeFilter(e) {
      e.preventDefault();
      var grid = this.$refs[this.gridRef].$refs.mygrid.kendoWidget();
      var row = __WEBPACK_IMPORTED_MODULE_0__progress_kendo_ui_js_kendo_all_js___default.a.jQuery(e.currentTarget).closest('tr');
      var dataItem = grid.dataItem(row);
      row.removeClass('table-success').addClass('table-danger');
      this.$emit('added-filter', {
        field: this.fieldName,
        item: dataItem,
        title: this.fieldLabel,
        'type': 'excludes'
      });
    },
    addAll: function addAll() {
      var _this = this;

      var grid = this.$refs[this.gridRef].$refs.mygrid.kendoWidget();
      var opts = grid.getOptions();
      this.axios.post(this.url + '/all', { filter: opts.dataSource.filter }).then(function (response) {
        for (var i = 0; i < response.data.data.length; i++) {
          _this.$emit('added-filter', {
            field: _this.fieldName,
            item: response.data.data[i],
            title: _this.fieldLabel,
            'type': 'includes'
          });
        }
      });
    },
    excludeAll: function excludeAll() {
      var _this2 = this;

      var grid = this.$refs[this.gridRef].$refs.mygrid.kendoWidget();
      var opts = grid.getOptions();
      this.axios.post(this.url + '/all', { filter: opts.dataSource.filter }).then(function (response) {
        for (var i = 0; i < response.data.data.length; i++) {
          _this2.$emit('added-filter', {
            field: _this2.fieldName,
            item: response.data.data[i],
            title: _this2.fieldLabel,
            'type': 'excludes'
          });
        }
      });
    }
  }
});

/***/ }),
/* 869 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('Grid',{ref:"generalFilter",attrs:{"name":"generalFilter","url":_vm.url,"columns":_vm.columns,"pageable":true,"height":_vm.height,"filterable":true,"sortable":true,"schemaModelFields":_vm.schemaModelFields,"preload":_vm.preload,"databound":_vm.dataBound}}),_vm._v(" "),_c('div',[_c('b-button',{attrs:{"variant":"success"},on:{"click":function($event){return _vm.addAll()}}},[_vm._v("Incluir todos")]),_vm._v(" "),_c('b-button',{attrs:{"variant":"danger"},on:{"click":function($event){return _vm.excludeAll()}}},[_vm._v("Excluir todos")])],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 870 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Grid_vue__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__BaseFilter__ = __webpack_require__(24);




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'Dealer',
  extends: __WEBPACK_IMPORTED_MODULE_1__BaseFilter__["a" /* default */],
  components: {
    Grid: __WEBPACK_IMPORTED_MODULE_0__components_Grid_vue__["a" /* default */]
  },
  data: function data() {
    return {
      fieldName: 'dealer_id',
      fieldLabel: 'Distribuidor',
      gridRef: 'filterGridDealer',
      preload: [{
        field: 'dealer_so_code',
        api: 'stars/lst/1'
      }, {
        field: 'dealer_st_code',
        api: 'stars/lst/2'
      }, {
        field: 'dealer_cha_code',
        api: 'stars/lst/4'
      }, {
        field: 'dealer_cadv_code',
        api: 'stars/lst/3'
      }],
      schemaModelFields: {},
      url: 'dealers',
      columns: [{
        'title': '',
        width: '120px',
        command: {
          'className': 'btn btn-success',
          text: 'incluir',
          click: this.addIncludeFilter
        }
      }, {
        'title': '',
        width: '120px',
        command: {
          'className': 'btn btn-danger',
          text: 'excluir',
          click: this.addExcludeFilter
        }
      }, {
        field: 'id',
        title: 'ID',
        width: '200px'
      }, {
        field: 'name',
        title: 'Name',
        width: '200px'
      }, {
        field: 'dealer_type_stats',
        title: 'Tipo',
        width: '120px',
        values: [{
          value: 1,
          text: 'CCSS'
        }, {
          value: 2,
          text: 'Distribuidor'
        }]
      }, {
        field: 'dealer_so_code',
        title: 'SO',
        width: '120px'
      }, {
        field: 'dealer_st_code',
        title: 'ST',
        width: '120px'
      }, {
        field: 'dealer_cadv_code',
        title: 'CADV',
        width: '120px'
      }, {
        field: 'dealer_cha_code',
        title: 'CHA',
        width: '120px'
      }],
      loaded: false,
      tableInitialized: false,
      variables: [],
      rows: [],
      subrows: [],
      tables: []
    };
  }
});

/***/ }),
/* 871 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"dealers-grid"},[_c('Grid',{ref:"filterGridDealer",attrs:{"name":"filterGridDealer","url":_vm.url,"columns":_vm.columns,"pageable":true,"height":_vm.height,"filterable":true,"sortable":true,"schemaModelFields":_vm.schemaModelFields,"preload":_vm.preload,"databound":_vm.dataBound}}),_vm._v(" "),_c('div',[_c('b-button',{attrs:{"variant":"success"},on:{"click":function($event){return _vm.addAll()}}},[_vm._v("Incluir todos")]),_vm._v(" "),_c('b-button',{attrs:{"variant":"danger"},on:{"click":function($event){return _vm.excludeAll()}}},[_vm._v("Excluir todos")])],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 872 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_GridLocal_vue__ = __webpack_require__(405);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__BaseFilter__ = __webpack_require__(24);




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'ProdAgreg',
  extends: __WEBPACK_IMPORTED_MODULE_1__BaseFilter__["a" /* default */],
  components: {
    GridLocal: __WEBPACK_IMPORTED_MODULE_0__components_GridLocal_vue__["a" /* default */]
  },
  data: function data() {
    return {
      fieldName: 'prodaggreg_id',
      fieldLabel: 'Prodagreg',
      gridRef: 'filterGridProdAgreg',
      preload: [{
        field: 'top10_id',
        api: 'top10/lst'
      }, {
        field: 'brand_id',
        api: 'brands/lst'
      }, {
        field: 'product_category_id',
        api: 'product_categories/lst'
      }],
      schemaModelFields: {},
      url: 'prodagregs',
      columns: [{
        'title': '',
        width: '120px',
        command: {
          'className': 'btn btn-success',
          text: 'incluir',
          click: this.addIncludeFilter
        }
      }, {
        'title': '',
        width: '120px',
        command: {
          'className': 'btn btn-danger',
          text: 'excluir',
          click: this.addExcludeFilter
        }
      }, {
        width: '160px',
        field: 'code',
        title: 'Código'
      }, {
        field: 'name',
        title: 'Name',
        width: '200px'
      }, {
        field: 'top10_id',
        title: 'Top UFS',
        width: '200px'
      }, {
        field: 'brand_id',
        title: 'Brand',
        width: '200px'
      }, {
        field: 'product_category_id',
        title: 'Category',
        width: '200px'
      }],
      loaded: false,
      tableInitialized: false
    };
  }
});

/***/ }),
/* 873 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__progress_kendo_ui_js_kendo_all_js__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__progress_kendo_ui_js_kendo_all_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__progress_kendo_ui_js_kendo_all_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__progress_kendo_grid_vue_wrapper__ = __webpack_require__(74);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__progress_kendo_grid_vue_wrapper___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__progress_kendo_grid_vue_wrapper__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__progress_kendo_datasource_vue_wrapper__ = __webpack_require__(75);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__progress_kendo_datasource_vue_wrapper___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__progress_kendo_datasource_vue_wrapper__);








__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_3__progress_kendo_datasource_vue_wrapper__["KendoDataSourceInstaller"]);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_2__progress_kendo_grid_vue_wrapper__["KendoGridInstaller"]);

/* harmony default export */ __webpack_exports__["a"] = ({
  props: ['name', 'schemaModelFields', 'url', 'columns', 'preload', 'sortable', 'pageable', 'filterable', 'height', 'aggregate', 'databound'],
  components: {
    KendoGrid: __WEBPACK_IMPORTED_MODULE_2__progress_kendo_grid_vue_wrapper__["KendoGrid"],
    KendoDataSource: __WEBPACK_IMPORTED_MODULE_3__progress_kendo_datasource_vue_wrapper__["KendoDataSource"]
  },
  data: function data() {
    return {
      preloadDone: false,
      gridTransport: this.getTransport(),
      schemaTotal: this.getTotal,
      finalDataBound: null,
      options: {
        dataSource: {
          page: 1,
          sort: null,
          filter: null
        }
      }
    };
  },

  methods: {
    getTransport: function getTransport() {
      var v = this;
      return {
        read: {
          url: v.axios.defaults.baseURL + this.url,
          beforeSend: function beforeSend(req) {
            req.setRequestHeader('Authorization', 'Bearer ' + v.$auth.token());
          }
        }
      };
    },
    getGrid: function getGrid() {
      return this.$refs.mygrid.kendoWidget();
    },
    getTotal: function getTotal(response) {
      return response.data.length;
    },
    setColumnsData: function setColumnsData(data, field) {
      for (var i = 0; i < this.columns.length; i++) {
        if (this.columns[i].field === field) {
          this.columns[i].values = data;
        }
      }
    }
  },
  created: function created() {
    var _this = this;

    if (typeof this.databound === 'function') {
      this.finalDataBound = this.databound;
    } else {
      this.finalDataBound = function () {};
    }
    var that = this;
    if (localStorage[this.name + 'options']) {
      this.options = JSON.parse(localStorage[this.name + 'options']);
    }
    console.log(this.options);

    var apiPreloads = [];
    if (typeof this.preload !== 'undefined' && this.preload != null && this.preload.length > 0) {
      for (var i = 0; i < this.preload.length; i++) {
        apiPreloads.push(this.preload[i].api);
      }
      this.axios.all(apiPreloads.map(function (l) {
        return _this.axios.get(l);
      })).then(that.axios.spread(function () {
        for (var i = 0; i < that.preload.length; i++) {
          that.setColumnsData(arguments[i].data.data, that.preload[i].field);
        }
        that.preloadDone = true;
      })).catch(function (response) {
        console.error('error loading foreigns', response);
      });
    } else {
      that.preloadDone = true;
    }
  },
  beforeDestroy: function beforeDestroy() {
    try {
      var grid = this.$refs.mygrid.kendoWidget();
      localStorage[this.name + 'options'] = __WEBPACK_IMPORTED_MODULE_1__progress_kendo_ui_js_kendo_all_js___default.a.stringify(grid.getOptions());
    } catch (error) {}
  }
});

/***/ }),
/* 874 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.preloadDone)?_c('div',[_c('kendo-datasource',{ref:"datasource1",attrs:{"aggregate":_vm.aggregate,"transport":_vm.gridTransport,"schema-model-fields":_vm.schemaModelFields,"schema-total":_vm.schemaTotal,"schema-data":'data',"server-paging":false,"server-filtering":false,"server-sorting":false,"page-size":10,"page":_vm.options.dataSource.page,"filter":_vm.options.dataSource.filter,"sort":_vm.options.dataSource.sort}}),_vm._v(" "),_c('kendo-grid',{ref:"mygrid",attrs:{"height":_vm.height,"data-source-ref":'datasource1',"pageable":_vm.pageable,"filterable":_vm.filterable,"sortable":_vm.sortable,"columns":_vm.columns,"scrollable":true},on:{"databound":_vm.finalDataBound}})],1):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 875 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('GridLocal',{ref:"filterGridProdAgreg",attrs:{"name":"filterGridProdAgreg","url":_vm.url,"columns":_vm.columns,"pageable":true,"height":_vm.height,"filterable":true,"sortable":true,"schemaModelFields":_vm.schemaModelFields,"preload":_vm.preload,"databound":_vm.dataBound}}),_vm._v(" "),_c('div',[_c('b-button',{attrs:{"variant":"success"},on:{"click":function($event){return _vm.addAll()}}},[_vm._v("Incluir todos")]),_vm._v(" "),_c('b-button',{attrs:{"variant":"danger"},on:{"click":function($event){return _vm.excludeAll()}}},[_vm._v("Excluir todos")])],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 876 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_GridLocal_vue__ = __webpack_require__(405);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__BaseFilter__ = __webpack_require__(24);




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'Product',
  extends: __WEBPACK_IMPORTED_MODULE_1__BaseFilter__["a" /* default */],
  components: {
    GridLocal: __WEBPACK_IMPORTED_MODULE_0__components_GridLocal_vue__["a" /* default */]
  },
  data: function data() {
    return {
      fieldName: 'product_id',
      fieldLabel: 'Produto',
      gridRef: 'filterGridProduct',
      preload: [{
        field: 'prodaggreg_id',
        api: 'prodagregs/lst'
      }],
      schemaModelFields: {},
      url: 'products',
      columns: [{
        'title': '',
        width: '120px',
        command: {
          'className': 'btn btn-success',
          text: 'incluir',
          click: this.addIncludeFilter
        }
      }, {
        'title': '',
        width: '120px',
        command: {
          'className': 'btn btn-danger',
          text: 'excluir',
          click: this.addExcludeFilter
        }
      }, {
        width: '160px',
        field: 'sku',
        title: 'Sku'
      }, {
        field: 'name',
        title: 'Name',
        width: '200px'
      }, {
        field: 'prodaggreg_id',
        title: 'ProdAgreg',
        width: '200px'
      }],
      loaded: false,
      tableInitialized: false
    };
  }
});

/***/ }),
/* 877 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('GridLocal',{ref:"filterGridProduct",attrs:{"name":"filterGridProduct","url":_vm.url,"columns":_vm.columns,"pageable":true,"height":_vm.height,"filterable":true,"sortable":true,"schemaModelFields":_vm.schemaModelFields,"preload":_vm.preload,"databound":_vm.dataBound}}),_vm._v(" "),_c('div',[_c('b-button',{attrs:{"variant":"success"},on:{"click":function($event){return _vm.addAll()}}},[_vm._v("Incluir todos")]),_vm._v(" "),_c('b-button',{attrs:{"variant":"danger"},on:{"click":function($event){return _vm.excludeAll()}}},[_vm._v("Excluir todos")])],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 878 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_OperatorsFilter_vue__ = __webpack_require__(879);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0b26e6c2_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_OperatorsFilter_vue__ = __webpack_require__(880);
var normalizeComponent = __webpack_require__(4)
/* script */

/* template */

/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_OperatorsFilter_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0b26e6c2_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_OperatorsFilter_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 879 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Grid_vue__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__BaseFilter__ = __webpack_require__(24);




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'Operator',
  extends: __WEBPACK_IMPORTED_MODULE_1__BaseFilter__["a" /* default */],
  components: {
    Grid: __WEBPACK_IMPORTED_MODULE_0__components_Grid_vue__["a" /* default */]
  },
  data: function data() {
    return {
      fieldName: 'operator_id',
      fieldLabel: 'Operador',
      gridRef: 'filterGridOperator',
      preload: [],
      schemaModelFields: {},
      url: 'operators',
      columns: [{
        'title': '',
        width: '120px',
        command: {
          'className': 'btn btn-success',
          text: 'incluir',
          click: this.addIncludeFilter
        }
      }, {
        'title': '',
        width: '120px',
        command: {
          'className': 'btn btn-danger',
          text: 'excluir',
          click: this.addExcludeFilter
        }
      }, {
        width: '160px',
        field: 'codle',
        title: 'Codle'
      }, {
        width: '160px',
        field: 'nif',
        title: 'NIF'
      }, {
        field: 'name',
        title: 'Name',
        width: '200px'
      }, {
        field: 'webshop',
        title: 'WebShop',
        width: '200px',
        values: [{
          value: 0,
          text: 'Não'
        }, {
          value: 1,
          text: 'Sim'
        }]
      }],
      loaded: false,
      tableInitialized: false
    };
  }
});

/***/ }),
/* 880 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('Grid',{ref:"filterGridOperator",attrs:{"name":"filterGridOperator","url":_vm.url,"columns":_vm.columns,"pageable":true,"height":_vm.height,"filterable":true,"sortable":true,"schemaModelFields":_vm.schemaModelFields,"preload":_vm.preload,"databound":_vm.dataBound}}),_vm._v(" "),_c('div',[_c('b-button',{attrs:{"variant":"success"},on:{"click":function($event){return _vm.addAll()}}},[_vm._v("Incluir todos")]),_vm._v(" "),_c('b-button',{attrs:{"variant":"danger"},on:{"click":function($event){return _vm.excludeAll()}}},[_vm._v("Excluir todos")])],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 881 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ZonesFilter_vue__ = __webpack_require__(882);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_203f4c97_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_ZonesFilter_vue__ = __webpack_require__(883);
var normalizeComponent = __webpack_require__(4)
/* script */

/* template */

/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ZonesFilter_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_203f4c97_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_ZonesFilter_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 882 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Grid_vue__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__BaseFilter__ = __webpack_require__(24);




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'Zone',
  extends: __WEBPACK_IMPORTED_MODULE_1__BaseFilter__["a" /* default */],
  components: {
    Grid: __WEBPACK_IMPORTED_MODULE_0__components_Grid_vue__["a" /* default */]
  },
  data: function data() {
    return {
      fieldName: 'zone',
      fieldLabel: 'Zona',
      gridRef: 'filterGridZone',
      preload: [{
        field: 'dealer_id',
        api: 'dealers/lst'
      }],
      schemaModelFields: {},
      url: 'zones',
      columns: [{
        'title': '',
        width: '120px',
        command: {
          'className': 'btn btn-success',
          text: 'incluir',
          click: this.addIncludeFilter
        }
      }, {
        'title': '',
        width: '120px',
        command: {
          'className': 'btn btn-danger',
          text: 'excluir',
          click: this.addExcludeFilter
        }
      }, {
        field: 'zone',
        title: 'Zona',
        width: '200px'
      }, {
        field: 'name',
        title: 'Name',
        width: '200px'
      }, {
        field: 'dealer_id',
        title: 'Distribuidor',
        width: '200px'
      }],
      loaded: false,
      tableInitialized: false
    };
  }
});

/***/ }),
/* 883 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('Grid',{ref:"filterGridZone",attrs:{"name":"filterGridZone","url":_vm.url,"columns":_vm.columns,"pageable":true,"height":_vm.height,"filterable":true,"sortable":true,"schemaModelFields":_vm.schemaModelFields,"preload":_vm.preload,"databound":_vm.dataBound}}),_vm._v(" "),_c('div',[_c('b-button',{attrs:{"variant":"success"},on:{"click":function($event){return _vm.addAll()}}},[_vm._v("Incluir todos")]),_vm._v(" "),_c('b-button',{attrs:{"variant":"danger"},on:{"click":function($event){return _vm.excludeAll()}}},[_vm._v("Excluir todos")])],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 884 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DsrFilter_vue__ = __webpack_require__(885);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5c35e5da_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_DsrFilter_vue__ = __webpack_require__(886);
var normalizeComponent = __webpack_require__(4)
/* script */

/* template */

/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DsrFilter_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5c35e5da_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_DsrFilter_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 885 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Grid_vue__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__BaseFilter__ = __webpack_require__(24);




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'Dsr',
  extends: __WEBPACK_IMPORTED_MODULE_1__BaseFilter__["a" /* default */],
  components: {
    Grid: __WEBPACK_IMPORTED_MODULE_0__components_Grid_vue__["a" /* default */]
  },
  data: function data() {
    return {
      fieldName: 'dsr_id',
      fieldLabel: 'DSR',
      gridRef: 'filterGridDsr',
      preload: [{
        field: 'dealer_id',
        api: 'dealers/lst'
      }],
      schemaModelFields: {},
      url: 'dsr',
      columns: [{
        'title': '',
        width: '120px',
        command: {
          'className': 'btn btn-success',
          text: 'incluir',
          click: this.addIncludeFilter
        }
      }, {
        'title': '',
        width: '120px',
        command: {
          'className': 'btn btn-danger',
          text: 'excluir',
          click: this.addExcludeFilter
        }
      }, {
        width: '120px',
        field: 'code',
        title: 'Código'
      }, {
        field: 'id',
        title: 'Id',
        width: '120px'
      }, {
        field: 'name',
        title: 'Nome',
        width: '200px'
      }, {
        field: 'dealer_id',
        title: 'Distribuidor',
        width: '200px'
      }, {
        field: 'dsr_type',
        title: 'Tipo',
        values: [{
          text: 'Vendedor',
          value: 1
        }, {
          text: 'CV/Vendedor',
          value: 2
        }, {
          text: 'CV',
          value: 3
        }, {
          text: 'Gerente',
          value: 4
        }],
        width: '120px'
      }],
      loaded: false
    };
  }
});

/***/ }),
/* 886 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('Grid',{ref:"filterGridDsr",attrs:{"name":"filterGridDsr","url":_vm.url,"columns":_vm.columns,"pageable":true,"height":_vm.height,"filterable":true,"sortable":true,"schemaModelFields":_vm.schemaModelFields,"preload":_vm.preload,"databound":_vm.dataBound}}),_vm._v(" "),_c('div',[_c('b-button',{attrs:{"variant":"success"},on:{"click":function($event){return _vm.addAll()}}},[_vm._v("Incluir todos")]),_vm._v(" "),_c('b-button',{attrs:{"variant":"danger"},on:{"click":function($event){return _vm.excludeAll()}}},[_vm._v("Excluir todos")])],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 887 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SOFilter_vue__ = __webpack_require__(888);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7c3e16e8_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_SOFilter_vue__ = __webpack_require__(889);
var normalizeComponent = __webpack_require__(4)
/* script */

/* template */

/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SOFilter_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7c3e16e8_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_SOFilter_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 888 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Grid_vue__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__BaseFilter__ = __webpack_require__(24);




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'SO',
  extends: __WEBPACK_IMPORTED_MODULE_1__BaseFilter__["a" /* default */],
  components: {
    Grid: __WEBPACK_IMPORTED_MODULE_0__components_Grid_vue__["a" /* default */]
  },
  data: function data() {
    return {
      fieldName: 'stars_so_code',
      fieldLabel: 'SO',
      gridRef: 'filterGridSO',
      preload: [],
      schemaModelFields: {},
      url: 'stars/type/1',
      columns: [{
        'title': '',
        width: '120px',
        command: {
          'className': 'btn btn-success',
          text: 'incluir',
          click: this.addIncludeFilter
        }
      }, {
        'title': '',
        width: '120px',
        command: {
          'className': 'btn btn-danger',
          text: 'excluir',
          click: this.addExcludeFilter
        }
      }, {
        width: '160px',
        field: 'code',
        title: 'Código'
      }, {
        field: 'name',
        title: 'Name',
        width: '200px'
      }],
      loaded: false,
      tableInitialized: false
    };
  }
});

/***/ }),
/* 889 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('Grid',{ref:"filterGridSO",attrs:{"name":"filterGridSO","url":_vm.url,"columns":_vm.columns,"pageable":true,"height":_vm.height,"filterable":true,"sortable":true,"schemaModelFields":_vm.schemaModelFields,"preload":_vm.preload,"databound":_vm.dataBound}}),_vm._v(" "),_c('div',[_c('b-button',{attrs:{"variant":"success"},on:{"click":function($event){return _vm.addAll()}}},[_vm._v("Incluir todos")]),_vm._v(" "),_c('b-button',{attrs:{"variant":"danger"},on:{"click":function($event){return _vm.excludeAll()}}},[_vm._v("Excluir todos")])],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 890 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CHAFilter_vue__ = __webpack_require__(891);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_18c508ac_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_CHAFilter_vue__ = __webpack_require__(892);
var normalizeComponent = __webpack_require__(4)
/* script */

/* template */

/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CHAFilter_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_18c508ac_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_CHAFilter_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 891 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Grid_vue__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__BaseFilter__ = __webpack_require__(24);




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'CHA',
  extends: __WEBPACK_IMPORTED_MODULE_1__BaseFilter__["a" /* default */],
  components: {
    Grid: __WEBPACK_IMPORTED_MODULE_0__components_Grid_vue__["a" /* default */]
  },
  data: function data() {
    return {
      fieldName: 'stars_cha_code',
      fieldLabel: 'CHA',
      gridRef: 'filterGridCHA',
      preload: [],
      schemaModelFields: {},
      url: 'stars/type/4',
      columns: [{
        'title': '',
        width: '120px',
        command: {
          'className': 'btn btn-success',
          text: 'incluir',
          click: this.addIncludeFilter
        }
      }, {
        'title': '',
        width: '120px',
        command: {
          'className': 'btn btn-danger',
          text: 'excluir',
          click: this.addExcludeFilter
        }
      }, {
        width: '160px',
        field: 'code',
        title: 'Código'
      }, {
        field: 'name',
        title: 'Name',
        width: '200px'
      }],
      loaded: false,
      tableInitialized: false
    };
  }
});

/***/ }),
/* 892 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('Grid',{ref:"filterGridCHA",attrs:{"name":"filterGridCHA","url":_vm.url,"columns":_vm.columns,"pageable":true,"height":_vm.height,"filterable":true,"sortable":true,"schemaModelFields":_vm.schemaModelFields,"preload":_vm.preload,"databound":_vm.dataBound}}),_vm._v(" "),_c('div',[_c('b-button',{attrs:{"variant":"success"},on:{"click":function($event){return _vm.addAll()}}},[_vm._v("Incluir todos")]),_vm._v(" "),_c('b-button',{attrs:{"variant":"danger"},on:{"click":function($event){return _vm.excludeAll()}}},[_vm._v("Excluir todos")])],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 893 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CADVFilter_vue__ = __webpack_require__(894);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f69c5ac0_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_CADVFilter_vue__ = __webpack_require__(895);
var normalizeComponent = __webpack_require__(4)
/* script */

/* template */

/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CADVFilter_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f69c5ac0_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_CADVFilter_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 894 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Grid_vue__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__BaseFilter__ = __webpack_require__(24);




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'CADV',
  extends: __WEBPACK_IMPORTED_MODULE_1__BaseFilter__["a" /* default */],
  components: {
    Grid: __WEBPACK_IMPORTED_MODULE_0__components_Grid_vue__["a" /* default */]
  },
  data: function data() {
    return {
      fieldName: 'stars_cadv_code',
      fieldLabel: 'CADV',
      gridRef: 'filterGridCADV',
      preload: [],
      schemaModelFields: {},
      url: 'stars/type/3',
      columns: [{
        'title': '',
        width: '120px',
        command: {
          'className': 'btn btn-success',
          text: 'incluir',
          click: this.addIncludeFilter
        }
      }, {
        'title': '',
        width: '120px',
        command: {
          'className': 'btn btn-danger',
          text: 'excluir',
          click: this.addExcludeFilter
        }
      }, {
        width: '160px',
        field: 'code',
        title: 'Código'
      }, {
        field: 'name',
        title: 'Name',
        width: '200px'
      }],
      loaded: false,
      tableInitialized: false
    };
  }
});

/***/ }),
/* 895 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('Grid',{ref:"filterGridCADV",attrs:{"name":"filterGridCADV","url":_vm.url,"columns":_vm.columns,"pageable":true,"height":_vm.height,"filterable":true,"sortable":true,"schemaModelFields":_vm.schemaModelFields,"preload":_vm.preload,"databound":_vm.dataBound}}),_vm._v(" "),_c('div',[_c('b-button',{attrs:{"variant":"success"},on:{"click":function($event){return _vm.addAll()}}},[_vm._v("Incluir todos")]),_vm._v(" "),_c('b-button',{attrs:{"variant":"danger"},on:{"click":function($event){return _vm.excludeAll()}}},[_vm._v("Excluir todos")])],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 896 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_STFilter_vue__ = __webpack_require__(897);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ab4f1b5e_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_STFilter_vue__ = __webpack_require__(898);
var normalizeComponent = __webpack_require__(4)
/* script */

/* template */

/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_STFilter_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ab4f1b5e_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_STFilter_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 897 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Grid_vue__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__BaseFilter__ = __webpack_require__(24);




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'ST',
  extends: __WEBPACK_IMPORTED_MODULE_1__BaseFilter__["a" /* default */],
  components: {
    Grid: __WEBPACK_IMPORTED_MODULE_0__components_Grid_vue__["a" /* default */]
  },
  data: function data() {
    return {
      fieldName: 'stars_st_code',
      fieldLabel: 'ST',
      gridRef: 'filterGridST',
      preload: [],
      schemaModelFields: {},
      url: 'stars/type/2',
      columns: [{
        'title': '',
        width: '120px',
        command: {
          'className': 'btn btn-success',
          text: 'incluir',
          click: this.addIncludeFilter
        }
      }, {
        'title': '',
        width: '120px',
        command: {
          'className': 'btn btn-danger',
          text: 'excluir',
          click: this.addExcludeFilter
        }
      }, {
        width: '160px',
        field: 'code',
        title: 'Código'
      }, {
        field: 'name',
        title: 'Name',
        width: '200px'
      }],
      loaded: false,
      tableInitialized: false
    };
  }
});

/***/ }),
/* 898 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('Grid',{ref:"filterGridST",attrs:{"name":"filterGridST","url":_vm.url,"columns":_vm.columns,"pageable":true,"height":_vm.height,"filterable":true,"sortable":true,"schemaModelFields":_vm.schemaModelFields,"preload":_vm.preload,"databound":_vm.dataBound}}),_vm._v(" "),_c('div',[_c('b-button',{attrs:{"variant":"success"},on:{"click":function($event){return _vm.addAll()}}},[_vm._v("Incluir todos")]),_vm._v(" "),_c('b-button',{attrs:{"variant":"danger"},on:{"click":function($event){return _vm.excludeAll()}}},[_vm._v("Excluir todos")])],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 899 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-card',{attrs:{"title":"Filtros"}},[_c('div',{staticClass:"row filter-column",class:{ 'showGrids': _vm.showFilterGrid }},[_c('div',{staticClass:"col-md",class:{ 'col-md-4': _vm.showFilterGrid }},[_c('b-card-group',{attrs:{"columns":""}},[(_vm.totalFilters===0)?_c('b-card',[_vm._v("\n          Sem filtros\n        ")]):_vm._e(),_vm._v(" "),_vm._l((_vm.readOptions.filters),function(filter){return _c('b-card',{directives:[{name:"show",rawName:"v-show",value:(filter.includes.length > 0 || filter.excludes.length > 0),expression:"filter.includes.length > 0 || filter.excludes.length > 0"}],key:filter.field,attrs:{"no-body":""}},[_c('b-card-header',[_vm._v("\n            "+_vm._s(filter.title)+"\n          ")]),_vm._v(" "),_c('b-list-group',[_vm._l((filter.includes),function(item,index){return _c('b-list-group-item',{key:item.id,staticClass:"d-flex justify-content-between align-items-center",attrs:{"variant":"success"}},[_vm._v("\n              "+_vm._s(item.name)+"\n              "),_c('b-badge',{directives:[{name:"show",rawName:"v-show",value:(_vm.showFilterGrid),expression:"showFilterGrid"}],attrs:{"variant":"danger"},on:{"click":function($event){return _vm.removeFilter(filter.field, index, 'includes')}}},[_c('i',{staticClass:"fa fa-times"})])],1)}),_vm._v(" "),_vm._l((filter.excludes),function(item,index){return _c('b-list-group-item',{key:item.id,staticClass:"d-flex justify-content-between align-items-center",attrs:{"variant":"danger"}},[_vm._v("\n              "+_vm._s(item.name)+"\n              "),_c('b-badge',{directives:[{name:"show",rawName:"v-show",value:(_vm.showFilterGrid),expression:"showFilterGrid"}],attrs:{"variant":"danger"},on:{"click":function($event){return _vm.removeFilter(filter.field, index, 'excludes')}}},[_c('i',{staticClass:"fa fa-times"})])],1)})],2),_vm._v(" "),_c('b-card-footer',[_c('a',{directives:[{name:"show",rawName:"v-show",value:(_vm.showFilterGrid),expression:"showFilterGrid"}],staticClass:"text-danger",on:{"click":function($event){return _vm.removeAllFilters(filter.field)}}},[_vm._v("Limpar filtros "),_c('i',{staticClass:"fa fa-ban"})])])],1)})],2)],1),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.showFilterGrid),expression:"showFilterGrid"}],staticClass:"col-md-8"},[_c('b-card',{attrs:{"no-body":""}},[_c('b-card-header',[_c('b-nav',{attrs:{"pills":"","variant":"secondary"}},_vm._l((_vm.filters),function(filter){return _c('b-nav-item',{key:filter.value,attrs:{"active":_vm.type === filter.value},on:{"click":function($event){return _vm.changedFilter(filter.value, filter.name)}}},[_vm._v(_vm._s(filter.text))])}),1)],1),_vm._v(" "),_c('DealersFilter',{directives:[{name:"show",rawName:"v-show",value:(_vm.type === 'dealer_id'),expression:"type === 'dealer_id'"}],attrs:{"filters":_vm.readOptions.filters,"url":"dealers","name":"Distribuidor","field":"dealer_id"},on:{"added-filter":_vm.addFilter}}),_vm._v(" "),_c('DsrFilter',{directives:[{name:"show",rawName:"v-show",value:(_vm.type === 'dsr_id'),expression:"type === 'dsr_id'"}],attrs:{"filters":_vm.readOptions.filters,"name":"Vendedor","field":"dsr_id"},on:{"added-filter":_vm.addFilter}}),_vm._v(" "),_c('Product',{directives:[{name:"show",rawName:"v-show",value:(_vm.type === 'product_id'),expression:"type === 'product_id'"}],attrs:{"filters":_vm.readOptions.filters,"url":"products","name":"Product","field":"product_id"},on:{"added-filter":_vm.addFilter}}),_vm._v(" "),_c('Prodaggreg',{directives:[{name:"show",rawName:"v-show",value:(_vm.type === 'prodaggreg_id'),expression:"type === 'prodaggreg_id'"}],attrs:{"filters":_vm.readOptions.filters,"url":"prodaggregs","name":"Prodaggreg","field":"prodaggreg_id"},on:{"added-filter":_vm.addFilter}}),_vm._v(" "),_c('GeneralFilter',{directives:[{name:"show",rawName:"v-show",value:(_vm.type === 'top10_id'),expression:"type === 'top10_id'"}],attrs:{"filters":_vm.readOptions.filters,"url":"top10","name":"Top UFS","field":"top10_id"},on:{"added-filter":_vm.addFilter}}),_vm._v(" "),_c('GeneralFilter',{directives:[{name:"show",rawName:"v-show",value:(_vm.type === 'product_category_id'),expression:"type === 'product_category_id'"}],attrs:{"filters":_vm.readOptions.filters,"url":"product_categories","name":"Categoria","field":"product_category_id"},on:{"added-filter":_vm.addFilter}}),_vm._v(" "),_c('OperatorsFilter',{directives:[{name:"show",rawName:"v-show",value:(_vm.type === 'operator_id'),expression:"type === 'operator_id'"}],attrs:{"filters":_vm.readOptions.filters},on:{"added-filter":_vm.addFilter}}),_vm._v(" "),_c('ZonesFilter',{directives:[{name:"show",rawName:"v-show",value:(_vm.type === 'zone'),expression:"type === 'zone'"}],attrs:{"filters":_vm.readOptions.filters},on:{"added-filter":_vm.addFilter}}),_vm._v(" "),_c('SOFilter',{directives:[{name:"show",rawName:"v-show",value:(_vm.type === 'stars_so_code'),expression:"type === 'stars_so_code'"}],attrs:{"filters":_vm.readOptions.filters},on:{"added-filter":_vm.addFilter}}),_vm._v(" "),_c('CHAFilter',{directives:[{name:"show",rawName:"v-show",value:(_vm.type === 'stars_cha_code'),expression:"type === 'stars_cha_code'"}],attrs:{"filters":_vm.readOptions.filters},on:{"added-filter":_vm.addFilter}}),_vm._v(" "),_c('STFilter',{directives:[{name:"show",rawName:"v-show",value:(_vm.type === 'stars_st_code'),expression:"type === 'stars_st_code'"}],attrs:{"filters":_vm.readOptions.filters},on:{"added-filter":_vm.addFilter}}),_vm._v(" "),_c('CADVFilter',{directives:[{name:"show",rawName:"v-show",value:(_vm.type === 'stars_cadv_code'),expression:"type === 'stars_cadv_code'"}],attrs:{"filters":_vm.readOptions.filters},on:{"added-filter":_vm.addFilter}})],1)],1)])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 900 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_UserQueries_vue__ = __webpack_require__(901);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_751354da_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_UserQueries_vue__ = __webpack_require__(902);
var normalizeComponent = __webpack_require__(4)
/* script */

/* template */

/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_UserQueries_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_751354da_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_UserQueries_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 901 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Grid_vue__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__progress_kendo_ui_js_kendo_all_js__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__progress_kendo_ui_js_kendo_all_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__progress_kendo_ui_js_kendo_all_js__);




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'Client',
  props: ['height'],
  components: {
    Grid: __WEBPACK_IMPORTED_MODULE_0__components_Grid_vue__["a" /* default */]
  },
  data: function data() {
    return {
      preload: [],
      schemaModelFields: {},
      url: 'queries/sellout',
      columns: [{
        'title': '',
        width: '120px',
        command: {
          'className': 'btn btn-success',
          text: 'carregar',
          click: this.loadQuery
        }
      }, {
        'title': '',
        width: '120px',
        command: {
          'className': 'btn btn-danger',
          text: 'apagar',
          click: this.deleteQuery
        }
      }, {
        field: 'name',
        title: 'Name'
      }],
      loaded: false,
      tableInitialized: false,
      variables: [],
      rows: [],
      subrows: [],
      filters: [],
      tables: []
    };
  },

  methods: {
    loadQuery: function loadQuery(e) {
      e.preventDefault();
      var grid = this.$refs.userQueriesGrid.$refs.mygrid.kendoWidget();
      var dataItem = grid.dataItem(__WEBPACK_IMPORTED_MODULE_1__progress_kendo_ui_js_kendo_all_js___default.a.jQuery(e.currentTarget).closest('tr'));
      this.$emit('load-query', {
        item: dataItem
      });
    },
    deleteQuery: function deleteQuery(e) {
      e.preventDefault();
      var grid = this.$refs.userQueriesGrid.$refs.mygrid.kendoWidget();
      var dataItem = grid.dataItem(__WEBPACK_IMPORTED_MODULE_1__progress_kendo_ui_js_kendo_all_js___default.a.jQuery(e.currentTarget).closest('tr'));
      this.axios.delete('queries/' + dataItem.id).then(function (response) {
        grid.dataSource.read();
      });
    }
  }
});

/***/ }),
/* 902 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('Grid',{ref:"userQueriesGrid",attrs:{"name":"userQueriesGrid","url":_vm.url,"columns":_vm.columns,"pageable":true,"height":_vm.height,"filterable":true,"sortable":true,"schemaModelFields":_vm.schemaModelFields,"preload":_vm.preload}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 903 */,
/* 904 */,
/* 905 */,
/* 906 */,
/* 907 */,
/* 908 */,
/* 909 */,
/* 910 */,
/* 911 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(!_vm.preloadDone)?_c('div',{staticClass:"splash"},[_vm._m(0)]):_vm._e(),_vm._v(" "),(_vm.preloadDone)?_c('div',[_c('b-card',{staticClass:"mt-1"},[_c('div',{staticClass:"text-right queries-toolbar"},[(!_vm.showResults)?_c('a',{attrs:{"href":""},on:{"click":function($event){$event.preventDefault();return _vm.openLoadQueryPopup($event)}}},[_c('i',{staticClass:"fa fa-folder-open"})]):_vm._e(),_vm._v(" "),_c('a',{attrs:{"href":""},on:{"click":function($event){$event.preventDefault();return _vm.openSaveQueryPopup($event)}}},[_c('i',{staticClass:"fa fa-save"})]),_vm._v(" "),_c('a',{attrs:{"href":""},on:{"click":function($event){$event.preventDefault();return _vm.shareQuery($event)}}},[_c('i',{staticClass:"fa fa-share-alt"})])]),_vm._v(" "),(!_vm.showResults)?_c('div',[_c('div',{staticClass:"toolbar"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-2"},[_c('b-form-group',{attrs:{"label":"Tipo de comparação"}},[_c('b-form-radio-group',{attrs:{"id":"radioDates","button-variant":"outline-primary","buttons":"","size":"sm","options":_vm.periodType,"name":"radiosBtnDatesType"},model:{value:(_vm.readOptions.datetype),callback:function ($$v) {_vm.$set(_vm.readOptions, "datetype", $$v)},expression:"readOptions.datetype"}})],1)],1),_vm._v(" "),_c('div',{staticClass:"col-md-1"},[_c('b-form-group',{attrs:{"label":"Ano"}},[_c('b-form-select',{attrs:{"options":_vm.years},model:{value:(_vm.readOptions.year),callback:function ($$v) {_vm.$set(_vm.readOptions, "year", $$v)},expression:"readOptions.year"}})],1)],1),_vm._v(" "),_c('div',{staticClass:"col-md-3"},[_c('b-form-group',{attrs:{"label":"Intervalo"}},[_c('b-form-radio-group',{attrs:{"id":"datesOptions","button-variant":"outline-primary","buttons":"","size":"sm","options":_vm.datesOptions,"name":"radiosBtndatesOptions"},model:{value:(_vm.readOptions.presetdate),callback:function ($$v) {_vm.$set(_vm.readOptions, "presetdate", $$v)},expression:"readOptions.presetdate"}})],1)],1),_vm._v(" "),(_vm.readOptions.presetdate==='custom')?_c('div',{staticClass:"col-md-6"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-4"},[_c('b-form-group',{attrs:{"label":"De"}},[_c('div',{staticClass:"form-inline"},[_c('b-form-select',{attrs:{"options":_vm.days},model:{value:(_vm.readOptions.dates.start.day),callback:function ($$v) {_vm.$set(_vm.readOptions.dates.start, "day", $$v)},expression:"readOptions.dates.start.day"}}),_vm._v(" /\n                      "),_c('b-form-select',{attrs:{"options":_vm.months},model:{value:(_vm.readOptions.dates.start.month),callback:function ($$v) {_vm.$set(_vm.readOptions.dates.start, "month", $$v)},expression:"readOptions.dates.start.month"}})],1)])],1),_vm._v(" "),_c('div',{staticClass:"col-sm-4"},[_c('b-form-group',{attrs:{"label":"a"}},[_c('div',{staticClass:"form-inline"},[_c('b-form-select',{attrs:{"options":_vm.days},model:{value:(_vm.readOptions.dates.end.day),callback:function ($$v) {_vm.$set(_vm.readOptions.dates.end, "day", $$v)},expression:"readOptions.dates.end.day"}}),_vm._v(" /\n                      "),_c('b-form-select',{attrs:{"options":_vm.months},model:{value:(_vm.readOptions.dates.end.month),callback:function ($$v) {_vm.$set(_vm.readOptions.dates.end, "month", $$v)},expression:"readOptions.dates.end.month"}})],1)])],1)])]):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-6"},[_c('b-form-group',{attrs:{"label":"Variável a analisar"}},[_c('b-form-radio-group',{attrs:{"id":"btnradios1","button-variant":"outline-primary","buttons":"","size":"sm","options":_vm.variables,"name":"radiosBtnVars"},model:{value:(_vm.readOptions.columns),callback:function ($$v) {_vm.$set(_vm.readOptions, "columns", $$v)},expression:"readOptions.columns"}})],1)],1),_vm._v(" "),_c('div',{staticClass:"col-md-2"},[(false)?_c('b-form-group',{attrs:{"label":"Perfilado"}},[_c('b-form-radio-group',{attrs:{"id":"btnProfiled","button-variant":"outline-primary","buttons":"","size":"sm","options":_vm.profiledOptions,"name":"radiosBtnProfile"},model:{value:(_vm.readOptions.profiled),callback:function ($$v) {_vm.$set(_vm.readOptions, "profiled", $$v)},expression:"readOptions.profiled"}})],1):_vm._e()],1),_vm._v(" "),_c('div',{staticClass:"col-md-2"},[(false)?_c('b-form-group',{attrs:{"label":"Webshop"}},[_c('b-form-radio-group',{attrs:{"id":"btnWebshop","button-variant":"outline-primary","buttons":"","size":"sm","options":_vm.webshopOptions,"name":"radiosBtnWebshop"},model:{value:(_vm.readOptions.webshop),callback:function ($$v) {_vm.$set(_vm.readOptions, "webshop", $$v)},expression:"readOptions.webshop"}})],1):_vm._e()],1),_vm._v(" "),_c('div',{staticClass:"col-md-2"},[_c('b-form-group',{attrs:{"label":"OFF LINE / OMM"}},[_c('b-form-radio-group',{attrs:{"id":"btnradiosONLINE","button-variant":"outline-primary","buttons":"","size":"sm","options":_vm.onlineOptions,"name":"radiosOnline"},model:{value:(_vm.readOptions.online),callback:function ($$v) {_vm.$set(_vm.readOptions, "online", $$v)},expression:"readOptions.online"}})],1)],1)]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-3"},[_c('b-form-group',{attrs:{"label":"Mostrar em linha"}},[_c('b-form-radio-group',{attrs:{"id":"btnradios2","button-variant":"outline-primary","buttons":"","size":"sm","options":_vm.rows,"name":"radiosRows"},model:{value:(_vm.readOptions.rows),callback:function ($$v) {_vm.$set(_vm.readOptions, "rows", $$v)},expression:"readOptions.rows"}})],1)],1),_vm._v(" "),_c('b-col',{attrs:{"md":"7"}},[_c('div',[_c('b-form-group',{attrs:{"label":"Detalhe"}},[_c('b-form-radio-group',{attrs:{"id":"btnradios3","buttons":"","size":"sm","button-variant":"outline-primary","options":_vm.subrows,"name":"radiosSubRows"},model:{value:(_vm.readOptions.subrows),callback:function ($$v) {_vm.$set(_vm.readOptions, "subrows", $$v)},expression:"readOptions.subrows"}})],1)],1),_vm._v(" "),_c('div',[_c('b-form-group',{attrs:{"label":"Agrupar por"}},[_c('b-form-radio-group',{attrs:{"id":"btnradios4","buttons":"","size":"sm","button-variant":"outline-primary","options":_vm.groups,"name":"radiosSubRows"},model:{value:(_vm.readOptions.groupby),callback:function ($$v) {_vm.$set(_vm.readOptions, "groupby", $$v)},expression:"readOptions.groupby"}})],1)],1)]),_vm._v(" "),_c('b-col',{attrs:{"md":"2"}},[_c('b-form-group',{attrs:{"label":"UFS / UPFIELD / Gallo"}},[_c('b-form-radio-group',{attrs:{"id":"btnradiosUFSBCS","button-variant":"outline-primary","buttons":"","size":"sm","options":_vm.ufsbcsOptions,"name":"radiosBtnbcs"},model:{value:(_vm.readOptions.ufsbcs),callback:function ($$v) {_vm.$set(_vm.readOptions, "ufsbcs", $$v)},expression:"readOptions.ufsbcs"}})],1)],1)],1),_vm._v(" "),_c('div',[_c('b-button',{staticClass:"btn-block",attrs:{"variant":"primary","disabled":_vm.loadingResults,"size":"lg"},on:{"click":function($event){return _vm.showData()}}},[_c('i',{staticClass:"fa fa-search",class:{'fa-search': !_vm.loadingResults, 'fa-spinner': _vm.loadingResults, 'fa-spin': _vm.loadingResults}}),_vm._v(" Pesquisar")])],1),_vm._v(" "),_c('b-alert',{staticClass:"mt-3",attrs:{"variant":"danger","show":_vm.queryErrorShow,"dismissible":""}},[_c('h4',{staticClass:"alert-heading"},[_vm._v("Erro")]),_vm._v(" "+_vm._s(_vm.queryErrorMessage)+"\n        ")])],1):_vm._e(),_vm._v(" "),(_vm.showResults)?_c('div',[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-9"},[_c('div',[_vm._v("A analisar: "),_c('strong',[_vm._v(_vm._s(_vm.columnsName))]),_vm._v(" por "),_c('strong',[_vm._v(_vm._s(_vm.rowsText))]),_vm._v(" "),(_vm.readOptions.groupby !== 'none')?_c('span',[_vm._v(" agrupado por "),_c('strong',[_vm._v(_vm._s(_vm.groupByName))])]):_vm._e(),_vm._v(" | "),_c('a',{directives:[{name:"scroll-to",rawName:"v-scroll-to",value:('#filters-grid'),expression:"'#filters-grid'"}],attrs:{"href":"#"}},[_c('strong',[_vm._v(_vm._s(_vm.totalFilters))]),_vm._v(" filtros")])]),_vm._v(" "),_c('div',{domProps:{"innerHTML":_vm._s(_vm.datesText)}})]),_vm._v(" "),_c('div',{staticClass:"col-sm-3"},[_c('b-button',{staticClass:"pull-right btn-block",attrs:{"variant":"primary","size":"lg"},on:{"click":function($event){return _vm.showForm()}}},[_vm._v("Alterar")])],1)])]):_vm._e()]),_vm._v(" "),_c('StatsFilter',{ref:"filtersPane",attrs:{"id":"filters-grid","filters":_vm.filterOptions,"showFilterGrid":_vm.showFilterGrid,"showResults":_vm.showResults,"totalFilters":_vm.totalFilters,"readOptions":_vm.readOptions}}),_vm._v(" "),_c('fullscreen',{attrs:{"fullscreen":_vm.fullscreenGrid},on:{"update:fullscreen":function($event){_vm.fullscreenGrid=$event}}},[(_vm.showResults)?_c('div',{staticClass:"statistics-results",attrs:{"id":"statistics-results"}},[_c('b-card',{attrs:{"no-body":""}},[_c('b-card-header',{staticClass:"text-right"},[(_vm.$auth.check(['all.export', 'dim.export']))?_c('b-btn',{attrs:{"variant":"outline-primary","disabled":_vm.exporting,"size":"sm"},on:{"click":_vm.exportResults}},[(!_vm.exporting)?_c('i',{staticClass:"fa fa-download"}):_vm._e(),(_vm.exporting)?_c('i',{staticClass:"fa fa-spinner fa-spin"}):_vm._e(),_vm._v(" exportar")]):_vm._e(),_vm._v(" "),_c('b-btn',{attrs:{"variant":"outline-primary","size":"sm"},on:{"click":_vm.toggleFullscreen}},[_c('i',{staticClass:"fa fa-expand"}),_vm._v(" fullscreen")])],1),_vm._v(" "),_c('kendo-tooltip',{attrs:{"content":_vm.getTooltipContents,"width":200,"filter":'.value-cell'}},[(_vm.loaded)?_c('statistics-grid',{ref:"statsGrid",attrs:{"rows":_vm.rows,"groupDefinition":_vm.groupDefinition,"aggregateDefinition":_vm.aggregateDefinition,"query":_vm.readOptions,"name":"statisticsGrid","url":_vm.url,"columns":_vm.columns,"pageable":true,"filterable":true,"sortable":true,"schemaModelFields":_vm.schemaModelFields,"schemaModelId":'id',"preload":_vm.preload,"details":_vm.details},on:{"ds-error":_vm.loadingError}}):_vm._e()],1)],1)],1):_vm._e()]),_vm._v(" "),(_vm.$auth.check(['superuser']))?_c('div'):_vm._e()],1):_vm._e(),_vm._v(" "),_c('b-modal',{ref:"downloadModal",attrs:{"id":"downloadModal"}},[_vm._v("\n    O ficheiro está pronto:\n    "),_c('a',{attrs:{"href":_vm.fileDownload.url,"target":"_blank"}},[_vm._v(_vm._s(_vm.fileDownload.title))]),_vm._v(" "),_c('div',{staticClass:"w-100",attrs:{"slot":"modal-footer"},slot:"modal-footer"},[_c('b-btn',{staticClass:"float-right",attrs:{"size":"sm","variant":"primary"},on:{"click":_vm.hideModal}},[_vm._v("\n        Close\n      ")])],1)]),_vm._v(" "),_c('b-modal',{ref:"downloadModal",attrs:{"id":"downloadModal"}},[_vm._v("\n    O ficheiro está pronto:\n    "),_c('a',{attrs:{"href":_vm.fileDownload.url,"target":"_blank"}},[_vm._v(_vm._s(_vm.fileDownload.title))]),_vm._v(" "),_c('div',{staticClass:"w-100",attrs:{"slot":"modal-footer"},slot:"modal-footer"},[_c('b-btn',{staticClass:"float-right",attrs:{"size":"sm","variant":"primary"},on:{"click":_vm.hideModal}},[_vm._v("\n        Close\n      ")])],1)]),_vm._v(" "),_c('b-modal',{ref:"saveModal",attrs:{"id":"saveModal","title":"Gravar pesquisa"}},[_c('b-form',{on:{"submit":_vm.saveQuery}},[_c('b-form-input',{ref:"queryName",attrs:{"type":"text"},model:{value:(_vm.queryName),callback:function ($$v) {_vm.queryName=$$v},expression:"queryName"}})],1),_vm._v(" "),_c('div',{staticClass:"w-100",attrs:{"slot":"modal-footer"},slot:"modal-footer"},[_c('b-btn',{staticClass:"float-left",attrs:{"size":"sm","variant":"secondary"},on:{"click":_vm.hideSaveModal}},[_vm._v("\n        Close\n      ")]),_vm._v(" "),_c('b-btn',{staticClass:"float-right",attrs:{"size":"sm","variant":"success"},on:{"click":_vm.saveQuery}},[_c('i',{staticClass:"fa fa-save-o"}),_vm._v(" Gravar\n      ")])],1)],1),_vm._v(" "),_c('b-modal',{ref:"shareModal",attrs:{"id":"shareModal"}},[_c('b-form',[_c('b-form-input',{ref:"queryName",attrs:{"readonly":"","type":"text"},model:{value:(_vm.queryUrl),callback:function ($$v) {_vm.queryUrl=$$v},expression:"queryUrl"}})],1),_vm._v(" "),_c('div',{staticClass:"w-100",attrs:{"slot":"modal-footer"},slot:"modal-footer"},[_c('b-btn',{staticClass:"float-left",attrs:{"size":"sm","variant":"secondary"},on:{"click":_vm.hideShareModal}},[_vm._v("\n        Close\n      ")])],1)],1),_vm._v(" "),_c('b-modal',{ref:"loadQueryModal",attrs:{"size":"lg","id":"loadQueryModal"},on:{"shown":function($event){_vm.showQueries=true},"hidden":function($event){_vm.showQueries=false}}},[(_vm.showQueries)?_c('UserQueries',{attrs:{"height":"400"},on:{"load-query":_vm.loadUserQuery}}):_vm._e()],1)],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container  d-flex h-100"},[_c('div',{staticClass:"row justify-content-center text-primary w-100 align-self-center text-white"},[_c('i',{staticClass:"fa fa-spin fa-spinner"})])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 912 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Statistics_vue__ = __webpack_require__(913);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6556f7a7_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_Statistics_vue__ = __webpack_require__(929);
var normalizeComponent = __webpack_require__(4)
/* script */

/* template */

/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Statistics_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6556f7a7_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_Statistics_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 913 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__views_sellin_Filters_vue__ = __webpack_require__(914);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__views_sellin_UserQueries_vue__ = __webpack_require__(926);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_fullscreen__ = __webpack_require__(407);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_fullscreen___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vue_fullscreen__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__progress_kendo_popups_vue_wrapper__ = __webpack_require__(408);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__progress_kendo_popups_vue_wrapper___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__progress_kendo_popups_vue_wrapper__);









__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_4__progress_kendo_popups_vue_wrapper__["PopupsInstaller"]);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_3_vue_fullscreen___default.a);
/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'Sellin',
  components: {
    Filters: __WEBPACK_IMPORTED_MODULE_1__views_sellin_Filters_vue__["a" /* default */],
    UserQueries: __WEBPACK_IMPORTED_MODULE_2__views_sellin_UserQueries_vue__["a" /* default */]
  },
  data: function data() {
    return {
      preload: [],
      schemaModelFields: {},
      url: 'sellin',
      loadingResults: false,
      queryErrorShow: false,
      queryErrorMessage: 'Houve um erro com a sua pesquisa',
      readOptions: {
        columns: 'value',
        rows: 'products',
        subrows: 'prodaggreg_id',
        groupby: 'none',
        presetdate: 'today',
        datetype: 'y',
        year: 2026,
        clientType: 'A',
        docType: 'AGR',
        dates: {
          start: {
            day: 1,
            month: 1
          },
          end: {
            day: 31,
            month: 12
          }
        },
        filters: []
      },
      clientTypes: [{
        value: 'A',
        text: 'Todos'
      }, {
        value: 'F',
        text: 'Fatura'
      }, {
        value: 'G',
        text: 'Guias'
      }],
      documentTypes: [{
        value: 'A',
        text: 'Todos'
      }, {
        value: 'AGR',
        text: 'Sem guias'
      }, {
        value: 'SG',
        text: 'Só guias'
      }],
      aggregateDefinition: [],
      details: [],
      columns: [],
      preloadDone: false,
      loaded: false,
      showFilterType: '',
      showFilterGrid: true,
      showResults: false,
      tableInitialized: false,
      fullscreenGrid: false,
      exporting: false,
      showQueries: false,
      fileDownload: '',
      variables: [],
      rows: [],
      subrows: [],
      groups: [],
      queryName: '',
      queryUrl: '',
      years: [{
        value: 2018,
        text: '2018'
      }, {
        value: 2019,
        text: '2019'
      }, {
        value: 2020,
        text: '2020'
      }, {
        value: 2021,
        text: '2021'
      }, {
        value: 2022,
        text: '2022'
      }, {
        value: 2023,
        text: '2023'
      }, {
        value: 2024,
        text: '2024'
      }, {
        value: 2025,
        text: '2025'
      }, {
        value: 2026,
        text: '2026'
      }],
      days: [],
      months: [{
        value: 1,
        text: 'Jan.'
      }, {
        value: 2,
        text: 'Fev.'
      }, {
        value: 3,
        text: 'Mar.'
      }, {
        value: 4,
        text: 'Abr.'
      }, {
        value: 5,
        text: 'Mai.'
      }, {
        value: 6,
        text: 'Jun.'
      }, {
        value: 7,
        text: 'Jul.'
      }, {
        value: 8,
        text: 'Ago.'
      }, {
        value: 9,
        text: 'Set.'
      }, {
        value: 10,
        text: 'Out.'
      }, {
        value: 11,
        text: 'Nov.'
      }, {
        value: 12,
        text: 'Dez.'
      }],
      filterOptions: [],
      datesOptions: [{
        text: 'até ontem',
        value: 'today'
      }, {
        text: 'Q1',
        value: 'q1'
      }, {
        text: 'Q2',
        value: 'q2'
      }, {
        text: 'Q3',
        value: 'q3'
      }, {
        text: 'Q4',
        value: 'q4'
      }, {
        text: 'customizado',
        value: 'custom'
      }],
      periodType: [{
        value: 'y',
        text: 'Ano'
      }, {
        value: 'ym',
        text: 'Ano / Mês'
      }]
    };
  },

  methods: {
    showData: function showData() {
      var _this = this;

      this.loaded = false;
      this.loadingResults = true;
      this.queryErrorShow = false;
      this.showFilterGrid = false;
      this.showResults = false;
      this.axios.post('sellin/columns', this.readOptions).then(function (response) {
        _this.columns = response.data.data.columns;
        _this.aggregateDefinition = response.data.data.aggregates;
        _this.groupDefinition = response.data.data.groups;
        _this.schemaModelFields = response.data.data.fields;

        if (!_this.tableInitialized) {
          _this.loaded = true;
          _this.showResults = true;
        } else {
          _this.$refs.statsGrid.refresh();
          _this.showResults = true;
          _this.loaded = true;
        }
        var that = _this;
        setTimeout(function () {
          that.$scrollTo('#statistics-results', 300, {
            offset: -60
          });
        }, 100);
      });
    },
    showForm: function showForm() {
      this.loaded = false;
      this.showResults = false;
      this.showFilterGrid = true;
      this.loadingResults = false;
    },
    loadingError: function loadingError(e) {
      this.loaded = false;
      this.loadingResults = false;
      this.showFilterGrid = true;
      this.showResults = false;
      this.queryErrorShow = true;
      var error = e.xhr.responseJSON;
      if (error.status_code === 503) {
        this.queryErrorMessage = error.message;
      } else {
        this.queryErrorMessage = 'Houve um erro com a sua pesquisa';
      }
    },
    changedRows: function changedRows() {
      this.subrows = this.rows[this.readOptions.rows].sub;
      this.readOptions.subrows = this.rows[this.readOptions.rows].default;
      this.details = this.subrows[this.readOptions.subrows].details;
      this.setGroups();
    },
    setGroups: function setGroups() {
      this.groups = [];
      var g = this.subrows[this.readOptions.subrows].groupby;
      this.groups.push({
        value: 'none',
        text: 'Consolidado'
      });

      var active = false;
      for (var i = 0; i < g.length; i++) {
        this.groups.push(g[i]);
        if (this.readOptions.groupby === g[i].value) {
          active = true;
        }
      }
      if (!active) {
        this.readOptions.groupby = 'none';
      }
    },
    changedSubRows: function changedSubRows() {
      this.details = this.subrows[this.readOptions.subrows].details;
      this.groups = [];
      this.setGroups();
    },
    exportResults: function exportResults(e) {
      var _this2 = this;

      e.preventDefault();
      this.exporting = true;
      this.axios.post('sellin/export', this.readOptions).then(function (response) {
        _this2.fileDownload = response.data;
        _this2.$refs.downloadModal.show();
        _this2.exporting = false;
      });
    },
    toggleFullscreen: function toggleFullscreen() {
      this.fullscreenGrid = !this.fullscreenGrid;
    },

    hideModal: function hideModal() {
      this.$refs.downloadModal.hide();
    },
    hideSaveModal: function hideSaveModal() {
      this.$refs.saveModal.hide();
    },
    hideShareModal: function hideShareModal() {
      this.$refs.shareModal.hide();
    },
    getTooltipContents: function getTooltipContents(e) {
      return e.target.data('past') + '<br>' + e.target.data('current') + '<br>' + e.target.data('dif');
    },
    getQuery: function getQuery(queryId) {
      var _this3 = this;

      this.axios.get('queries/' + queryId).then(function (response) {
        _this3.loadQuery(response.data.data);
      });
    },
    openSaveQueryPopup: function openSaveQueryPopup() {
      this.$refs.saveModal.show();
    },
    openLoadQueryPopup: function openLoadQueryPopup() {
      this.$refs.loadQueryModal.show();
    },
    shareQuery: function shareQuery() {
      var _this4 = this;

      this.axios.post('queries', this.readOptions).then(function (response) {
        var route = _this4.$router.resolve({
          name: 'sellin.index',
          params: {
            id: response.data.data.uuid
          }
        });
        _this4.queryUrl = window.location.origin + route.href;
        _this4.$refs.shareModal.show();
      });
    },
    saveQuery: function saveQuery() {
      var _this5 = this;

      this.axios.post('userqueries', {
        query: this.readOptions,
        query_type: 'sellin',
        name: this.queryName
      }).then(function (response) {
        _this5.$router.replace({
          name: 'sellin.index',
          params: {
            id: response.data.data.uuid
          }
        });
        _this5.hideSaveModal();
      });
    },
    loadUserQuery: function loadUserQuery(evt) {
      this.$router.push({
        name: 'sellin.index',
        params: {
          id: evt.item.uquery.data.uuid
        }
      });

      this.$refs.loadQueryModal.hide();
    },
    loadQuery: function loadQuery(data) {
      this.readOptions.columns = data.columns;
      this.readOptions.presetdate = data.presetdate;
      this.readOptions.datetype = data.datetype;
      this.readOptions.dates = data.dates;
      this.readOptions.year = data.year;
      this.readOptions.rows = data.rows;
      this.readOptions.subrows = data.subrows;
      this.readOptions.groupby = data.groupby;
      this.readOptions.filters = data.filters;
    }
  },
  computed: {
    columnsName: function columnsName() {
      return this.variables[this.readOptions.columns].text;
    },
    datesText: function datesText() {
      var txt = 'Ano: <strong>' + this.readOptions.year + '</strong> vs <strong>' + (this.readOptions.year - 1) + '</strong> ';
      txt += 'período: <strong>';
      switch (this.readOptions.presetdate) {
        case 'today':
          txt += ' do início do ano até ontem';
          break;
        case 'q1':
          txt += ' 1º trimestre';
          break;
        case 'q2':
          txt += ' 2º trimestre';
          break;
        case 'q3':
          txt += ' 3º trimestre';
          break;
        case 'q4':
          txt += ' 4º trimestre';
          break;
        case 'custom':
          txt += ' de ' + this.readOptions.dates.start.day + '/' + this.readOptions.dates.start.month;
          txt += ' a ' + this.readOptions.dates.end.day + '/' + this.readOptions.dates.end.month;
      }
      txt += '</strong>';
      return txt;
    },
    groupByName: function groupByName() {
      var sub = this.rows[this.readOptions.rows].sub;
      var groups = sub[this.readOptions.subrows].groupby;
      for (var i = 0; i < groups.length; i++) {
        if (groups[i].value === this.readOptions.groupby) {
          return groups[i].text;
        }
      }
      return '';
    },
    rowsText: function rowsText() {
      var sub = this.rows[this.readOptions.rows].sub;
      return sub[this.readOptions.subrows].text + ' (' + this.rows[this.readOptions.rows].text + ')';
    },
    totalFilters: function totalFilters() {
      var total = 0;
      for (var i = 0; i < this.readOptions.filters.length; i++) {
        total += this.readOptions.filters[i].includes.length;
        total += this.readOptions.filters[i].excludes.length;
      }
      return total;
    }
  },
  watch: {
    'readOptions.rows': function readOptionsRows(val, oldVal) {
      this.changedRows();
    },
    'readOptions.subrows': function readOptionsSubrows(val, oldVal) {
      this.changedSubRows();
    }
  },
  beforeRouteUpdate: function beforeRouteUpdate(to, from, next) {
    var _this6 = this;

    if (to.params.id !== 'index') {
      this.axios.get('queries/' + to.params.id).then(function (response) {
        _this6.loadQuery(response.data.data);
        next();
      });
    } else {
      this.readOptions = {
        columns: 'value',
        rows: 'products',
        subrows: 'prodaggreg_id',
        groupby: 'none',
        presetdate: 'today',
        datetype: 'y',
        clientType: 'A',
        docType: 'AGR',
        year: 2026,
        dates: {
          start: {
            day: 1,
            month: 1
          },
          end: {
            day: 31,
            month: 12
          }
        },
        filters: []
      };
      next();
    }
  },
  created: function created() {
    var _this7 = this;

    for (var i = 1; i <= 31; i++) {
      this.days.push({
        value: i,
        text: i
      });
    }
    var today = new Date();
    var apiPreloads = [{
      url: 'sellin/variables',
      callback: setVariables
    }, {
      url: 'sellin/rows',
      callback: setRows
    }, {
      url: 'sellin/filters',
      callback: setFilters
    }];
    if (typeof this.$route.params.id !== 'undefined' && this.$route.params.id !== 'index') {
      apiPreloads.push({
        url: 'queries/' + this.$route.params.id,
        callback: this.loadQuery
      });
    }
    var that = this;
    this.axios.all(apiPreloads.map(function (l) {
      return _this7.axios.get(l.url);
    })).then(that.axios.spread(function () {
      for (var i = 0; i < apiPreloads.length; i++) {
        apiPreloads[i].callback(arguments[i].data.data);
      }
      that.preloadDone = true;
    })).catch(function (response) {
      console.error('error loading foreigns', response);
    });

    function setVariables(response) {
      that.variables = response;
    }

    function setRows(response) {
      that.rows = response;
      that.subrows = that.rows[that.readOptions.rows].sub;
      that.readOptions.subrows = that.rows[that.readOptions.rows].default;
      that.details = that.subrows[that.readOptions.subrows].details;
      that.setGroups();
    }

    function setFilters(response) {
      that.filterOptions = response;
    }
    this.readOptions.dates.end.day = today.getDate();
    this.readOptions.dates.end.month = today.getMonth() + 1;
  }
});

/***/ }),
/* 914 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Filters_vue__ = __webpack_require__(915);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ecf249b2_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_Filters_vue__ = __webpack_require__(925);
var normalizeComponent = __webpack_require__(4)
/* script */

/* template */

/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Filters_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ecf249b2_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_Filters_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 915 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__views_Filters_Filter_vue__ = __webpack_require__(402);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__views_Filters_BrandFilter_vue__ = __webpack_require__(916);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__views_Filters_ProdAgregFilter_vue__ = __webpack_require__(404);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__views_Filters_DealersFilter_vue__ = __webpack_require__(403);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__views_Filters_ProductFilter_vue__ = __webpack_require__(406);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__views_Filters_SellinOperatorsFilter_vue__ = __webpack_require__(919);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__views_Filters_SellinSOFilter_vue__ = __webpack_require__(922);










/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'Filters',
  components: {
    GeneralFilter: __WEBPACK_IMPORTED_MODULE_0__views_Filters_Filter_vue__["a" /* default */],
    DealersFilter: __WEBPACK_IMPORTED_MODULE_3__views_Filters_DealersFilter_vue__["a" /* default */],
    Brand: __WEBPACK_IMPORTED_MODULE_1__views_Filters_BrandFilter_vue__["a" /* default */],
    Prodaggreg: __WEBPACK_IMPORTED_MODULE_2__views_Filters_ProdAgregFilter_vue__["a" /* default */],
    Product: __WEBPACK_IMPORTED_MODULE_4__views_Filters_ProductFilter_vue__["a" /* default */],
    SellinOperators: __WEBPACK_IMPORTED_MODULE_5__views_Filters_SellinOperatorsFilter_vue__["a" /* default */],
    SOFilter: __WEBPACK_IMPORTED_MODULE_6__views_Filters_SellinSOFilter_vue__["a" /* default */]
  },
  props: ['showFilterGrid', 'filters', 'showResults', 'totalFilters', 'readOptions'],
  data: function data() {
    return {
      type: null,
      name: ''
    };
  },

  methods: {
    changedFilter: function changedFilter(field, name) {
      this.type = field;
      this.name = name;
    },
    removeBeforeAdding: function removeBeforeAdding(evt) {
      for (var i = 0; i < this.readOptions.filters.length; i++) {
        if (this.readOptions.filters[i].field === evt.field) {
          for (var w = 0; w < this.readOptions.filters[i]['includes'].length; w++) {
            if (evt.item.id === this.readOptions.filters[i]['includes'][w].id) {
              this.readOptions.filters[i]['includes'].splice(w, 1);
            }
          }
          for (var _w = 0; _w < this.readOptions.filters[i]['excludes'].length; _w++) {
            if (evt.item.id === this.readOptions.filters[i]['excludes'][_w].id) {
              this.readOptions.filters[i]['excludes'].splice(_w, 1);
            }
          }
          break;
        }
      }
    },
    addFilter: function addFilter(evt) {
      var start = window.performance.now();
      console.log('event received', start);
      var found = false;
      this.removeBeforeAdding(evt);
      for (var i = 0; i < this.readOptions.filters.length; i++) {
        if (this.readOptions.filters[i].field === evt.field) {
          this.readOptions.filters[i][evt.type].push({
            id: evt.item.id,
            name: evt.item.name
          });
          found = true;
        }
      }
      if (!found) {
        if (evt.type === 'includes') {
          this.readOptions.filters.push({
            field: evt.field,
            title: evt.title,
            includes: [{
              id: evt.item.id,
              name: evt.item.name
            }],
            excludes: []
          });
        } else {
          this.readOptions.filters.push({
            field: evt.field,
            title: evt.title,
            excludes: [{
              id: evt.item.id,
              name: evt.item.name
            }],
            includes: []
          });
        }
      }
      console.log('added to list', window.performance.now());
      console.log('added to list elapsed', window.performance.now() - start);
    },
    removeFilter: function removeFilter(field, index, type) {
      for (var i = 0; i < this.readOptions.filters.length; i++) {
        if (this.readOptions.filters[i].field === field) {
          if (type === 'includes') {
            this.readOptions.filters[i].includes.splice(index, 1);
          } else {
            this.readOptions.filters[i].excludes.splice(index, 1);
          }
        }
      }
    },
    removeAllFilters: function removeAllFilters(field) {
      for (var i = 0; i < this.readOptions.filters.length; i++) {
        if (this.readOptions.filters[i].field === field) {
          this.readOptions.filters[i].includes = [];
          this.readOptions.filters[i].excludes = [];
        }
      }
    }
  },
  created: function created() {}
});

/***/ }),
/* 916 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_BrandFilter_vue__ = __webpack_require__(917);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6f109452_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_BrandFilter_vue__ = __webpack_require__(918);
var normalizeComponent = __webpack_require__(4)
/* script */

/* template */

/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_BrandFilter_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6f109452_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_BrandFilter_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 917 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Grid_vue__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__BaseFilter__ = __webpack_require__(24);




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'Brand',
  extends: __WEBPACK_IMPORTED_MODULE_1__BaseFilter__["a" /* default */],
  components: {
    Grid: __WEBPACK_IMPORTED_MODULE_0__components_Grid_vue__["a" /* default */]
  },
  data: function data() {
    return {
      fieldName: 'brand_id',
      fieldLabel: 'Marca',
      gridRef: 'filterGridBrand',
      preload: [],
      schemaModelFields: {},
      url: 'brands',
      columns: [{
        'title': '',
        width: '120px',
        command: {
          'className': 'btn btn-success',
          text: 'incluir',
          click: this.addIncludeFilter
        }
      }, {
        'title': '',
        width: '120px',
        command: {
          'className': 'btn btn-danger',
          text: 'excluir',
          click: this.addExcludeFilter
        }
      }, {
        width: '160px',
        field: 'code',
        title: 'Código'
      }, {
        field: 'name',
        title: 'Name',
        width: '200px'
      }],
      loaded: false,
      tableInitialized: false
    };
  }
});

/***/ }),
/* 918 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('Grid',{ref:"filterGridBrand",attrs:{"name":"filterGridBrand","url":_vm.url,"columns":_vm.columns,"pageable":false,"height":_vm.height,"filterable":true,"sortable":true,"schemaModelFields":_vm.schemaModelFields,"preload":_vm.preload}}),_vm._v(" "),_c('div',[_c('b-button',{attrs:{"variant":"success"},on:{"click":function($event){return _vm.addAll()}}},[_vm._v("Incluir todos")]),_vm._v(" "),_c('b-button',{attrs:{"variant":"danger"},on:{"click":function($event){return _vm.excludeAll()}}},[_vm._v("Excluir todos")])],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 919 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SellinOperatorsFilter_vue__ = __webpack_require__(920);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f99f59b0_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_SellinOperatorsFilter_vue__ = __webpack_require__(921);
var normalizeComponent = __webpack_require__(4)
/* script */

/* template */

/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SellinOperatorsFilter_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f99f59b0_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_SellinOperatorsFilter_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 920 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Grid_vue__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__BaseFilter__ = __webpack_require__(24);




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'Operator',
  extends: __WEBPACK_IMPORTED_MODULE_1__BaseFilter__["a" /* default */],
  components: {
    Grid: __WEBPACK_IMPORTED_MODULE_0__components_Grid_vue__["a" /* default */]
  },
  data: function data() {
    return {
      fieldName: 'operator_id',
      fieldLabel: 'Operator',
      gridRef: 'filterGridSellinOperator',
      preload: [],
      schemaModelFields: {},
      url: 'sellin_operators',
      columns: [{
        'title': '',
        width: '120px',
        command: {
          'className': 'btn btn-success',
          text: 'incluir',
          click: this.addIncludeFilter
        }
      }, {
        'title': '',
        width: '120px',
        command: {
          'className': 'btn btn-danger',
          text: 'excluir',
          click: this.addExcludeFilter
        }
      }, {
        width: '160px',
        field: 'shipto',
        title: 'Shipto'
      }, {
        width: '160px',
        field: 'soldto',
        title: 'Soldto'
      }, {
        width: '160px',
        field: 'nif',
        title: 'NIF'
      }, {
        field: 'name',
        title: 'Name',
        width: '200px'
      }],
      loaded: false,
      tableInitialized: false
    };
  }
});

/***/ }),
/* 921 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('Grid',{ref:"filterGridSellinOperator",attrs:{"name":"filterGridSellinOperator","url":_vm.url,"columns":_vm.columns,"pageable":true,"height":_vm.height,"filterable":true,"sortable":true,"schemaModelFields":_vm.schemaModelFields,"preload":_vm.preload,"databound":_vm.dataBound}}),_vm._v(" "),_c('div',[_c('b-button',{attrs:{"variant":"success"},on:{"click":function($event){return _vm.addAll()}}},[_vm._v("Incluir todos")]),_vm._v(" "),_c('b-button',{attrs:{"variant":"danger"},on:{"click":function($event){return _vm.excludeAll()}}},[_vm._v("Excluir todos")])],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 922 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SellinSOFilter_vue__ = __webpack_require__(923);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_12598623_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_SellinSOFilter_vue__ = __webpack_require__(924);
var normalizeComponent = __webpack_require__(4)
/* script */

/* template */

/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SellinSOFilter_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_12598623_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_SellinSOFilter_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 923 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Grid_vue__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__BaseFilter__ = __webpack_require__(24);




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'SO',
  extends: __WEBPACK_IMPORTED_MODULE_1__BaseFilter__["a" /* default */],
  components: {
    Grid: __WEBPACK_IMPORTED_MODULE_0__components_Grid_vue__["a" /* default */]
  },
  data: function data() {
    return {
      fieldName: 'ufs_salesteam_code',
      fieldLabel: 'Vendedor',
      gridRef: 'filterGridSO',
      preload: [],
      schemaModelFields: {},
      url: 'ufs_salesteam',
      columns: [{
        'title': '',
        width: '120px',
        command: {
          'className': 'btn btn-success',
          text: 'incluir',
          click: this.addIncludeFilter
        }
      }, {
        'title': '',
        width: '120px',
        command: {
          'className': 'btn btn-danger',
          text: 'excluir',
          click: this.addExcludeFilter
        }
      }, {
        width: '160px',
        field: 'ufs_salesteam_code',
        title: 'Código'
      }, {
        field: 'ufs_salesteam_name',
        title: 'Name',
        width: '200px'
      }],
      loaded: false,
      tableInitialized: false
    };
  }
});

/***/ }),
/* 924 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('Grid',{ref:"filterGridSO",attrs:{"name":"filterGridSO","url":_vm.url,"columns":_vm.columns,"pageable":false,"height":_vm.height,"filterable":true,"sortable":true,"schemaModelFields":_vm.schemaModelFields,"preload":_vm.preload,"databound":_vm.dataBound}}),_vm._v(" "),_c('div',[_c('b-button',{attrs:{"variant":"success"},on:{"click":function($event){return _vm.addAll()}}},[_vm._v("Incluir todos")]),_vm._v(" "),_c('b-button',{attrs:{"variant":"danger"},on:{"click":function($event){return _vm.excludeAll()}}},[_vm._v("Excluir todos")])],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 925 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-card',{attrs:{"title":"Filtros"}},[_c('div',{staticClass:"row filter-column"},[_c('div',{staticClass:"col-md",class:{ 'col-md-4': _vm.showFilterGrid }},[_c('b-card-group',{attrs:{"columns":""}},[(_vm.totalFilters===0)?_c('b-card',[_vm._v("\n          Sem filtros\n        ")]):_vm._e(),_vm._v(" "),_vm._l((_vm.readOptions.filters),function(filter){return _c('b-card',{directives:[{name:"show",rawName:"v-show",value:(filter.includes.length > 0 || filter.excludes.length > 0),expression:"filter.includes.length > 0 || filter.excludes.length > 0"}],key:filter.field,attrs:{"no-body":""}},[_c('b-card-header',[_vm._v("\n            "+_vm._s(filter.title)+"\n          ")]),_vm._v(" "),_c('b-list-group',[_vm._l((filter.includes),function(item,index){return _c('b-list-group-item',{key:item.id,staticClass:"d-flex justify-content-between align-items-center",attrs:{"variant":"success"}},[_vm._v("\n              "+_vm._s(item.name)+"\n              "),_c('b-badge',{directives:[{name:"show",rawName:"v-show",value:(_vm.showFilterGrid),expression:"showFilterGrid"}],attrs:{"variant":"danger"},on:{"click":function($event){return _vm.removeFilter(filter.field, index, 'includes')}}},[_c('i',{staticClass:"fa fa-times"})])],1)}),_vm._v(" "),_vm._l((filter.excludes),function(item,index){return _c('b-list-group-item',{key:item.id,staticClass:"d-flex justify-content-between align-items-center",attrs:{"variant":"danger"}},[_vm._v("\n              "+_vm._s(item.name)+"\n              "),_c('b-badge',{directives:[{name:"show",rawName:"v-show",value:(_vm.showFilterGrid),expression:"showFilterGrid"}],attrs:{"variant":"danger"},on:{"click":function($event){return _vm.removeFilter(filter.field, index, 'excludes')}}},[_c('i',{staticClass:"fa fa-times"})])],1)})],2),_vm._v(" "),_c('b-card-footer',[_c('a',{directives:[{name:"show",rawName:"v-show",value:(_vm.showFilterGrid),expression:"showFilterGrid"}],staticClass:"text-danger",on:{"click":function($event){return _vm.removeAllFilters(filter.field)}}},[_vm._v("Limpar filtros "),_c('i',{staticClass:"fa fa-ban"})])])],1)})],2)],1),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.showFilterGrid),expression:"showFilterGrid"}],staticClass:"col-md-8"},[_c('b-card',{attrs:{"no-body":""}},[_c('b-card-header',[_c('b-nav',{attrs:{"pills":""}},_vm._l((_vm.filters),function(filter){return _c('b-nav-item',{key:filter.value,attrs:{"active":_vm.type === filter.value},on:{"click":function($event){return _vm.changedFilter(filter.value, filter.name)}}},[_vm._v(_vm._s(filter.text))])}),1)],1),_vm._v(" "),_c('DealersFilter',{directives:[{name:"show",rawName:"v-show",value:(_vm.type === 'dealer_id'),expression:"type === 'dealer_id'"}],attrs:{"filters":_vm.readOptions.filters,"url":"dealers","name":"Distribuidor","field":"dealer_id"},on:{"added-filter":_vm.addFilter}}),_vm._v(" "),_c('Product',{directives:[{name:"show",rawName:"v-show",value:(_vm.type === 'product_id'),expression:"type === 'product_id'"}],attrs:{"filters":_vm.readOptions.filters,"url":"products","name":"Product","field":"product_id"},on:{"added-filter":_vm.addFilter}}),_vm._v(" "),_c('Prodaggreg',{directives:[{name:"show",rawName:"v-show",value:(_vm.type === 'prodaggreg_id'),expression:"type === 'prodaggreg_id'"}],attrs:{"filters":_vm.readOptions.filters,"url":"prodaggregs","name":"Prodaggreg","field":"prodaggreg_id"},on:{"added-filter":_vm.addFilter}}),_vm._v(" "),_c('GeneralFilter',{directives:[{name:"show",rawName:"v-show",value:(_vm.type === 'top10_id'),expression:"type === 'top10_id'"}],attrs:{"filters":_vm.readOptions.filters,"url":"top10","name":"Top10","field":"top10_id"},on:{"added-filter":_vm.addFilter}}),_vm._v(" "),_c('GeneralFilter',{directives:[{name:"show",rawName:"v-show",value:(_vm.type === 'product_category_id'),expression:"type === 'product_category_id'"}],attrs:{"filters":_vm.readOptions.filters,"url":"product_categories","name":"Categoria","field":"product_category_id"},on:{"added-filter":_vm.addFilter}}),_vm._v(" "),_c('SellinOperators',{directives:[{name:"show",rawName:"v-show",value:(_vm.type === 'operator_id'),expression:"type === 'operator_id'"}],attrs:{"filters":_vm.readOptions.filters},on:{"added-filter":_vm.addFilter}}),_vm._v(" "),_c('GeneralFilter',{directives:[{name:"show",rawName:"v-show",value:(_vm.type === 'rtm_id'),expression:"type === 'rtm_id'"}],attrs:{"filters":_vm.readOptions.filters,"url":"rtm","name":"RTM","field":"rtm_id"},on:{"added-filter":_vm.addFilter}}),_vm._v(" "),_c('GeneralFilter',{directives:[{name:"show",rawName:"v-show",value:(_vm.type === 'customer_type_id'),expression:"type === 'customer_type_id'"}],attrs:{"filters":_vm.readOptions.filters,"url":"sellin_customer_types","name":"Customer Type 2","field":"customer_type_id"},on:{"added-filter":_vm.addFilter}}),_vm._v(" "),_c('GeneralFilter',{directives:[{name:"show",rawName:"v-show",value:(_vm.type === 'operator_group_id'),expression:"type === 'operator_group_id'"}],attrs:{"filters":_vm.readOptions.filters,"url":"sellin_operator_groups","name":"Customer Type","field":"operator_group_id"},on:{"added-filter":_vm.addFilter}}),_vm._v(" "),_c('SOFilter',{directives:[{name:"show",rawName:"v-show",value:(_vm.type === 'ufs_salesteam_code'),expression:"type === 'ufs_salesteam_code'"}],attrs:{"filters":_vm.readOptions.filters},on:{"added-filter":_vm.addFilter}})],1)],1)])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 926 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_UserQueries_vue__ = __webpack_require__(927);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_557d9372_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_UserQueries_vue__ = __webpack_require__(928);
var normalizeComponent = __webpack_require__(4)
/* script */

/* template */

/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_UserQueries_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_557d9372_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_UserQueries_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 927 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Grid_vue__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__progress_kendo_ui_js_kendo_all_js__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__progress_kendo_ui_js_kendo_all_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__progress_kendo_ui_js_kendo_all_js__);




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'Client',
  props: ['height'],
  components: {
    Grid: __WEBPACK_IMPORTED_MODULE_0__components_Grid_vue__["a" /* default */]
  },
  data: function data() {
    return {
      preload: [],
      schemaModelFields: {},
      url: 'queries/sellin',
      columns: [{
        'title': '',
        width: '120px',
        command: {
          'className': 'btn btn-success',
          text: 'carregar',
          click: this.loadQuery
        }
      }, {
        'title': '',
        width: '120px',
        command: {
          'className': 'btn btn-danger',
          text: 'apagar',
          click: this.deleteQuery
        }
      }, {
        field: 'name',
        title: 'Name'
      }],
      loaded: false,
      tableInitialized: false,
      variables: [],
      rows: [],
      subrows: [],
      filters: [],
      tables: []
    };
  },

  methods: {
    loadQuery: function loadQuery(e) {
      e.preventDefault();
      var grid = this.$refs.userQueriesGrid.$refs.mygrid.kendoWidget();
      var dataItem = grid.dataItem(__WEBPACK_IMPORTED_MODULE_1__progress_kendo_ui_js_kendo_all_js___default.a.jQuery(e.currentTarget).closest('tr'));
      this.$emit('load-query', {
        item: dataItem
      });
    },
    deleteQuery: function deleteQuery(e) {
      e.preventDefault();
      var grid = this.$refs.userQueriesGrid.$refs.mygrid.kendoWidget();
      var dataItem = grid.dataItem(__WEBPACK_IMPORTED_MODULE_1__progress_kendo_ui_js_kendo_all_js___default.a.jQuery(e.currentTarget).closest('tr'));
      this.axios.delete('queries/' + dataItem.id).then(function (response) {
        grid.dataSource.read();
      });
    }
  }
});

/***/ }),
/* 928 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('Grid',{ref:"userQueriesGrid",attrs:{"name":"userQueriesGrid","url":_vm.url,"columns":_vm.columns,"pageable":true,"height":_vm.height,"filterable":true,"sortable":true,"schemaModelFields":_vm.schemaModelFields,"preload":_vm.preload}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 929 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(!_vm.preloadDone)?_c('div',{staticClass:"splash"},[_vm._m(0)]):_vm._e(),_vm._v(" "),(_vm.preloadDone)?_c('div',[_c('b-card',{staticClass:"mt-1"},[_c('div',{staticClass:"text-right queries-toolbar"},[(!_vm.showResults)?_c('a',{attrs:{"href":""},on:{"click":function($event){$event.preventDefault();return _vm.openLoadQueryPopup($event)}}},[_c('i',{staticClass:"fa fa-folder-open"})]):_vm._e(),_vm._v(" "),_c('a',{attrs:{"href":""},on:{"click":function($event){$event.preventDefault();return _vm.openSaveQueryPopup($event)}}},[_c('i',{staticClass:"fa fa-save"})]),_vm._v(" "),_c('a',{attrs:{"href":""},on:{"click":function($event){$event.preventDefault();return _vm.shareQuery($event)}}},[_c('i',{staticClass:"fa fa-share-alt"})])]),_vm._v(" "),(!_vm.showResults)?_c('div',[_c('div',{staticClass:"toolbar"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-2"},[_c('b-form-group',{attrs:{"label":"Tipo de comparação"}},[_c('b-form-radio-group',{attrs:{"id":"radioDates","button-variant":"outline-primary","buttons":"","size":"sm","options":_vm.periodType,"name":"radiosBtnDatesType"},model:{value:(_vm.readOptions.datetype),callback:function ($$v) {_vm.$set(_vm.readOptions, "datetype", $$v)},expression:"readOptions.datetype"}})],1)],1),_vm._v(" "),_c('div',{staticClass:"col-md-1"},[_c('b-form-group',{attrs:{"label":"Ano"}},[_c('b-form-select',{attrs:{"options":_vm.years},model:{value:(_vm.readOptions.year),callback:function ($$v) {_vm.$set(_vm.readOptions, "year", $$v)},expression:"readOptions.year"}})],1)],1),_vm._v(" "),_c('div',{staticClass:"col-md-3"},[_c('b-form-group',{attrs:{"label":"Intervalo"}},[_c('b-form-radio-group',{attrs:{"id":"datesOptions","button-variant":"outline-primary","buttons":"","size":"sm","options":_vm.datesOptions,"name":"radiosBtndatesOptions"},model:{value:(_vm.readOptions.presetdate),callback:function ($$v) {_vm.$set(_vm.readOptions, "presetdate", $$v)},expression:"readOptions.presetdate"}})],1)],1),_vm._v(" "),(_vm.readOptions.presetdate==='custom')?_c('div',{staticClass:"col-md-6"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-4"},[_c('b-form-group',{attrs:{"label":"De"}},[_c('div',{staticClass:"form-inline"},[_c('b-form-select',{attrs:{"options":_vm.days},model:{value:(_vm.readOptions.dates.start.day),callback:function ($$v) {_vm.$set(_vm.readOptions.dates.start, "day", $$v)},expression:"readOptions.dates.start.day"}}),_vm._v(" /\n                      "),_c('b-form-select',{attrs:{"options":_vm.months},model:{value:(_vm.readOptions.dates.start.month),callback:function ($$v) {_vm.$set(_vm.readOptions.dates.start, "month", $$v)},expression:"readOptions.dates.start.month"}})],1)])],1),_vm._v(" "),_c('div',{staticClass:"col-sm-4"},[_c('b-form-group',{attrs:{"label":"a"}},[_c('div',{staticClass:"form-inline"},[_c('b-form-select',{attrs:{"options":_vm.days},model:{value:(_vm.readOptions.dates.end.day),callback:function ($$v) {_vm.$set(_vm.readOptions.dates.end, "day", $$v)},expression:"readOptions.dates.end.day"}}),_vm._v(" /\n                      "),_c('b-form-select',{attrs:{"options":_vm.months},model:{value:(_vm.readOptions.dates.end.month),callback:function ($$v) {_vm.$set(_vm.readOptions.dates.end, "month", $$v)},expression:"readOptions.dates.end.month"}})],1)])],1)])]):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-6"},[_c('b-form-group',{attrs:{"label":"Variável a analisar"}},[_c('b-form-radio-group',{attrs:{"id":"btnradios1","button-variant":"outline-primary","buttons":"","size":"sm","options":_vm.variables,"name":"radiosBtnVars"},model:{value:(_vm.readOptions.columns),callback:function ($$v) {_vm.$set(_vm.readOptions, "columns", $$v)},expression:"readOptions.columns"}})],1)],1)]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-3"},[_c('b-form-group',{attrs:{"label":"Mostrar em linha"}},[_c('b-form-radio-group',{attrs:{"id":"btnradios2","button-variant":"outline-primary","buttons":"","size":"sm","options":_vm.rows,"name":"radiosRows"},model:{value:(_vm.readOptions.rows),callback:function ($$v) {_vm.$set(_vm.readOptions, "rows", $$v)},expression:"readOptions.rows"}})],1)],1),_vm._v(" "),_c('b-col',{attrs:{"md":"9"}},[_c('div',[_c('b-form-group',{attrs:{"label":"Detalhe"}},[_c('b-form-radio-group',{attrs:{"id":"btnradios3","buttons":"","size":"sm","button-variant":"outline-primary","options":_vm.subrows,"name":"radiosSubRows"},model:{value:(_vm.readOptions.subrows),callback:function ($$v) {_vm.$set(_vm.readOptions, "subrows", $$v)},expression:"readOptions.subrows"}})],1)],1),_vm._v(" "),_c('div',[_c('b-form-group',{attrs:{"label":"Agrupar por"}},[_c('b-form-radio-group',{attrs:{"id":"btnradios4","buttons":"","size":"sm","button-variant":"outline-primary","options":_vm.groups,"name":"radiosSubRows"},model:{value:(_vm.readOptions.groupby),callback:function ($$v) {_vm.$set(_vm.readOptions, "groupby", $$v)},expression:"readOptions.groupby"}})],1)],1)])],1),_vm._v(" "),_c('div',[_c('b-button',{staticClass:"btn-block",attrs:{"variant":"primary","disabled":_vm.loadingResults,"size":"lg"},on:{"click":function($event){return _vm.showData()}}},[_c('i',{staticClass:"fa fa-search",class:{'fa-search': !_vm.loadingResults, 'fa-spinner': _vm.loadingResults, 'fa-spin': _vm.loadingResults}}),_vm._v(" Pesquisar")])],1),_vm._v(" "),_c('b-alert',{staticClass:"mt-3",attrs:{"variant":"danger","show":_vm.queryErrorShow,"dismissible":""}},[_c('h4',{staticClass:"alert-heading"},[_vm._v("Erro")]),_vm._v(" "+_vm._s(_vm.queryErrorMessage)+"\n        ")])],1):_vm._e(),_vm._v(" "),(_vm.showResults)?_c('div',[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-9"},[_c('div',[_vm._v("A analisar: "),_c('strong',[_vm._v(_vm._s(_vm.columnsName))]),_vm._v(" por "),_c('strong',[_vm._v(_vm._s(_vm.rowsText))]),_vm._v(" "),(_vm.readOptions.groupby !== 'none')?_c('span',[_vm._v(" agrupado por "),_c('strong',[_vm._v(_vm._s(_vm.groupByName))])]):_vm._e(),_vm._v(" | "),_c('a',{directives:[{name:"scroll-to",rawName:"v-scroll-to",value:('#filters-grid'),expression:"'#filters-grid'"}],attrs:{"href":"#"}},[_c('strong',[_vm._v(_vm._s(_vm.totalFilters))]),_vm._v(" filtros")])]),_vm._v(" "),_c('div',{domProps:{"innerHTML":_vm._s(_vm.datesText)}})]),_vm._v(" "),_c('div',{staticClass:"col-sm-3"},[_c('b-button',{staticClass:"pull-right btn-block",attrs:{"variant":"primary","size":"lg"},on:{"click":function($event){return _vm.showForm()}}},[_vm._v("Alterar")])],1)])]):_vm._e()]),_vm._v(" "),_c('filters',{ref:"filtersPane",attrs:{"id":"filters-grid","filters":_vm.filterOptions,"showFilterGrid":_vm.showFilterGrid,"showResults":_vm.showResults,"totalFilters":_vm.totalFilters,"readOptions":_vm.readOptions}}),_vm._v(" "),_c('fullscreen',{attrs:{"fullscreen":_vm.fullscreenGrid},on:{"update:fullscreen":function($event){_vm.fullscreenGrid=$event}}},[(_vm.showResults)?_c('div',{staticClass:"statistics-results",attrs:{"id":"statistics-results"}},[_c('b-card',{attrs:{"no-body":""}},[_c('b-card-header',{staticClass:"text-right"},[(_vm.$auth.check(['all.export', 'dim.export']))?_c('b-btn',{attrs:{"variant":"outline-primary","disabled":_vm.exporting,"size":"sm"},on:{"click":_vm.exportResults}},[(!_vm.exporting)?_c('i',{staticClass:"fa fa-download"}):_vm._e(),(_vm.exporting)?_c('i',{staticClass:"fa fa-spinner fa-spin"}):_vm._e(),_vm._v(" exportar")]):_vm._e(),_vm._v(" "),_c('b-btn',{attrs:{"variant":"outline-primary","size":"sm"},on:{"click":_vm.toggleFullscreen}},[_c('i',{staticClass:"fa fa-expand"}),_vm._v(" fullscreen")])],1),_vm._v(" "),_c('kendo-tooltip',{attrs:{"content":_vm.getTooltipContents,"width":200,"filter":'.value-cell'}},[(_vm.loaded)?_c('sellin-grid',{ref:"statsGrid",attrs:{"rows":_vm.rows,"groupDefinition":_vm.groupDefinition,"aggregateDefinition":_vm.aggregateDefinition,"query":_vm.readOptions,"name":"statisticsGrid","url":_vm.url,"columns":_vm.columns,"pageable":true,"filterable":true,"sortable":true,"schemaModelFields":_vm.schemaModelFields,"schemaModelId":'id',"preload":_vm.preload,"details":_vm.details},on:{"ds-error":_vm.loadingError}}):_vm._e()],1)],1)],1):_vm._e()])],1):_vm._e(),_vm._v(" "),_c('b-modal',{ref:"downloadModal",attrs:{"id":"downloadModal"}},[_vm._v("\n    O ficheiro está pronto:\n    "),_c('a',{attrs:{"href":_vm.fileDownload.url,"target":"_blank"}},[_vm._v(_vm._s(_vm.fileDownload.title))]),_vm._v(" "),_c('div',{staticClass:"w-100",attrs:{"slot":"modal-footer"},slot:"modal-footer"},[_c('b-btn',{staticClass:"float-right",attrs:{"size":"sm","variant":"primary"},on:{"click":_vm.hideModal}},[_vm._v("\n        Close\n      ")])],1)]),_vm._v(" "),_c('b-modal',{ref:"downloadModal",attrs:{"id":"downloadModal"}},[_vm._v("\n    O ficheiro está pronto:\n    "),_c('a',{attrs:{"href":_vm.fileDownload.url,"target":"_blank"}},[_vm._v(_vm._s(_vm.fileDownload.title))]),_vm._v(" "),_c('div',{staticClass:"w-100",attrs:{"slot":"modal-footer"},slot:"modal-footer"},[_c('b-btn',{staticClass:"float-right",attrs:{"size":"sm","variant":"primary"},on:{"click":_vm.hideModal}},[_vm._v("\n        Close\n      ")])],1)]),_vm._v(" "),_c('b-modal',{ref:"saveModal",attrs:{"id":"saveModal","title":"Gravar pesquisa"}},[_c('b-form',{on:{"submit":_vm.saveQuery}},[_c('b-form-input',{ref:"queryName",attrs:{"type":"text"},model:{value:(_vm.queryName),callback:function ($$v) {_vm.queryName=$$v},expression:"queryName"}})],1),_vm._v(" "),_c('div',{staticClass:"w-100",attrs:{"slot":"modal-footer"},slot:"modal-footer"},[_c('b-btn',{staticClass:"float-left",attrs:{"size":"sm","variant":"secondary"},on:{"click":_vm.hideSaveModal}},[_vm._v("\n        Close\n      ")]),_vm._v(" "),_c('b-btn',{staticClass:"float-right",attrs:{"size":"sm","variant":"success"},on:{"click":_vm.saveQuery}},[_c('i',{staticClass:"fa fa-save-o"}),_vm._v(" Gravar\n      ")])],1)],1),_vm._v(" "),_c('b-modal',{ref:"shareModal",attrs:{"id":"shareModal"}},[_c('b-form',[_c('b-form-input',{ref:"queryName",attrs:{"readonly":"","type":"text"},model:{value:(_vm.queryUrl),callback:function ($$v) {_vm.queryUrl=$$v},expression:"queryUrl"}})],1),_vm._v(" "),_c('div',{staticClass:"w-100",attrs:{"slot":"modal-footer"},slot:"modal-footer"},[_c('b-btn',{staticClass:"float-left",attrs:{"size":"sm","variant":"secondary"},on:{"click":_vm.hideShareModal}},[_vm._v("\n        Close\n      ")])],1)],1),_vm._v(" "),_c('b-modal',{ref:"loadQueryModal",attrs:{"size":"lg","id":"loadQueryModal"},on:{"shown":function($event){_vm.showQueries=true},"hidden":function($event){_vm.showQueries=false}}},[(_vm.showQueries)?_c('UserQueries',{attrs:{"height":"400"},on:{"load-query":_vm.loadUserQuery}}):_vm._e()],1)],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container  d-flex h-100"},[_c('div',{staticClass:"row justify-content-center text-primary w-100 align-self-center text-white"},[_c('i',{staticClass:"fa fa-spin fa-spinner"})])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 930 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_oportunity_vue__ = __webpack_require__(931);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_77492e52_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_oportunity_vue__ = __webpack_require__(932);
var normalizeComponent = __webpack_require__(4)
/* script */

/* template */

/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_oportunity_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_77492e52_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_oportunity_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 931 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'Profile',
  data: function data() {
    return {
      preloadDone: false,
      showPrizes: false,
      results: {},
      resultFields: [{ key: 'name', label: 'Nome', sortable: true }, { key: 'codle', label: 'Codle', sortable: true }, { key: 'value_ufs', label: 'Valor UFS', sortable: true, width: '120px' }, { key: 'ok', label: 'Cumpre', sortable: true, width: '120px' }]
    };
  },

  methods: {},
  created: function created() {
    var that = this;
    var user = this.$auth.user();
    console.log(user);
    this.axios.get('stars/oportunities/7').then(function (response) {
      that.results = response.data.data;
      that.preloadDone = true;
    });
  }
});

/***/ }),
/* 932 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"animated fadeIn"},[(!_vm.preloadDone)?_c('div',{staticClass:"splash"},[_vm._m(0)]):_vm._e(),_vm._v(" "),(_vm.preloadDone)?_c('div',{staticClass:"container mt-3"},[_c('div',{staticClass:"oportunity",attrs:{"role":"tablist"}},[_vm._l((_vm.results.results),function(result){return _c('b-card',{key:result.code,staticClass:"mb-1",attrs:{"no-body":""}},[_c('b-card-header',{staticClass:"p-3",attrs:{"header-tag":"header","role":"tab"}},[_c('b-row',[_c('b-col',{attrs:{"md":"6"}},[_c('b-btn',{directives:[{name:"b-toggle",rawName:"v-b-toggle",value:('accordion-' + result.code),expression:"'accordion-' + result.code"}],attrs:{"variant":"link"}},[_vm._v(_vm._s(result.name))])],1),_vm._v(" "),_c('b-col',{attrs:{"md":"3"}},[_vm._v("Valor UFS: "),_c('span',{staticClass:"value"},[_vm._v(_vm._s(_vm._f("currency")(result.value_ufs,{fractionCount:2, symbol:'€'})))])]),_vm._v(" "),_c('b-col',{attrs:{"md":"3"}},[_vm._v("Cumprem: "),_c('span',{staticClass:"value"},[_vm._v(_vm._s(_vm._f("currency")(result.ok,{fractionCount:0, symbol:''})))])])],1)],1),_vm._v(" "),_c('b-collapse',{attrs:{"id":'accordion-' + result.code,"accordion":"my-accordion","role":"tabpanel"}},[_c('b-card-body',[_c('b-table',{attrs:{"responsive":"","stacked":"sm","striped":true,"fields":_vm.resultFields,"items":result.results,"sort-by":_vm.value_ufs,"sort-desc":true},scopedSlots:_vm._u([{key:"cell(name)",fn:function(data){return [_vm._v("\n                "+_vm._s(data.item.name)+"\n              ")]}},{key:"cell(codle)",fn:function(data){return [_vm._v("\n                "+_vm._s(data.item.codle)+"\n              ")]}},{key:"cell(value_ufs)",fn:function(data){return [_vm._v("\n                "+_vm._s(_vm._f("currency")(data.item.value_ufs,{fractionCount:2, symbol:'€'}))+"\n              ")]}},{key:"cell(ok)",fn:function(data){return [_vm._v("\n                "+_vm._s(data.item.ok == '1'?'Sim':'Não')+"\n              ")]}}])})],1)],1)],1)}),_vm._v(" "),_vm._l((_vm.results.cha_results),function(result){return _c('b-card',{key:result.code,staticClass:"mb-1",attrs:{"no-body":""}},[_c('b-card-header',{staticClass:"p-3",attrs:{"header-tag":"header","header-bg-variant":"info"}},[_c('b-row',[_c('b-col',{attrs:{"md":"6"}},[_c('span',{staticClass:"name"},[_vm._v(_vm._s(result.name))])]),_vm._v(" "),_c('b-col',{attrs:{"md":"3"}},[_vm._v("Valor UFS: "),_c('span',{staticClass:"value"},[_vm._v(_vm._s(_vm._f("currency")(result.value_ufs,{fractionCount:2, symbol:'€'})))])]),_vm._v(" "),_c('b-col',{attrs:{"md":"3"}},[_vm._v("Cumprem: "),_c('span',{staticClass:"value"},[_vm._v(_vm._s(_vm._f("currency")(result.ok,{fractionCount:0, symbol:''})))])])],1)],1)],1)}),_vm._v(" "),_c('b-card',{staticClass:"mb-1",attrs:{"no-body":""}},[_c('b-card-header',{staticClass:"p-3",attrs:{"header-tag":"header","header-bg-variant":"info"}},[_c('b-row',[_c('b-col',{attrs:{"md":"6"}},[_c('span',{staticClass:"name"},[_vm._v(_vm._s(_vm.results.national.name))])]),_vm._v(" "),_c('b-col',{attrs:{"md":"3"}},[_vm._v("Valor UFS: "),_c('span',{staticClass:"value"},[_vm._v(_vm._s(_vm._f("currency")(_vm.results.national.value_ufs,{fractionCount:2, symbol:'€'})))])]),_vm._v(" "),_c('b-col',{attrs:{"md":"3"}},[_vm._v("Cumprem: "),_c('span',{staticClass:"value"},[_vm._v(_vm._s(_vm._f("currency")(_vm.results.national.ok,{fractionCount:0, symbol:''})))])])],1)],1)],1)],2)]):_vm._e()])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container  d-flex h-100"},[_c('div',{staticClass:"row justify-content-center text-primary w-100 align-self-center text-white"},[_c('i',{staticClass:"fa fa-spin fa-spinner"})])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 933 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_oportunity_self_vue__ = __webpack_require__(934);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ca7c4f9c_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_oportunity_self_vue__ = __webpack_require__(935);
var normalizeComponent = __webpack_require__(4)
/* script */

/* template */

/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_oportunity_self_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ca7c4f9c_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_oportunity_self_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 934 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'Profile',
  data: function data() {
    return {
      preloadDone: false,
      result: null,
      resultFields: [{ key: 'name', label: 'Nome', sortable: true }, { key: 'codle', label: 'Codle', sortable: true }, { key: 'value_ufs', label: 'Valor UFS', sortable: true, width: '120px' }, { key: 'ok', label: 'Cumpre', sortable: true, width: '120px' }]
    };
  },
  created: function created() {
    this.fetchData();
  },

  methods: {
    fetchData: function fetchData() {
      var _this = this;

      this.axios.get('stars/oportunities/self/7').then(function (response) {

        _this.result = response.data && response.data.data ? response.data.data : {};


        _this.preloadDone = true;
      }).catch(function (error) {

        if (error.response) {} else if (error.request) {}

        _this.preloadDone = true;
      });
    }
  }
});

/***/ }),
/* 935 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"animated fadeIn"},[(!_vm.preloadDone)?_c('div',{staticClass:"splash"},[_vm._m(0)]):_vm._e(),_vm._v(" "),(_vm.preloadDone && _vm.result)?_c('div',{staticClass:"container mt-3"},[_c('div',{staticClass:"oportunity",attrs:{"role":"tablist"}},[_c('b-card',[_c('b-card-header',{staticClass:"p-3",attrs:{"header-tag":"header","header-bg-variant":"info"}},[_c('b-row',[(_vm.result.count_first_criteria !== undefined)?_c('b-col',{staticClass:"text-center summary-wrapper",attrs:{"md":"3"}},[_c('div',{staticClass:"summary-header"},[_vm._v("Operadores "),_c('br'),_vm._v(">= 325€")]),_vm._v(" "),_c('div',{staticClass:"summary-value"},[_c('div',{staticClass:"value"},[_vm._v(_vm._s(_vm._f("currency")(_vm.result.count_first_criteria,{fractionCount:0, symbol:''})))]),_vm._v(" "),_c('div',{staticClass:"percentage"},[_vm._v("\n                  "+_vm._s(_vm._f("currency")((_vm.result.count_first_criteria * 100 / 40),{fractionCount:1, symbol:'%'}))+"\n                  (Obj: 40)\n                ")])])]):_vm._e(),_vm._v(" "),(_vm.result.count_second_criteria !== undefined)?_c('b-col',{staticClass:"text-center summary-wrapper",attrs:{"md":"3"}},[_c('div',{staticClass:"summary-header"},[_vm._v("Operadores "),_c('br'),_vm._v(">= 390€")]),_vm._v(" "),_c('div',{staticClass:"summary-value"},[_c('div',{staticClass:"value"},[_vm._v(_vm._s(_vm._f("currency")(_vm.result.count_second_criteria,{fractionCount:0, symbol:''})))]),_vm._v(" "),_c('div',{staticClass:"percentage"},[_vm._v("\n                  "+_vm._s(_vm._f("currency")((_vm.result.count_second_criteria * 100 / 30),{fractionCount:1, symbol:'%'}))+"\n                  (Obj: 30)\n                ")])])]):_vm._e(),_vm._v(" "),(_vm.result.count_third_criteria !== undefined)?_c('b-col',{staticClass:"text-center summary-wrapper",attrs:{"md":"3"}},[_c('div',{staticClass:"summary-header"},[_vm._v("Operadores "),_c('br'),_vm._v(">= 500€")]),_vm._v(" "),_c('div',{staticClass:"summary-value"},[_c('div',{staticClass:"value"},[_vm._v(_vm._s(_vm._f("currency")(_vm.result.count_third_criteria,{fractionCount:0, symbol:''})))]),_vm._v(" "),_c('div',{staticClass:"percentage"},[_vm._v("\n                  "+_vm._s(_vm._f("currency")((_vm.result.count_third_criteria * 100 / 20),{fractionCount:1, symbol:'%'}))+"\n                  (Obj: 20)\n                ")])])]):_vm._e(),_vm._v(" "),(_vm.result.top15_sum_value !== undefined)?_c('b-col',{staticClass:"text-center summary-wrapper",attrs:{"md":"3"}},[_c('div',{staticClass:"summary-header"},[_vm._v("Soma Top 15 "),_c('br'),_vm._v("Operadores")]),_vm._v(" "),_c('div',{staticClass:"summary-value"},[_c('div',{staticClass:"value"},[_vm._v(_vm._s(_vm._f("currency")(_vm.result.top15_sum_value,{fractionCount:2, symbol:'€'})))]),_vm._v(" "),_c('div',{staticClass:"percentage"},[_vm._v("\n                  "+_vm._s(_vm._f("currency")((_vm.result.top15_sum_value * 100 / 22750),{fractionCount:1, symbol:'%'}))+"\n                  (Obj: 22.750 €)\n                ")])])]):_vm._e()],1)],1),_vm._v(" "),(_vm.result.results)?_c('b-table',{attrs:{"responsive":"","stacked":"sm","striped":true,"fields":_vm.resultFields,"items":_vm.result.results,"sort-by":'value_ufs',"sort-desc":true},scopedSlots:_vm._u([{key:"cell(name)",fn:function(data){return [_vm._v("\n            "+_vm._s(data.item.name)+"\n          ")]}},{key:"cell(codle)",fn:function(data){return [_vm._v("\n            "+_vm._s(data.item.codle)+"\n          ")]}},{key:"cell(value_ufs)",fn:function(data){return [_vm._v("\n            "+_vm._s(_vm._f("currency")(data.item.value_ufs,{fractionCount:2, symbol:'€'}))+"\n          ")]}}])}):_vm._e()],1)],1)]):_vm._e()])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container d-flex h-100"},[_c('div',{staticClass:"row justify-content-center text-primary w-100 align-self-center text-white"},[_c('i',{staticClass:"fa fa-spin fa-spinner"})])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 936 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_nifsexcluidos_vue__ = __webpack_require__(937);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1d4ff69d_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_nifsexcluidos_vue__ = __webpack_require__(938);
var normalizeComponent = __webpack_require__(4)
/* script */

/* template */

/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_nifsexcluidos_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1d4ff69d_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_nifsexcluidos_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 937 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Grid_vue__ = __webpack_require__(15);




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'NifsExcluidosGrid',
  components: {
    Grid: __WEBPACK_IMPORTED_MODULE_0__components_Grid_vue__["a" /* default */]
  },
  data: function data() {
    return {
      schemaModelFields: {
        'created_at': {
          type: 'date'
        }
      },
      pagesize: 30,
      url: 'stars/nifsexcluded',
      columns: [{
        field: 'category',
        title: 'Categoria',
        values: [{
          value: 'campanhas pontos',
          text: 'campanhas pontos'
        }, {
          value: 'statistics',
          text: 'statistics'
        }, {
          value: 'scorecard',
          text: 'scorecard'
        }, {
          value: 'incentivos internos',
          text: 'incentivos internos'
        }]
      }, {
        field: 'operator_name',
        title: 'Operador',
        width: '220px'
      }, {
        field: 'dealer_name',
        title: 'Distribuidor',
        width: '120px'
      }, {
        field: 'nif',
        title: 'NIF'
      }, {
        field: 'codle',
        title: 'CODLE',
        width: '160px'
      }, {
        field: 'date_start',
        title: 'Excluído desde'
      }, {
        field: 'date_end',
        title: 'Excluído até'
      }]
    };
  }
});

/***/ }),
/* 938 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"animated fadeIn"},[_c('div',{staticClass:"container mt-3"},[_c('div',{staticClass:"table-caption"},[_vm._v("NIF's Excluídos")]),_vm._v(" "),[_c('div',[_c('b-card',[_c('Grid',{attrs:{"name":"NifsExcluidosGrid","url":_vm.url,"columns":_vm.columns,"pageable":true,"pagesize":_vm.pagesize,"filterable":true,"sortable":true,"schemaModelFields":_vm.schemaModelFields}})],1)],1)]],2)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 939 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_operatorsGrid_vue__ = __webpack_require__(940);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0c050bc1_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_operatorsGrid_vue__ = __webpack_require__(941);
var normalizeComponent = __webpack_require__(4)
/* script */

/* template */

/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_operatorsGrid_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0c050bc1_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_operatorsGrid_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 940 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Grid_vue__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__router__ = __webpack_require__(94);





/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'OperatorsGrid',
  components: {
    Grid: __WEBPACK_IMPORTED_MODULE_0__components_Grid_vue__["a" /* default */]
  },
  data: function data() {
    return {
      schemaModelFields: {
        'created_at': {
          type: 'date'
        }
      },
      pagesize: 30,
      url: 'stars/operators',
      columns: [{
        template: this.getBtnTemplate,
        title: '',
        width: '100px'
      }, {
        field: 'id',
        title: 'Id',
        width: '50px'
      }, {
        field: 'name',
        title: 'Nome',
        width: '260px'
      }, {
        field: 'nif',
        title: 'NIF',
        width: '130px'
      }, {
        field: 'codle',
        title: 'codle',
        width: '130px'
      }, {
        field: 'zip_code',
        title: 'Código Postal'
      }, {
        field: 'operator_group_id',
        title: 'Operador',
        width: '50px'
      }, {
        field: 'operatorgroup.data.name',
        title: 'Descrição Operator',
        width: '180px'
      }]
    };
  },

  methods: {
    getBtnTemplate: function getBtnTemplate(item) {
      var route = __WEBPACK_IMPORTED_MODULE_1__router__["a" /* default */].resolve({
        name: 'operators.OperatorsEdit',
        params: {
          id: item.id
        }
      });
      if (this.$auth.check('operators.OperatorsEdit')) {
        return '<a href="' + route.href + '" class="btn btn-primary" ><i class="fa fa-pencil"></i> editar</a>';
      }
      return '';
    }
  }
});

/***/ }),
/* 941 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"animated fadeIn"},[_c('div',{staticClass:"container mt-3"},[_c('div',{staticClass:"table-caption"},[_vm._v("Operadores")]),_vm._v(" "),[_c('div',[_c('b-card',[_c('Grid',{attrs:{"name":"OperatorsGrid","url":_vm.url,"columns":_vm.columns,"pageable":true,"pagesize":_vm.pagesize,"filterable":true,"sortable":true,"schemaModelFields":_vm.schemaModelFields}})],1)],1)]],2)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 942 */,
/* 943 */,
/* 944 */,
/* 945 */,
/* 946 */,
/* 947 */,
/* 948 */,
/* 949 */,
/* 950 */,
/* 951 */,
/* 952 */,
/* 953 */,
/* 954 */,
/* 955 */,
/* 956 */,
/* 957 */,
/* 958 */,
/* 959 */,
/* 960 */,
/* 961 */,
/* 962 */,
/* 963 */,
/* 964 */,
/* 965 */,
/* 966 */,
/* 967 */,
/* 968 */,
/* 969 */
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./af": 420,
	"./af.js": 420,
	"./ar": 421,
	"./ar-dz": 422,
	"./ar-dz.js": 422,
	"./ar-kw": 423,
	"./ar-kw.js": 423,
	"./ar-ly": 424,
	"./ar-ly.js": 424,
	"./ar-ma": 425,
	"./ar-ma.js": 425,
	"./ar-sa": 426,
	"./ar-sa.js": 426,
	"./ar-tn": 427,
	"./ar-tn.js": 427,
	"./ar.js": 421,
	"./az": 428,
	"./az.js": 428,
	"./be": 429,
	"./be.js": 429,
	"./bg": 430,
	"./bg.js": 430,
	"./bm": 431,
	"./bm.js": 431,
	"./bn": 432,
	"./bn.js": 432,
	"./bo": 433,
	"./bo.js": 433,
	"./br": 434,
	"./br.js": 434,
	"./bs": 435,
	"./bs.js": 435,
	"./ca": 436,
	"./ca.js": 436,
	"./cs": 437,
	"./cs.js": 437,
	"./cv": 438,
	"./cv.js": 438,
	"./cy": 439,
	"./cy.js": 439,
	"./da": 440,
	"./da.js": 440,
	"./de": 441,
	"./de-at": 442,
	"./de-at.js": 442,
	"./de-ch": 443,
	"./de-ch.js": 443,
	"./de.js": 441,
	"./dv": 444,
	"./dv.js": 444,
	"./el": 445,
	"./el.js": 445,
	"./en-SG": 446,
	"./en-SG.js": 446,
	"./en-au": 447,
	"./en-au.js": 447,
	"./en-ca": 448,
	"./en-ca.js": 448,
	"./en-gb": 449,
	"./en-gb.js": 449,
	"./en-ie": 450,
	"./en-ie.js": 450,
	"./en-il": 451,
	"./en-il.js": 451,
	"./en-nz": 452,
	"./en-nz.js": 452,
	"./eo": 453,
	"./eo.js": 453,
	"./es": 454,
	"./es-do": 455,
	"./es-do.js": 455,
	"./es-us": 456,
	"./es-us.js": 456,
	"./es.js": 454,
	"./et": 457,
	"./et.js": 457,
	"./eu": 458,
	"./eu.js": 458,
	"./fa": 459,
	"./fa.js": 459,
	"./fi": 460,
	"./fi.js": 460,
	"./fo": 461,
	"./fo.js": 461,
	"./fr": 462,
	"./fr-ca": 463,
	"./fr-ca.js": 463,
	"./fr-ch": 464,
	"./fr-ch.js": 464,
	"./fr.js": 462,
	"./fy": 465,
	"./fy.js": 465,
	"./ga": 466,
	"./ga.js": 466,
	"./gd": 467,
	"./gd.js": 467,
	"./gl": 468,
	"./gl.js": 468,
	"./gom-latn": 469,
	"./gom-latn.js": 469,
	"./gu": 470,
	"./gu.js": 470,
	"./he": 471,
	"./he.js": 471,
	"./hi": 472,
	"./hi.js": 472,
	"./hr": 473,
	"./hr.js": 473,
	"./hu": 474,
	"./hu.js": 474,
	"./hy-am": 475,
	"./hy-am.js": 475,
	"./id": 476,
	"./id.js": 476,
	"./is": 477,
	"./is.js": 477,
	"./it": 478,
	"./it-ch": 479,
	"./it-ch.js": 479,
	"./it.js": 478,
	"./ja": 480,
	"./ja.js": 480,
	"./jv": 481,
	"./jv.js": 481,
	"./ka": 482,
	"./ka.js": 482,
	"./kk": 483,
	"./kk.js": 483,
	"./km": 484,
	"./km.js": 484,
	"./kn": 485,
	"./kn.js": 485,
	"./ko": 486,
	"./ko.js": 486,
	"./ku": 487,
	"./ku.js": 487,
	"./ky": 488,
	"./ky.js": 488,
	"./lb": 489,
	"./lb.js": 489,
	"./lo": 490,
	"./lo.js": 490,
	"./lt": 491,
	"./lt.js": 491,
	"./lv": 492,
	"./lv.js": 492,
	"./me": 493,
	"./me.js": 493,
	"./mi": 494,
	"./mi.js": 494,
	"./mk": 495,
	"./mk.js": 495,
	"./ml": 496,
	"./ml.js": 496,
	"./mn": 497,
	"./mn.js": 497,
	"./mr": 498,
	"./mr.js": 498,
	"./ms": 499,
	"./ms-my": 500,
	"./ms-my.js": 500,
	"./ms.js": 499,
	"./mt": 501,
	"./mt.js": 501,
	"./my": 502,
	"./my.js": 502,
	"./nb": 503,
	"./nb.js": 503,
	"./ne": 504,
	"./ne.js": 504,
	"./nl": 505,
	"./nl-be": 506,
	"./nl-be.js": 506,
	"./nl.js": 505,
	"./nn": 507,
	"./nn.js": 507,
	"./pa-in": 508,
	"./pa-in.js": 508,
	"./pl": 509,
	"./pl.js": 509,
	"./pt": 510,
	"./pt-br": 511,
	"./pt-br.js": 511,
	"./pt.js": 510,
	"./ro": 512,
	"./ro.js": 512,
	"./ru": 513,
	"./ru.js": 513,
	"./sd": 514,
	"./sd.js": 514,
	"./se": 515,
	"./se.js": 515,
	"./si": 516,
	"./si.js": 516,
	"./sk": 517,
	"./sk.js": 517,
	"./sl": 518,
	"./sl.js": 518,
	"./sq": 519,
	"./sq.js": 519,
	"./sr": 520,
	"./sr-cyrl": 521,
	"./sr-cyrl.js": 521,
	"./sr.js": 520,
	"./ss": 522,
	"./ss.js": 522,
	"./sv": 523,
	"./sv.js": 523,
	"./sw": 524,
	"./sw.js": 524,
	"./ta": 525,
	"./ta.js": 525,
	"./te": 526,
	"./te.js": 526,
	"./tet": 527,
	"./tet.js": 527,
	"./tg": 528,
	"./tg.js": 528,
	"./th": 529,
	"./th.js": 529,
	"./tl-ph": 530,
	"./tl-ph.js": 530,
	"./tlh": 531,
	"./tlh.js": 531,
	"./tr": 532,
	"./tr.js": 532,
	"./tzl": 533,
	"./tzl.js": 533,
	"./tzm": 534,
	"./tzm-latn": 535,
	"./tzm-latn.js": 535,
	"./tzm.js": 534,
	"./ug-cn": 536,
	"./ug-cn.js": 536,
	"./uk": 537,
	"./uk.js": 537,
	"./ur": 538,
	"./ur.js": 538,
	"./uz": 539,
	"./uz-latn": 540,
	"./uz-latn.js": 540,
	"./uz.js": 539,
	"./vi": 541,
	"./vi.js": 541,
	"./x-pseudo": 542,
	"./x-pseudo.js": 542,
	"./yo": 543,
	"./yo.js": 543,
	"./zh-cn": 544,
	"./zh-cn.js": 544,
	"./zh-hk": 545,
	"./zh-hk.js": 545,
	"./zh-tw": 546,
	"./zh-tw.js": 546
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 969;

/***/ }),
/* 970 */,
/* 971 */,
/* 972 */,
/* 973 */,
/* 974 */,
/* 975 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_StatisticsGrid_vue__ = __webpack_require__(976);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_42d9aea2_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_StatisticsGrid_vue__ = __webpack_require__(981);
var normalizeComponent = __webpack_require__(4)
/* script */

/* template */

/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_StatisticsGrid_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_42d9aea2_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_StatisticsGrid_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 976 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__progress_kendo_grid_vue_wrapper__ = __webpack_require__(74);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__progress_kendo_grid_vue_wrapper___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__progress_kendo_grid_vue_wrapper__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__progress_kendo_datasource_vue_wrapper__ = __webpack_require__(75);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__progress_kendo_datasource_vue_wrapper___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__progress_kendo_datasource_vue_wrapper__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__views_Statistics_Detail_vue__ = __webpack_require__(977);









__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_2__progress_kendo_datasource_vue_wrapper__["KendoDataSourceInstaller"]);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1__progress_kendo_grid_vue_wrapper__["KendoGridInstaller"]);

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'StatisticsGrid',
  props: ['name', 'gridHeight', 'schemaModelFields', 'schemaModelId', 'url', 'columns', 'preload', 'sortable', 'pageable', 'filterable', 'query', 'details', 'aggregateDefinition', 'rows', 'groupDefinition'],
  components: {
    KendoGrid: __WEBPACK_IMPORTED_MODULE_1__progress_kendo_grid_vue_wrapper__["KendoGrid"],
    KendoDataSource: __WEBPACK_IMPORTED_MODULE_2__progress_kendo_datasource_vue_wrapper__["KendoDataSource"],
    Detail: __WEBPACK_IMPORTED_MODULE_3__views_Statistics_Detail_vue__["a" /* default */]
  },
  data: function data() {
    return {
      preloadDone: false,
      gridTransport: this.getTransport(),
      schemaTotal: this.getTotal,
      options: {
        dataSource: {
          page: 1,
          sort: null,
          filter: null
        }
      }
    };
  },

  methods: {
    dataSourceLoaded: function dataSourceLoaded(e) {
      this.$emit('ds-loaded', e);
    },
    dataSourceLoadError: function dataSourceLoadError(e) {
      this.$emit('ds-error', e);
    },
    queryFromDetail: function queryFromDetail() {
      console.log('hey, aquery from a detail!');
    },

    detailInit: function detailInit(e) {
      var that = this;
      var ComponentClass = __WEBPACK_IMPORTED_MODULE_0_vue__["default"].extend(__WEBPACK_IMPORTED_MODULE_3__views_Statistics_Detail_vue__["a" /* default */]);
      var instance = new ComponentClass({
        propsData: {
          query: this.query,
          rowData: e.data,
          details: this.details,
          masterRows: this.rows
        }
      });
      instance.$mount();
      instance.$on('filter-detail', function (evt) {
        that.$emit('filter-detail', evt);
      });
      e.detailCell.append(instance.$el);
    },
    setQuery: function setQuery() {
      var _this = this;

      this.axios.post('queries', this.query).then(function (response) {
        _this.$router.push({
          name: 'statistics.query',
          params: {
            id: response.data.data.uuid
          }
        });
      });
    },
    getTransport: function getTransport() {
      var v = this;
      return {
        read: {
          url: v.axios.defaults.baseURL + this.url,
          type: 'POST',
          data: this.query,
          beforeSend: function beforeSend(req) {
            console.log(req);
            req.setRequestHeader('Authorization', 'Bearer ' + v.$auth.token());
          }
        }
      };
    },
    refresh: function refresh() {
      this.$refs.mygrid.kendoWidget().dataSource.read();
    },
    getTotal: function getTotal(response) {
      return response.meta.pagination.total;
    },
    setColumnsData: function setColumnsData(data, field) {
      for (var i = 0; i < this.columns.length; i++) {
        if (this.columns[i].field === field) {
          this.columns[i].values = data;
        }
      }
    }
  },
  created: function created() {
    var _this2 = this;

    var that = this;
    var apiPreloads = [];
    if (typeof this.preload !== 'undefined' && this.preload != null && this.preload.length > 0) {
      for (var i = 0; i < this.preload.length; i++) {
        apiPreloads.push(this.preload[i].api);
      }
      this.axios.all(apiPreloads.map(function (l) {
        return _this2.axios.get(l);
      })).then(that.axios.spread(function () {
        for (var i = 0; i < that.preload.length; i++) {
          that.setColumnsData(arguments[i].data.data, that.preload[i].field);
        }
        that.preloadDone = true;
      })).catch(function (response) {
        console.error('error loading foreigns', response);
      });
    } else {
      that.preloadDone = true;
    }
  }
});

/***/ }),
/* 977 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Detail_vue__ = __webpack_require__(978);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_46702f09_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_Detail_vue__ = __webpack_require__(980);
var normalizeComponent = __webpack_require__(4)
/* script */

/* template */

/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Detail_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_46702f09_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_Detail_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 978 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(198);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__progress_kendo_ui_js_kendo_all_js__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__progress_kendo_ui_js_kendo_all_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__progress_kendo_ui_js_kendo_all_js__);




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'Detail',
  props: ['query', 'rowData', 'details', 'masterRows'],
  data: function data() {
    return {
      preload: [],
      schemaModelFields: {},
      url: 'statistics',
      columns: [],
      aggregateDefinition: [],
      loaded: false,
      tableInitialized: false,
      tables: []
    };
  },

  methods: {
    changedTab: function changedTab(a) {
      var _this = this;

      this.axios.post('statistics/columns', this.tables[a].query).then(function (response) {
        var data = response.data.data;
        _this.tables[a].columns = data.columns;
        _this.tables[a].aggregateDefinition = data.aggregates;
        _this.tables[a].schemaModelFields = data.fields;
        _this.tables[a].visible = true;
      });
    },
    seQueryFromRow: function seQueryFromRow(e) {
      e.preventDefault();
      var t = e.currentTarget;
      var q = __WEBPACK_IMPORTED_MODULE_1__progress_kendo_ui_js_kendo_all_js___default.a.jQuery(t).data('query');
      var gridref = __WEBPACK_IMPORTED_MODULE_1__progress_kendo_ui_js_kendo_all_js___default.a.jQuery(t).data('gridref');
      var field = __WEBPACK_IMPORTED_MODULE_1__progress_kendo_ui_js_kendo_all_js___default.a.jQuery(t).data('field');
      var grid = this.$refs[gridref][0].$refs.mygrid.kendoWidget();
      var row = __WEBPACK_IMPORTED_MODULE_1__progress_kendo_ui_js_kendo_all_js___default.a.jQuery(t).closest('tr');
      var dataItem = grid.dataItem(row);
      q.filters = this.addFilter(q.filters, field, dataItem[field]);
      console.log(q);
      this.$emit('filter-detail', {
        item: q
      });
    },
    addFilter: function addFilter(filters, field, value) {
      var found = false;
      for (var c = 0; c < filters.length; c++) {
        if (filters[c].field === field) {
          filters[c].includes = [{
            id: value,
            name: 'auto'
          }];
          found = true;
        }
      }
      if (!found) {
        filters.push({
          field: field,
          title: '',
          includes: [{
            id: value,
            name: 'auto'
          }],
          excludes: []
        });
      }
      return filters;
    }
  },
  created: function created() {
    var that = this;

    for (var i = 0; i < this.details.length; i++) {
      var d = this.details[i];
      for (var w = 0; w < d.subrows.length; w++) {
        var subs = d.subrows;

        var q = JSON.parse(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.query));
        var groupby = q.groupby;
        q.groupby = 'none';

        var id = this.rowData[this.query.subrows];

        q.filters = this.addFilter(q.filters, this.query.subrows, id);
        if (groupby !== 'none') {
          var groupById = this.rowData[groupby];
          q.filters = this.addFilter(q.filters, groupby, groupById);
        }

        q.rows = d.rows;
        q.subrows = subs[w];
        this.tables.push({
          visible: false,
          title: this.masterRows[q.rows].sub[q.subrows].text,
          details: this.masterRows[q.rows].sub[q.subrows].details,
          field: q.subrows,
          query: q
        });
      }
    }
    console.log('details', this.details);
    console.log('tables', this.tables);
    that.loaded = true;
  }
});

/***/ }),
/* 979 */,
/* 980 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"details"},[(_vm.loaded)?_c('b-card',{attrs:{"no-body":""}},[_c('b-tabs',{attrs:{"small":"","card":""},on:{"input":_vm.changedTab}},_vm._l((_vm.tables),function(detail){return _c('b-tab',{key:detail.field,attrs:{"title":detail.title}},[(detail.visible)?_c('statistics-grid',{ref:'statsGrid' + detail.query.subrows,refInFor:true,attrs:{"gridHeight":"400px","query":detail.query,"name":'detailGrid' + detail,"url":_vm.url,"columns":detail.columns,"pageable":true,"filterable":true,"sortable":true,"schemaModelFields":detail.schemaModelFields,"schemaModelId":'id',"aggregateDefinition":detail.aggregateDefinition,"rows":_vm.masterRows,"details":detail.details,"preload":_vm.preload}}):_vm._e(),_vm._v(" "),(!detail.visible)?_c('div',{staticClass:"splash"},[_c('div',{staticClass:"container  d-flex h-100"},[_c('div',{staticClass:"row justify-content-center text-primary w-100 align-self-center text-white"},[_c('i',{staticClass:"fa fa-spin fa-spinner"})])])]):_vm._e()],1)}),1)],1):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 981 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.preloadDone)?_c('div',[_c('kendo-datasource',{ref:"datasource1",attrs:{"transport":_vm.gridTransport,"schema-model-id":_vm.schemaModelId,"schema-model-fields":_vm.schemaModelFields,"schema-data":'data',"server-paging":false,"server-filtering":false,"server-sorting":false,"aggregate":_vm.aggregateDefinition,"group":_vm.groupDefinition,"page":_vm.options.dataSource.page},on:{"requestend":_vm.dataSourceLoaded,"error":_vm.dataSourceLoadError}}),_vm._v(" "),_c('kendo-grid',{ref:"mygrid",attrs:{"scrollable-virtual":true,"data-source-ref":'datasource1',"filterable":_vm.filterable,"sortable":_vm.sortable,"columns":_vm.columns,"scrollable":true},on:{"detailinit":_vm.detailInit,"filter-detail":_vm.queryFromDetail}})],1):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 982 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SellinGrid_vue__ = __webpack_require__(983);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0088aafa_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_SellinGrid_vue__ = __webpack_require__(987);
var normalizeComponent = __webpack_require__(4)
/* script */

/* template */

/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SellinGrid_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0088aafa_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_SellinGrid_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 983 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__progress_kendo_grid_vue_wrapper__ = __webpack_require__(74);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__progress_kendo_grid_vue_wrapper___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__progress_kendo_grid_vue_wrapper__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__progress_kendo_datasource_vue_wrapper__ = __webpack_require__(75);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__progress_kendo_datasource_vue_wrapper___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__progress_kendo_datasource_vue_wrapper__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__views_Sellin_Detail_vue__ = __webpack_require__(984);









__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_2__progress_kendo_datasource_vue_wrapper__["KendoDataSourceInstaller"]);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1__progress_kendo_grid_vue_wrapper__["KendoGridInstaller"]);

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'StatisticsGrid',
  props: ['name', 'gridHeight', 'schemaModelFields', 'schemaModelId', 'url', 'columns', 'preload', 'sortable', 'pageable', 'filterable', 'query', 'details', 'aggregateDefinition', 'rows', 'groupDefinition'],
  components: {
    KendoGrid: __WEBPACK_IMPORTED_MODULE_1__progress_kendo_grid_vue_wrapper__["KendoGrid"],
    KendoDataSource: __WEBPACK_IMPORTED_MODULE_2__progress_kendo_datasource_vue_wrapper__["KendoDataSource"],
    Detail: __WEBPACK_IMPORTED_MODULE_3__views_Sellin_Detail_vue__["a" /* default */]
  },
  data: function data() {
    return {
      preloadDone: false,
      gridTransport: this.getTransport(),
      schemaTotal: this.getTotal,
      options: {
        dataSource: {
          page: 1,
          sort: null,
          filter: null
        }
      }
    };
  },

  methods: {
    dataSourceLoaded: function dataSourceLoaded(e) {
      this.$emit('ds-loaded', e);
    },
    dataSourceLoadError: function dataSourceLoadError(e) {
      this.$emit('ds-error', e);
    },
    queryFromDetail: function queryFromDetail() {
      console.log('hey, aquery from a detail!');
    },

    detailInit: function detailInit(e) {
      var that = this;
      var ComponentClass = __WEBPACK_IMPORTED_MODULE_0_vue__["default"].extend(__WEBPACK_IMPORTED_MODULE_3__views_Sellin_Detail_vue__["a" /* default */]);
      var instance = new ComponentClass({
        propsData: {
          query: this.query,
          rowData: e.data,
          details: this.details,
          masterRows: this.rows
        }
      });
      instance.$mount();
      instance.$on('filter-detail', function (evt) {
        that.$emit('filter-detail', evt);
      });
      e.detailCell.append(instance.$el);
    },
    setQuery: function setQuery() {
      var _this = this;

      this.axios.post('queries', this.query).then(function (response) {
        _this.$router.push({
          name: 'statistics.query',
          params: {
            id: response.data.data.uuid
          }
        });
      });
    },
    getTransport: function getTransport() {
      var v = this;
      return {
        read: {
          url: v.axios.defaults.baseURL + this.url,
          type: 'POST',
          data: this.query,
          beforeSend: function beforeSend(req) {
            console.log(req);
            req.setRequestHeader('Authorization', 'Bearer ' + v.$auth.token());
          }
        }
      };
    },
    refresh: function refresh() {
      this.$refs.mygrid.kendoWidget().dataSource.read();
    },
    getTotal: function getTotal(response) {
      return response.meta.pagination.total;
    },
    setColumnsData: function setColumnsData(data, field) {
      for (var i = 0; i < this.columns.length; i++) {
        if (this.columns[i].field === field) {
          this.columns[i].values = data;
        }
      }
    }
  },
  created: function created() {
    var _this2 = this;

    var that = this;
    var apiPreloads = [];
    if (typeof this.preload !== 'undefined' && this.preload != null && this.preload.length > 0) {
      for (var i = 0; i < this.preload.length; i++) {
        apiPreloads.push(this.preload[i].api);
      }
      this.axios.all(apiPreloads.map(function (l) {
        return _this2.axios.get(l);
      })).then(that.axios.spread(function () {
        for (var i = 0; i < that.preload.length; i++) {
          that.setColumnsData(arguments[i].data.data, that.preload[i].field);
        }
        that.preloadDone = true;
      })).catch(function (response) {
        console.error('error loading foreigns', response);
      });
    } else {
      that.preloadDone = true;
    }
  }
});

/***/ }),
/* 984 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Detail_vue__ = __webpack_require__(985);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1624edb5_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_Detail_vue__ = __webpack_require__(986);
var normalizeComponent = __webpack_require__(4)
/* script */

/* template */

/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Detail_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1624edb5_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_Detail_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 985 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(198);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__progress_kendo_ui_js_kendo_all_js__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__progress_kendo_ui_js_kendo_all_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__progress_kendo_ui_js_kendo_all_js__);




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'Detail',
  props: ['query', 'rowData', 'details', 'masterRows'],
  data: function data() {
    return {
      preload: [],
      schemaModelFields: {},
      url: 'sellin',
      columns: [],
      aggregateDefinition: [],
      loaded: false,
      tableInitialized: false,
      tables: []
    };
  },

  methods: {
    changedTab: function changedTab(a) {
      var _this = this;

      this.axios.post('sellin/columns', this.tables[a].query).then(function (response) {
        var data = response.data.data;
        _this.tables[a].columns = data.columns;
        _this.tables[a].aggregateDefinition = data.aggregates;
        _this.tables[a].schemaModelFields = data.fields;
        _this.tables[a].visible = true;
      });
    },
    seQueryFromRow: function seQueryFromRow(e) {
      e.preventDefault();
      var t = e.currentTarget;
      var q = __WEBPACK_IMPORTED_MODULE_1__progress_kendo_ui_js_kendo_all_js___default.a.jQuery(t).data('query');
      var gridref = __WEBPACK_IMPORTED_MODULE_1__progress_kendo_ui_js_kendo_all_js___default.a.jQuery(t).data('gridref');
      var field = __WEBPACK_IMPORTED_MODULE_1__progress_kendo_ui_js_kendo_all_js___default.a.jQuery(t).data('field');
      var grid = this.$refs[gridref][0].$refs.mygrid.kendoWidget();
      var row = __WEBPACK_IMPORTED_MODULE_1__progress_kendo_ui_js_kendo_all_js___default.a.jQuery(t).closest('tr');
      var dataItem = grid.dataItem(row);
      q.filters = this.addFilter(q.filters, field, dataItem[field]);
      console.log(q);
      this.$emit('filter-detail', {
        item: q
      });
    },
    addFilter: function addFilter(filters, field, value) {
      var found = false;
      for (var c = 0; c < filters.length; c++) {
        if (filters[c].field === field) {
          filters[c].includes = [{
            id: value,
            name: 'auto'
          }];
          found = true;
        }
      }
      if (!found) {
        filters.push({
          field: field,
          title: '',
          includes: [{
            id: value,
            name: 'auto'
          }],
          excludes: []
        });
      }
      return filters;
    }
  },
  created: function created() {
    var that = this;

    for (var i = 0; i < this.details.length; i++) {
      var d = this.details[i];
      for (var w = 0; w < d.subrows.length; w++) {
        var subs = d.subrows;

        var q = JSON.parse(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.query));
        var groupby = q.groupby;
        q.groupby = 'none';

        var id = this.rowData[this.query.subrows];

        q.filters = this.addFilter(q.filters, this.query.subrows, id);
        if (groupby !== 'none') {
          var groupById = this.rowData[groupby];
          q.filters = this.addFilter(q.filters, groupby, groupById);
        }

        q.rows = d.rows;
        q.subrows = subs[w];
        this.tables.push({
          visible: false,
          title: this.masterRows[q.rows].sub[q.subrows].text,
          details: this.masterRows[q.rows].sub[q.subrows].details,
          field: q.subrows,
          query: q
        });
      }
    }
    console.log('details', this.details);
    console.log('tables', this.tables);
    that.loaded = true;
  }
});

/***/ }),
/* 986 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"details"},[(_vm.loaded)?_c('b-card',{attrs:{"no-body":""}},[_c('b-tabs',{attrs:{"small":"","card":""},on:{"input":_vm.changedTab}},_vm._l((_vm.tables),function(detail){return _c('b-tab',{key:detail.field,attrs:{"title":detail.title}},[(detail.visible)?_c('statistics-grid',{ref:'statsGrid' + detail.query.subrows,refInFor:true,attrs:{"gridHeight":"400px","query":detail.query,"name":'detailGrid' + detail,"url":_vm.url,"columns":detail.columns,"pageable":true,"filterable":true,"sortable":true,"schemaModelFields":detail.schemaModelFields,"schemaModelId":'id',"aggregateDefinition":detail.aggregateDefinition,"rows":_vm.masterRows,"details":detail.details,"preload":_vm.preload}}):_vm._e(),_vm._v(" "),(!detail.visible)?_c('div',{staticClass:"splash"},[_c('div',{staticClass:"container  d-flex h-100"},[_c('div',{staticClass:"row justify-content-center text-primary w-100 align-self-center text-white"},[_c('i',{staticClass:"fa fa-spin fa-spinner"})])])]):_vm._e()],1)}),1)],1):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 987 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.preloadDone)?_c('div',[_c('kendo-datasource',{ref:"datasource1",attrs:{"transport":_vm.gridTransport,"schema-model-id":_vm.schemaModelId,"schema-model-fields":_vm.schemaModelFields,"schema-data":'data',"server-paging":false,"server-filtering":false,"server-sorting":false,"aggregate":_vm.aggregateDefinition,"group":_vm.groupDefinition,"page":_vm.options.dataSource.page},on:{"requestend":_vm.dataSourceLoaded,"error":_vm.dataSourceLoadError}}),_vm._v(" "),_c('kendo-grid',{ref:"mygrid",attrs:{"scrollable-virtual":true,"data-source-ref":'datasource1',"filterable":_vm.filterable,"sortable":_vm.sortable,"columns":_vm.columns,"scrollable":true},on:{"detailinit":_vm.detailInit,"filter-detail":_vm.queryFromDetail}})],1):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 988 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_GenericGrid_vue__ = __webpack_require__(989);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e94f1df2_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_GenericGrid_vue__ = __webpack_require__(993);
var normalizeComponent = __webpack_require__(4)
/* script */

/* template */

/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_GenericGrid_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e94f1df2_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_GenericGrid_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 989 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__progress_kendo_grid_vue_wrapper__ = __webpack_require__(74);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__progress_kendo_grid_vue_wrapper___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__progress_kendo_grid_vue_wrapper__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__progress_kendo_datasource_vue_wrapper__ = __webpack_require__(75);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__progress_kendo_datasource_vue_wrapper___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__progress_kendo_datasource_vue_wrapper__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_Detail_vue__ = __webpack_require__(990);









__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_2__progress_kendo_datasource_vue_wrapper__["KendoDataSourceInstaller"]);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1__progress_kendo_grid_vue_wrapper__["KendoGridInstaller"]);

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'AccountsGrid',
  props: ['name', 'gridHeight', 'schemaModelFields', 'schemaModelId', 'url', 'detailUrl', 'columns', 'preload', 'sortable', 'pageable', 'filterable', 'query', 'details', 'aggregateDefinition', 'rows', 'groupDefinition'],
  components: {
    KendoGrid: __WEBPACK_IMPORTED_MODULE_1__progress_kendo_grid_vue_wrapper__["KendoGrid"],
    KendoDataSource: __WEBPACK_IMPORTED_MODULE_2__progress_kendo_datasource_vue_wrapper__["KendoDataSource"],
    Detail: __WEBPACK_IMPORTED_MODULE_3__components_Detail_vue__["a" /* default */]
  },
  data: function data() {
    return {
      preloadDone: false,
      gridTransport: this.getTransport(),
      schemaTotal: this.getTotal,
      options: {
        dataSource: {
          page: 1,
          sort: null,
          filter: null
        }
      }
    };
  },

  methods: {
    dataSourceLoaded: function dataSourceLoaded(e) {
      this.$emit('ds-loaded', e);
    },
    dataSourceLoadError: function dataSourceLoadError(e) {
      this.$emit('ds-error', e);
    },
    queryFromDetail: function queryFromDetail() {
      console.log('hey, aquery from a detail!');
    },

    detailInit: function detailInit(e) {
      var that = this;
      var ComponentClass = __WEBPACK_IMPORTED_MODULE_0_vue__["default"].extend(__WEBPACK_IMPORTED_MODULE_3__components_Detail_vue__["a" /* default */]);
      var instance = new ComponentClass({
        propsData: {
          url: this.detailUrl,
          query: this.query,
          rowData: e.data,
          details: this.details,
          masterRows: this.rows
        }
      });
      instance.$mount();
      instance.$on('filter-detail', function (evt) {
        that.$emit('filter-detail', evt);
      });
      e.detailCell.append(instance.$el);
    },
    setQuery: function setQuery() {
      var _this = this;

      this.axios.post('queries', this.query).then(function (response) {
        _this.$router.push({
          name: 'statistics.query',
          params: {
            id: response.data.data.uuid
          }
        });
      });
    },
    getTransport: function getTransport() {
      var v = this;
      return {
        read: {
          url: v.axios.defaults.baseURL + this.url,
          type: 'POST',
          data: this.query,
          beforeSend: function beforeSend(req) {
            console.log(req);
            req.setRequestHeader('Authorization', 'Bearer ' + v.$auth.token());
          }
        }
      };
    },
    refresh: function refresh() {
      this.$refs.mygrid.kendoWidget().dataSource.read();
    },
    getTotal: function getTotal(response) {
      return response.meta.pagination.total;
    },
    setColumnsData: function setColumnsData(data, field) {
      for (var i = 0; i < this.columns.length; i++) {
        if (this.columns[i].field === field) {
          this.columns[i].values = data;
        }
      }
    }
  },
  created: function created() {
    var _this2 = this;

    var that = this;
    var apiPreloads = [];
    if (typeof this.preload !== 'undefined' && this.preload != null && this.preload.length > 0) {
      for (var i = 0; i < this.preload.length; i++) {
        apiPreloads.push(this.preload[i].api);
      }
      this.axios.all(apiPreloads.map(function (l) {
        return _this2.axios.get(l);
      })).then(that.axios.spread(function () {
        for (var i = 0; i < that.preload.length; i++) {
          that.setColumnsData(arguments[i].data.data, that.preload[i].field);
        }
        that.preloadDone = true;
      })).catch(function (response) {
        console.error('error loading foreigns', response);
      });
    } else {
      that.preloadDone = true;
    }
  }
});

/***/ }),
/* 990 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Detail_vue__ = __webpack_require__(991);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_12cb63f7_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_Detail_vue__ = __webpack_require__(992);
var normalizeComponent = __webpack_require__(4)
/* script */

/* template */

/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Detail_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_12cb63f7_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_Detail_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 991 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(198);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__progress_kendo_ui_js_kendo_all_js__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__progress_kendo_ui_js_kendo_all_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__progress_kendo_ui_js_kendo_all_js__);




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'Detail',
  props: ['query', 'rowData', 'details', 'masterRows', 'url'],
  data: function data() {
    return {
      preload: [],
      schemaModelFields: {},
      columns: [],
      aggregateDefinition: [],
      loaded: false,
      tableInitialized: false,
      tables: []
    };
  },

  methods: {
    changedTab: function changedTab(a) {
      var _this = this;

      this.axios.post(this.url + '/columns', this.tables[a].query).then(function (response) {
        var data = response.data.data;
        _this.tables[a].columns = data.columns;
        _this.tables[a].aggregateDefinition = data.aggregates;
        _this.tables[a].schemaModelFields = data.fields;
        _this.tables[a].visible = true;
      });
    },
    seQueryFromRow: function seQueryFromRow(e) {
      e.preventDefault();
      var t = e.currentTarget;
      var q = __WEBPACK_IMPORTED_MODULE_1__progress_kendo_ui_js_kendo_all_js___default.a.jQuery(t).data('query');
      var gridref = __WEBPACK_IMPORTED_MODULE_1__progress_kendo_ui_js_kendo_all_js___default.a.jQuery(t).data('gridref');
      var field = __WEBPACK_IMPORTED_MODULE_1__progress_kendo_ui_js_kendo_all_js___default.a.jQuery(t).data('field');
      var grid = this.$refs[gridref][0].$refs.mygrid.kendoWidget();
      var row = __WEBPACK_IMPORTED_MODULE_1__progress_kendo_ui_js_kendo_all_js___default.a.jQuery(t).closest('tr');
      var dataItem = grid.dataItem(row);
      q.filters = this.addFilter(q.filters, field, dataItem[field]);
      console.log(q);
      this.$emit('filter-detail', {
        item: q
      });
    },
    addFilter: function addFilter(filters, field, value) {
      var found = false;
      for (var c = 0; c < filters.length; c++) {
        if (filters[c].field === field) {
          filters[c].includes.push({
            id: value,
            name: 'auto'
          });
          found = true;
        }
      }
      if (!found) {
        filters.push({
          field: field,
          title: '',
          includes: [{
            id: value,
            name: 'auto'
          }],
          excludes: []
        });
      }
      return filters;
    }
  },
  created: function created() {
    var that = this;

    if (this.details) {
      for (var i = 0; i < this.details.length; i++) {
        var d = this.details[i];
        var q = JSON.parse(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.query));
        q.rows = d;
        var id = this.rowData[this.query.rows];
        q.filters = this.addFilter(q.filters, this.query.rows, id);

        this.tables.push({
          visible: false,
          title: this.masterRows[q.rows].text,
          details: this.masterRows[q.rows].details,
          field: q.rows,
          query: q
        });
      }
    }
    console.log('detail url:', this.url);
    console.log('details', this.details);
    console.log('tables', this.tables);
    that.loaded = true;
  }
});

/***/ }),
/* 992 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"details"},[(_vm.loaded)?_c('b-card',{attrs:{"no-body":""}},[_c('b-tabs',{attrs:{"small":"","card":""},on:{"input":_vm.changedTab}},_vm._l((_vm.tables),function(detail){return _c('b-tab',{key:detail.field,attrs:{"title":detail.title}},[(detail.visible)?_c('generic-grid',{ref:'statsGrid' + detail.query.subrows,refInFor:true,attrs:{"gridHeight":"400px","query":detail.query,"name":'detailGrid' + detail,"url":_vm.url,"columns":detail.columns,"pageable":true,"filterable":true,"sortable":true,"schemaModelFields":detail.schemaModelFields,"schemaModelId":'id',"aggregateDefinition":detail.aggregateDefinition,"rows":_vm.masterRows,"details":detail.details,"preload":_vm.preload,"detail-url":_vm.url}}):_vm._e(),_vm._v(" "),(!detail.visible)?_c('div',{staticClass:"splash"},[_c('div',{staticClass:"container  d-flex h-100"},[_c('div',{staticClass:"row justify-content-center text-primary w-100 align-self-center text-white"},[_c('i',{staticClass:"fa fa-spin fa-spinner"})])])]):_vm._e()],1)}),1)],1):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 993 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.preloadDone)?_c('div',[_c('kendo-datasource',{ref:"datasource1",attrs:{"transport":_vm.gridTransport,"schema-model-id":_vm.schemaModelId,"schema-model-fields":_vm.schemaModelFields,"schema-data":'data',"server-paging":false,"server-filtering":false,"server-sorting":false,"aggregate":_vm.aggregateDefinition,"group":_vm.groupDefinition,"page":_vm.options.dataSource.page},on:{"requestend":_vm.dataSourceLoaded,"error":_vm.dataSourceLoadError}}),_vm._v(" "),_c('kendo-grid',{ref:"mygrid",attrs:{"scrollable-virtual":true,"data-source-ref":'datasource1',"filterable":_vm.filterable,"sortable":_vm.sortable,"columns":_vm.columns,"scrollable":true},on:{"detailinit":_vm.detailInit,"filter-detail":_vm.queryFromDetail}})],1):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 994 */,
/* 995 */,
/* 996 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 997 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 998 */,
/* 999 */,
/* 1000 */
/***/ (function(module, exports) {

module.exports = {

  request: function request(req, token) {
    this.options.http._setHeaders.call(this, req, {
      Authorization: 'Bearer ' + token
    });
  },

  response: function response(res) {
    var headers = this.options.http._getHeaders.call(this, res);
    var token = headers.Authorization || headers.authorization;
    if (!token && typeof res.data.token !== 'undefined') {
      token = res.data.token;
      return token;
    }
    if (!token && typeof res.data.access_token !== 'undefined') {
      token = res.data.access_token;
      return token;
    }

    if (token) {
      token = token.split(/Bearer:?\s?/i);
      return token[token.length > 1 ? 1 : 0].trim();
    }
  }
};

/***/ })
],[547]);


// WEBPACK FOOTER //
// static/js/app.d87dee189046d0be5d14.js